{
  "% к прошлой неделе": "% նախորդ շաբաթվա համեմատ",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID-ն և ֆինանսական անդորրագրերը պահպանվում են։",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Պատրաստի ձայները հասանելի են «Հնչյունավորում» → «Իմը» բաժնում։",
  ". Он не меняет голос озвучки чата.": ". Այն չի փոխում չաթի հնչյունավորման ձայնը։",
  ". После подтверждения обновите профиль.": ". Հաստատելուց հետո թարմացրեք պրոֆիլը։",
  ". Проверьте папку «Спам».": ". Ստուգեք «Սպամ» պանակը։",
  "Circle каждый месяц по подписке": "Circle՝ ամսական բաժանորդագրությամբ",
  "Circle по подписке на этот месяц потрачены": "Այս ամսվա բաժանորդագրության Circle-ները ծախսված են",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Միացված չէ",
  "Telegram ID скопирован.": "Telegram ID-ն պատճենված է։",
  "{0} {1} C сгорят {2}": "{0} {1} C-ն կվառվի {2}-ին",
  "{0} из {1}": "{0}՝ {1}-ից",
  "{0} фото хватит для сходства": "{0} լուսանկարը բավարար է նմանության համար",
  "{0}: {1} работ": "{0}՝ {1} աշխատանք",
  "{0}: пока недоступно": "{0}՝ առայժմ անհասանելի է",
  "· Вы и варианты": "· Դուք և տարբերակները",
  "· Новое": "· Նորը",
  "· занято": "· զբաղված է",
  "· отменена": "· չեղարկված է",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Ուսուցումը կսկսվի քարտում «Կրկնել մշակումը» կոճակն առանձին սեղմելուց հետո։",
  "Автовоспроизведение примеров": "Նմուշների ավտոմատ նվագարկում",
  "Аккаунт": "Հաշիվ",
  "Аккаунт подключён": "Հաշիվը միացված է",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Արխիվն անհասանելի է կամ հղման ժամկետը լրացել է։ Կարող եք նոր արտահանում պահանջել։",
  "Бабушка": "Տատիկ",
  "Баланс и вывод доступны в STEOS ID.": "Մնացորդը և դուրսբերումը հասանելի են STEOS ID-ում։",
  "Баланс и награды": "Մնացորդ և պարգևներ",
  "Без имени": "Առանց անվան",
  "Бесплатный план": "Անվճար պլան",
  "Ближайшие": "Մոտակա",
  "Близкие": "Մտերիմներ",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Հարազատը կհեռացվի պրոֆիլից։ Նրա լուսանկարներն այլևս հասանելի չեն լինի նոր աշխատանքների համար։",
  "Близкий удалён.": "Հարազատը հեռացված է։",
  "Близких пока нет.": "Դեռ հարազատներ չկան։",
  "Брат": "Եղբայր",
  "В Steos с": "Steos-ում՝ սկսած",
  "В избранное": "Ավելացնել ընտրյալներին",
  "Валюта": "Արժույթ",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "Տարբերակը կհեռացվի։ Բնօրինակ լուսանկարներն ու STEOS ID-ն կպահպանվեն։",
  "Вариантов: {0}": "Տարբերակների քանակը՝ {0}",
  "Варианты": "Տարբերակներ",
  "Ваш собственный голос": "Ձեր սեփական ձայնը",
  "Введите УДАЛИТЬ": "Մուտքագրեք УДАЛИТЬ",
  "Введите пароль": "Մուտքագրեք գաղտնաբառը",
  "Введите почту": "Մուտքագրեք էլփոստը",
  "Вернуться ко входу": "Վերադառնալ մուտքի էջ",
  "Версия": "Տարբերակ",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Համաձայնության տարբերակը փոխվել է։ Թարմացրեք էջը և հաստատեք գործող տեքստը։",
  "Версия согласия изменилась. Обновите страницу.": "Համաձայնության տարբերակը փոխվել է։ Թարմացրեք էջը։",
  "Версия:": "Տարբերակ՝",
  "Взрослый": "Մեծահասակ",
  "Включаем микрофон…": "Միացնում ենք խոսափողը…",
  "Включено": "Միացված է",
  "Возраст": "Տարիք",
  "Войти": "Մուտք գործել",
  "Восстановить пароль": "Վերականգնել գաղտնաբառը",
  "Все Circle на балансе без срока": "Ձեր Circle-ները ժամկետ չունեն",
  "Вы": "Դուք",
  "Вы и близкие": "Դուք և հարազատները",
  "Вы и варианты": "Դուք և տարբերակները",
  "Выберите голос": "Ընտրեք ձայնը",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Ընտրեք գործիքը և լրացրեք դրա ձևը։ Պատրաստի աշխատանքը կպահպանվի պատմության մեջ։",
  "Выбран": "Ընտրված է",
  "Выбрать голос": "Ընտրել ձայնը",
  "Выбрать голос по умолчанию": "Ընտրել լռելյայն ձայնը",
  "Выбрать из работ": "Ընտրել աշխատանքներից",
  "Выгрузить мои данные": "Արտահանել իմ տվյալները",
  "Выгрузка:": "Արտահանում՝",
  "Выключено": "Անջատված է",
  "Голос": "Ձայն",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Ձայնը պատրաստ է։ Այն հասանելի է հնչյունավորման «Իմը» ներդիրում։",
  "Голос и клон": "Ձայն և կլոն",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Ձայնը փոխվել է։ Տվյալները թարմացվել են․ պահպանելուց առաջ ստուգեք դրանք։",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Ձայնը փոխվել է։ Կրկին մշակելուց առաջ ստուգեք թարմացված տվյալները։",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "Ձայնը կհեռացվի ձեր ցանկից։ Այս գործողությունը հնարավոր չէ չեղարկել։",
  "Голос по умолчанию для создания:": "Ստեղծման լռելյայն ձայնը՝",
  "Голос принят в обработку. Здесь появится его статус.": "Ձայնն ընդունվել է մշակման։ Դրա կարգավիճակն այստեղ կհայտնվի։",
  "Голос уже удалён или недоступен.": "Ձայնն արդեն հեռացված է կամ անհասանելի է։",
  "Голос:": "Ձայն՝",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Ձայներ չեն գտնվել։ Բացեք կատալոգը կամ փոխեք որոնումը։",
  "Горизонтальное": "Հորիզոնական",
  "Готов": "Պատրաստ է",
  "Готовим образцы": "Պատրաստում ենք նմուշները",
  "Готово": "Պատրաստ է",
  "Готовые работы": "Պատրաստ աշխատանքներ",
  "Далее": "Հաջորդը",
  "Данные Telegram обновлены.": "Telegram-ի տվյալները թարմացվել են։",
  "Данные баланса временно недоступны": "Մնացորդի տվյալները ժամանակավորապես անհասանելի են",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Տվյալները տեղափոխվում են հաստատված հաշիվ։ Հին աշխատաշրջանները փակվել են․ անդորրագիրը թույլ է տալիս շարունակել ստուգումը վերաբեռնումից հետո։",
  "Дедушка": "Պապիկ",
  "До 5 фото: лицо крупно, при хорошем свете": "Մինչև 5 լուսանկար՝ դեմքը մոտիկից, լավ լուսավորության պայմաններում",
  "До пяти фото. Они будут использоваться как ваш образ.": "Մինչև հինգ լուսանկար։ Դրանք կօգտագործվեն որպես ձեր կերպար։",
  "Добавить близкого": "Ավելացնել հարազատ",
  "Добавить фото": "Ավելացնել լուսանկար",
  "Добавьте ещё": "Ավելացրեք ևս",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "Ավելացրեք ձեր խոսքի 2 վայրկյանից մինչև 1,5 րոպե տևողությամբ ձայնագրություն։ Խոսեք բնական՝ առանց երաժշտության և այլ ձայների։",
  "Дочь": "Դուստր",
  "Друг": "Ընկեր",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Եթե հաշիվը գոյություն ունի, նոր գաղտնաբառի հղումն ուղարկվել է հետևյալ հասցեին՝",
  "Ещё варианты": "Եվս տարբերակներ",
  "Ещё операции": "Ավելի շատ գործարքներ",
  "Ещё работы": "Եվս աշխատանքներ",
  "Жена": "Կին",
  "ЗАМЕНА ОБРАЗЦОВ": "ՆՄՈՒՇՆԵՐԻ ՓՈԽԱՐԻՆՈՒՄ",
  "Забыли пароль?": "Մոռացե՞լ եք գաղտնաբառը։",
  "Загружаем аккаунт…": "Բեռնում ենք հաշիվը…",
  "Загружаем варианты…": "Բեռնում ենք տարբերակները…",
  "Загружаем ваши голоса…": "Բեռնում ենք ձեր ձայները…",
  "Загружаем голоса…": "Բեռնում ենք ձայները…",
  "Загружаем настройки…": "Բեռնում ենք կարգավորումները…",
  "Загружаем обновления…": "Բեռնում ենք թարմացումները…",
  "Загружаем операции…": "Բեռնում ենք գործողությունները…",
  "Загружаем пример…": "Բեռնում ենք նմուշը…",
  "Загружаем работы…": "Բեռնում ենք աշխատանքները…",
  "Загружаем фото…": "Բեռնում ենք լուսանկարները…",
  "Загрузить аудиофайлы": "Վերբեռնել աուդիոֆայլեր",
  "Загрузить выбранные фото": "Վերբեռնել ընտրված լուսանկարները",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Վերբեռնումը դեռ հաստատված չէ։ Սեղմեք «Շարունակել ուղարկումը»․ նախ կստուգենք նախորդ վերբեռնումը։",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Վերբեռնումը հաստատված չէ։ Շարունակելուց առաջ նախ կստուգվեն նախորդ վերբեռնումները։",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Վերբեռնումը մերժվել է։ Սեղմեք «Շարունակել ուղարկումը»՝ նոր հղում ստանալու և նմուշը վերբեռնելու համար։",
  "Закрыть": "Փակել",
  "Закрыть мастер": "Փակել օգնականը",
  "Заменить образцы": "Փոխարինել նմուշները",
  "Записать с микрофона": "Ձայնագրել խոսափողից",
  "Запись": "Ձայնագրություն",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Այստեղ ձայնագրությունն անհասանելի է։ Բացեք հավելվածը HTTPS-ով կամ վերբեռնեք աուդիոֆայլ։",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Ձայնագրությունն ընդհատվեց։ Փորձեք կրկին կամ վերբեռնեք ֆայլը։",
  "Запись-{0}.{1}": "Ձայնագրություն-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Ձայնագրեք նմուշը, սպասեք ուսուցման ավարտին և հնչյունավորեք տեքստը ձեր ձայնով։",
  "Запишите речь или загрузите аудиофайлы": "Ձայնագրեք խոսքը կամ վերբեռնեք աուդիոֆայլեր",
  "Запишите свой голос один раз — используйте его в озвучке.": "Մեկ անգամ ձայնագրեք ձեր ձայնը և օգտագործեք այն հնչյունավորման համար։",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Հարցումը պահպանված է։ Շարունակելիս կստուգվի նախորդ հարցումը, և երկրորդ ձայն չի ստեղծվի։",
  "Запустить обработку": "Սկսել մշակումը",
  "Здесь появятся ваши работы": "Ձեր աշխատանքներն այստեղ կհայտնվեն",
  "Из них": "Դրանցից",
  "Из них {0} C можно вывести": "Դրանցից {0} C-ն կարելի է դուրս բերել",
  "Избранное": "Ընտրյալներ",
  "Избранные работы": "Ընտրված աշխատանքներ",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Փոփոխությունը հաստատված չէ։ Կրկնելուց առաջ ստուգեք գործող քարտը։",
  "Изменить": "Փոփոխել",
  "Изменить близкого": "Փոփոխել հարազատին",
  "Изменить вариант": "Փոփոխել տարբերակը",
  "Изменить голос": "Փոփոխել ձայնը",
  "Изменить мои фото": "Փոփոխել իմ լուսանկարները",
  "Имя близкого": "Հարազատի անունը",
  "Имя голоса": "Ձայնի անունը",
  "Имя пользователя не задано": "Օգտանունը սահմանված չէ",
  "Использовать как себя": "Օգտագործել որպես ինձ",
  "Используем сохранённые образцы голоса «": "Օգտագործում ենք պահպանված ձայնի նմուշները «",
  "Используйте свои фото и фото близких в инструментах студии.": "Օգտագործեք ձեր և հարազատների լուսանկարները ստուդիայի գործիքներում։",
  "История очищена: {0} работ, {1} заказов.": "Պատմությունը մաքրված է․ {0} աշխատանք, {1} պատվեր։",
  "КЛОН ГОЛОСА": "ՁԱՅՆԻ ԿԼՈՆ",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Յուրաքանչյուր նմուշ պետք է պարունակի առնվազն մեկ վայրկյան խոսք։",
  "Как в системе": "Ինչպես համակարգում",
  "Как пользоваться": "Ինչպես օգտվել",
  "Как снимать": "Ինչպես լուսանկարել",
  "Каталог голосов": "Ձայների կատալոգ",
  "Квадрат": "Քառակուսի",
  "Кем приходится": "Հարաբերությունը",
  "Ко входу": "Դեպի մուտք",
  "Количество вариантов пока недоступно": "Տարբերակների քանակը դեռ անհասանելի է",
  "Конфиденциальность": "Գաղտնիություն",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Պատճենումն անհասանելի է։ ID-ն ցուցադրված է հաշվի քարտում։",
  "Кружок с героем": "Տեսահաղորդագրություն՝ հերոսով",
  "Лимит {0} голосов выбран": "Ընտրված է {0} ձայնի սահմանաչափը",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Ձայների սահմանաչափը լրացված է։ Նորը ավելացնելու համար հեռացրեք ավելորդ ձայնը։",
  "Лимит:": "Սահմանաչափ՝",
  "Мама": "Մայրիկ",
  "Можно добавить до {0} образцов.": "Կարելի է ավելացնել մինչև {0} նմուշ։",
  "Можно закрыть приложение. Статус обновится после обработки.": "Կարող եք փակել հավելվածը։ Կարգավիճակը կթարմացվի մշակումից հետո։",
  "Мои варианты": "Իմ տարբերակները",
  "Мои голоса": "Իմ ձայները",
  "Мои данные": "Իմ տվյալները",
  "Мои фото": "Իմ լուսանկարները",
  "Моё": "Իմը",
  "Моё фото": "Իմ լուսանկարը",
  "Муж": "Ամուսին",
  "НОВЫЙ ГОЛОС": "ՆՈՐ ՁԱՅՆ",
  "Награды": "Պարգևներ",
  "Награды и задания": "Պարգևներ և առաջադրանքներ",
  "Назад": "Հետ",
  "Название варианта": "Տարբերակի անվանումը",
  "Назначить голос": "Նշանակել ձայն",
  "Настройки": "Կարգավորումներ",
  "Настройки уже изменились. Показана актуальная версия.": "Կարգավորումներն արդեն փոխվել են։ Ցուցադրված է գործող տարբերակը։",
  "Начните с 2 секунд речи в тихом месте.": "Սկսեք 2 վայրկյան խոսքից՝ հանգիստ վայրում։",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Առավելագույնը 5 JPEG կամ PNG լուսանկար՝ յուրաքանչյուրը մինչև 10 ՄԲ։",
  "Не задано": "Սահմանված չէ",
  "Не короче 8 знаков": "Առնվազն 8 նիշ",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Չհաջողվեց միացնել խոսափողը։ Թույլատրեք մուտքը կամ վերբեռնեք ֆայլը։",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Չհաջողվեց մուտք գործել։ Կրկին բացեք հավելվածը Telegram-ից։",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Չհաջողվեց նվագարկել նմուշը։ Կրկին բացեք քարտը և փորձեք նորից։",
  "Не удалось загрузить варианты.": "Չհաջողվեց բեռնել տարբերակները։",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Չհաջողվեց բեռնել ձայները։ Փորձը կրկնելու համար փոխեք որոնումը կամ ներդիրը։",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Չհաջողվեց բեռնել կարգավորումները։ Փորձեք թարմացնել։",
  "Не удалось загрузить работы.": "Չհաջողվեց բեռնել աշխատանքները։",
  "Не удалось загрузить следующую страницу.": "Չհաջողվեց բեռնել հաջորդ էջը։",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Չհաջողվեց բեռնել հաջորդ էջը։ Փորձեք կրկին։",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Չհաջողվեց թարմացնել Telegram-ի տվյալները։ Փորձեք ավելի ուշ։",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Չհաջողվեց հաստատել ընտրյալների փոփոխությունը։ Թարմացրեք պրոֆիլը։",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Չհաջողվեց հաստատել գործողությունը։ Կրկնելուց առաջ ստուգեք հաշվի վիճակը։",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Չհաջողվեց հաստատել պահպանումը։ Կրկնելուց առաջ թարմացրեք կարգավորումները։",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Չհաջողվեց հաստատել հարազատի հեռացումը։ Թարմացրեք պրոֆիլը։",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Չհաջողվեց ստանալ պատասխան։ Փորձեք կրկին․ հարցումը կշարունակվի նույն բանալիով։",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Չհաջողվեց ստուգել արտահանումը։ Թարմացրեք էջը․ կշարունակենք նախորդ գործողությունը։",
  "Не удалось прочитать запись.": "Չհաջողվեց կարդալ ձայնագրությունը։",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Չհաջողվեց ստեղծել ձայն։ Բացեք քարտը՝ կարգավիճակը ստուգելու կամ մշակումը կրկնելու համար։",
  "Не удалось создать голос. Проверьте данные и образцы.": "Չհաջողվեց ստեղծել ձայն։ Ստուգեք տվյալներն ու նմուշները։",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Չհաջողվեց պահպանել դիտումը։ Կարող եք փակել և վերադառնալ ավելի ուշ։",
  "Неверная почта или пароль": "Սխալ էլփոստ կամ գաղտնաբառ",
  "Нет работ": "Աշխատանքներ չկան",
  "Новая выгрузка": "Նոր արտահանում",
  "Новости": "Նորություններ",
  "Новый вариант": "Նոր տարբերակ",
  "Новый голос": "Նոր ձայն",
  "Новых публикаций пока нет.": "Նոր հրապարակումներ դեռ չկան։",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Ընդհանուր առմամբ անհրաժեշտ է 2 վայրկյանից մինչև 1,5 րոպե խոսք։",
  "О приложении": "Հավելվածի մասին",
  "Обновить": "Թարմացնել",
  "Обновить варианты": "Թարմացնել տարբերակները",
  "Обновить из Telegram": "Թարմացնել Telegram-ից",
  "Обновить настройки": "Թարմացնել կարգավորումները",
  "Обновить профиль": "Թարմացնել պրոֆիլը",
  "Обновить работы": "Թարմացնել աշխատանքները",
  "Обновления": "Թարմացումներ",
  "Обновляем вход…": "Թարմացնում ենք մուտքը…",
  "Обрабатывается": "Մշակվում է",
  "Образ готов": "Կերպարը պատրաստ է",
  "Образ ещё не собран": "Կերպարը դեռ ստեղծված չէ",
  "Образец {0}": "Նմուշ {0}",
  "Образец голоса": "Ձայնի նմուշ",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Նմուշը դեռ ստուգված չէ։ Սպասեք և շարունակեք ուղարկումը։",
  "Образец не прошёл проверку. Выберите другую запись.": "Նմուշը չի անցել ստուգումը։ Ընտրեք մեկ այլ ձայնագրություն։",
  "Образцы готовы к повторной обработке.": "Նմուշները պատրաստ են կրկնակի մշակման։",
  "Образцы для «": "Նմուշներ՝ «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Նմուշները թարմացվել են։ Սեղմեք «Կրկնել մշակումը»՝ ձայնը կրկին ուսուցանելու համար։",
  "Обучаем голос": "Ուսուցանում ենք ձայնը",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Նմուշների ընդհանուր տևողությունը չպետք է գերազանցի 1,5 րոպեն։",
  "Объединение STEOS ID": "STEOS ID-ների միավորում",
  "Объединяем аккаунты": "Միավորում ենք հաշիվները",
  "Объём образцов": "Նմուշների ծավալը",
  "Один аккаунт для бота и сайта STEOS": "Մեկ հաշիվ՝ STEOS բոտի և կայքի համար",
  "Озвучить текст голосом «": "Հնչյունավորել տեքստը « ձայնով",
  "Операции": "Գործարքներ",
  "Операции в токенах STEOS ID": "Գործողություններ STEOS ID-ի թոքեններով",
  "Операции временно недоступны.": "Գործողությունները ժամանակավորապես անհասանելի են։",
  "Операций пока нет.": "Գործողություններ դեռ չկան։",
  "Операция не подтверждена. Повтор использует прежний ключ.": "Գործողությունը հաստատված չէ։ Կրկնակի փորձը կօգտագործի նույն բանալին։",
  "Описание": "Նկարագրություն",
  "Описание и согласие": "Նկարագրություն և համաձայնություն",
  "Остановить запись ·": "Դադարեցնել ձայնագրությունը ·",
  "Остаток Circle недоступен": "Circle-ի մնացորդն անհասանելի է",
  "Отклик": "Թրթռանք",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Բացեք նամակի հղումը և նոր գաղտնաբառ սահմանեք id.steos.io կայքում։ Այնուհետև մուտք գործեք այստեղ։",
  "Откройте ссылку подтверждения для": "Բացեք հաստատման հղումը հետևյալի համար՝",
  "Открыть id.steos.io": "Բացել id.steos.io",
  "Открыть историю": "Բացել պատմությունը",
  "Отмена": "Չեղարկել",
  "Отметьте согласие с условиями": "Նշեք համաձայնությունը պայմաններին",
  "Отправить ссылку": "Ուղարկել հղումը",
  "Отправляем…": "Ուղարկում ենք…",
  "Оформить подписку": "Բաժանորդագրվել",
  "Оформление": "Արտաքին տեսք",
  "Очистить историю": "Մաքրել պատմությունը",
  "Очистить историю?": "Մաքրե՞լ պատմությունը։",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Մաքրումը հաստատված չէ։ Կրկնակի փորձը կստուգի նախորդ գործողությունը։",
  "Очищаем…": "Մաքրում ենք…",
  "Ошибка": "Սխալ",
  "Папа": "Հայրիկ",
  "Пароль": "Գաղտնաբառ",
  "Переименовать вариант": "Վերանվանել տարբերակը",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Տեղափոխումը դեռ հաստատված չէ։ Անդորրագիրը պահպանված է․ ստուգումը կշարունակվի։",
  "Перенос завершён, обновляем вход…": "Տեղափոխումն ավարտված է, թարմացնում ենք մուտքը…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Տվյալները տեղափոխում ենք գոյություն ունեցող STEOS ID։ Տեղափոխումից հետո հավելվածը կթարմացնի աշխատաշրջանը։ Մի սկսեք միավորումը կրկին։",
  "Письмо отправлено": "Նամակն ուղարկված է",
  "Питомец": "Ընտանի կենդանի",
  "Повторить загрузку": "Կրկին փորձել բեռնել",
  "Повторить обработку": "Կրկնել մշակումը",
  "Подготовить ZIP для скачивания": "Պատրաստել ZIP-ը ներբեռնման համար",
  "Поддержка": "Աջակցություն",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "STEOS ID-ի միացումն այժմ անհասանելի է։ Փորձեք ավելի ուշ կամ բացեք STEOS ID կայքը։",
  "Подключён": "Միացված է",
  "Подключён:": "Միացված է՝",
  "Подруга": "Ընկերուհի",
  "Подтвердите почту": "Հաստատեք էլփոստը",
  "Подтвердите согласие перед отправкой образцов.": "Նմուշներն ուղարկելուց առաջ հաստատեք ձեր համաձայնությունը։",
  "Подтвердить очистку истории": "Հաստատել պատմության մաքրումը",
  "Подтвердить удаление": "Հաստատել հեռացումը",
  "Подтвердить удаление аккаунта": "Հաստատել հաշվի հեռացումը",
  "Подтвердить удаление близкого": "Հաստատել հարազատի հեռացումը",
  "Подтвердить удаление варианта": "Հաստատել տարբերակի հեռացումը",
  "Поиск голоса": "Որոնել ձայն",
  "Поиск по имени": "Որոնել անունով",
  "Пока нет своих голосов": "Դեռ սեփական ձայներ չկան",
  "Показать ещё": "Ցույց տալ ավելին",
  "Показать ещё голоса": "Ցույց տալ ավելի շատ ձայներ",
  "Показать пароль": "Ցույց տալ գաղտնաբառը",
  "Пополнить": "Լիցքավորել",
  "Попробовать": "Փորձել",
  "Портрет": "Դիմանկար",
  "Пост": "Գրառում",
  "Потрачено Circle:": "Ծախսված Circle՝",
  "Почта": "Էլփոստ",
  "Почта уже занята": "Էլփոստն արդեն զբաղված է",
  "Почта уже занята, войдите с ней": "Էլփոստն արդեն զբաղված է, մուտք գործեք դրանով",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Բարև։ Սա իմ ձայնի համար նախատեսված ձայնագրությունն է։ Ես խոսում եմ հանգիստ և սովորական տեմպով, ինչպես ընկերոջ հետ զրուցելիս։ Կպատմեմ, թե ինչպես անցավ օրս, ինչն ինձ ուրախացրեց և ինչ ծրագրեր ունեմ վաղվա համար։ Շարունակեք խոսել ձեր բառերով առնվազն երեսուն վայրկյան։",
  "Приглашайте друзей": "Հրավիրեք ընկերներին",
  "Пример голоса {0}": "Ձայնի նմուշ {0}",
  "Принимаю": "Ընդունում եմ",
  "Присылать готовые работы в чат": "Պատրաստի աշխատանքներն ուղարկել չաթ",
  "Проверен": "Ստուգված է",
  "Проверить выгрузку": "Ստուգել արտահանումը",
  "Проверить подтверждение": "Ստուգել հաստատումը",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Ձայնի ստուգումը չի անցել։ Ձայնագրեք նմուշն առանց երաժշտության և այլ մարդկանց ձայների։",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Նմուշների ստուգումը չի անցել։ Փորձեք մեկ ձայնի մաքուր ձայնագրություն։",
  "Проверьте адрес": "Ստուգեք հասցեն",
  "Проверяем запись": "Ստուգում ենք ձայնագրությունը",
  "Проверяем образец {0} из {1}…": "Ստուգում ենք {1}-ից {0} նմուշը…",
  "Проверяем состояние переноса…": "Ստուգում ենք տեղափոխման վիճակը…",
  "Проверяем…": "Ստուգում ենք…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Ստուգեք մնացորդը պրոֆիլում և ստացեք հասանելի պարգևները։",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Կշարունակենք նախորդ հարցման ստուգումը՝ առանց այն կրկին գործարկելու։",
  "Продолжим сохранённый запрос с теми же данными.": "Կշարունակենք պահպանված հարցումը նույն տվյալներով։",
  "Продолжить отправку": "Շարունակել ուղարկումը",
  "Продолжить проверку": "Շարունակել ստուգումը",
  "Продолжить создание голоса": "Շարունակել ձայնի ստեղծումը",
  "Продолжить сохранение": "Շարունակել պահպանումը",
  "Прослушать {0}": "Լսել {0}",
  "Профиль": "Պրոֆիլ",
  "Профиль «Вы» пока недоступен.": "«Դուք» պրոֆիլն առայժմ անհասանելի է։",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Պրոֆիլն արդեն փոխվել է։ Փակեք ձևը և բացեք գործող տարբերակը։",
  "Работ в этом списке пока нет.": "Այս ցանկում դեռ աշխատանքներ չկան։",
  "Работа №": "Աշխատանք №",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Աշխատանքներն ու պատվերների կարգավորումները կհեռացվեն պատմությունից։ Ձայները, «Դուք» տարբերակները և հարազատները կմնան։ Ֆինանսական անդորրագրերը կպահպանվեն։ Պատմությունը վերականգնել հնարավոր չէ։",
  "Работы по неделям": "Աշխատանքներն ըստ շաբաթների",
  "Раздел профиля": "Պրոֆիլի բաժին",
  "Разделы профиля": "Պրոֆիլի բաժիններ",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Յուրաքանչյուր նմուշի չափը պետք է լինի 1 բայթից մինչև 20 ՄԲ։",
  "Ребёнок": "Երեխա",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Մշակման արդյունքը դեռ ճշտվում է։ Կրկին գործարկելն առայժմ անհասանելի է։",
  "Русский": "Русский",
  "С": "Սկսած",
  "Сбросить голос по умолчанию": "Վերակայել լռելյայն ձայնը",
  "Светлая": "Բաց գույնի",
  "Свой аватар": "Սեփական ավատար",
  "Сгорят {0}, если не потратить": "Կայրվեն {0}, եթե չծախսեք",
  "Сделать кружок": "Ստեղծել տեսահաղորդագրություն",
  "Серия:": "Շարք՝",
  "Сестра": "Քույր",
  "Скачать ZIP": "Ներբեռնել ZIP",
  "Скопировать Telegram ID": "Պատճենել Telegram ID-ն",
  "Скорость речи": "Խոսքի արագություն",
  "Скрыть пароль": "Թաքցնել գաղտնաբառը",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Հարցումները չափազանց շատ են։ Մի փոքր սպասեք և փորձեք կրկին։",
  "Слишком много попыток. Попробуйте позже.": "Փորձերը չափազանց շատ են։ Փորձեք ավելի ուշ։",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Լուսանկարեք դեմքն առանց զտիչների և մուգ ակնոցների՝ հավասարաչափ լուսավորության պայմաններում։ Ավելացրեք տարբեր անկյուններից լուսանկարներ։ Կադրում պետք է լինի միայն մեկ մարդ։",
  "Снять голос": "Ձայնագրել ձայնը",
  "Снять фото": "Լուսանկարել",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Համաձայնությունը փոխվել է մինչև ուսուցման սկիզբը։ Թարմացրեք էջը և կրկնակի մշակումից առաջ հաստատեք գործող տարբերակը։",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Ստեղծեք խոսող շրջանիկներ՝ ընտրված կերպարով կամ ձեր սեփական կերպարով։",
  "Создание": "Ստեղծում",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Ձայների ստեղծումը ժամանակավորապես անհասանելի է։ Նմուշները պահպանված են այս պատուհանում։",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Նոր ձայների ստեղծումն առայժմ անհասանելի է։ Արդեն ստեղծված ձայները հասանելի են ստորև։",
  "Создано:": "Ստեղծվել է՝",
  "Создан {0}": "Ստեղծվել է {0}",
  "Создать аккаунт": "Ստեղծել հաշիվ",
  "Создать голос": "Ստեղծել ձայն",
  "Создаём голос…": "Ստեղծում ենք ձայնը…",
  "Сохранение настроек создания сейчас выключено.": "Ստեղծման կարգավորումների պահպանումն այժմ անջատված է։",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Պահպանումը հաստատված չէ։ Փակեք ձևը և ստուգեք գործող պրոֆիլը։",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Պահպանումը հաստատված չէ։ Ստեղծումը կրկնելիս կօգտագործվի նախորդ հարցումը։",
  "Сохранение недоступно.": "Պահպանումն անհասանելի է։",
  "Сохранено": "Պահպանված է",
  "Сохранить": "Պահպանել",
  "Сохранить близкого": "Պահպանել հարազատին",
  "Сохранить вариант": "Պահպանել տարբերակը",
  "Сохранить голос по умолчанию": "Պահպանել լռելյայն ձայնը",
  "Сохранить мои фото": "Պահպանել իմ լուսանկարները",
  "Сохранить образцы": "Պահպանել նմուշները",
  "Сохраняем образцы…": "Պահպանում ենք նմուշները…",
  "Сохраняем…": "Պահպանում ենք…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Ձեր պահպանված տարբերակները հասանելի են պրոֆիլում և ստեղծման գործիքներում։",
  "Сохранённых вариантов пока нет.": "Պահպանված տարբերակներ դեռ չկան։",
  "Сроки партий Circle временно недоступны": "Circle խմբաքանակների ժամկետները ժամանակավորապես անհասանելի են",
  "Старший": "Ավագ",
  "Статистика": "Վիճակագրություն",
  "Статистика по неделям временно недоступна.": "Շաբաթական վիճակագրությունը ժամանակավորապես անհասանելի է։",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Հեռացման կարգավիճակը ժամանակավորապես անհասանելի է։ Անդորրագիրը պահպանված է այս ներդիրում։",
  "Сторис": "Սթորիներ",
  "Сын": "Որդի",
  "Тариф": "Սակագնային փաթեթ",
  "Текст для чтения": "Ընթերցվող տեքստ",
  "Тема": "Թեմա",
  "Тема сохраняется на этом устройстве.": "Թեման պահպանվում է այս սարքում։",
  "Тёмная": "Մուգ",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Ես իրավունք ունեմ օգտագործելու այս լուսանկարները և ունեմ դրանցում պատկերված մարդկանց համաձայնությունը։",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Հեռացնում ենք աղմուկը",
  "Убрать": "Հեռացնել",
  "Убрать {0}": "Հեռացնել {0}",
  "Убрать из избранного": "Հեռացնել ընտրյալներից",
  "Убрать фоновый шум": "Հեռացնել ֆոնային աղմուկը",
  "Убрать фото": "Հեռացնել լուսանկարը",
  "Уведомления": "Ծանուցումներ",
  "Уведомления недоступны.": "Ծանուցումներն անհասանելի են։",
  "Уведомления пока недоступны.": "Ծանուցումները դեռ անհասանելի են։",
  "Удаление аккаунта Mini App": "Mini App-ի հաշվի հեռացում",
  "Удаление:": "Հեռացում՝",
  "Удалить": "Հեռացնել",
  "Удалить «": "Հեռացնել «",
  "Удалить «{0}»?": "Հեռացնե՞լ «{0}»-ը։",
  "Удалить аккаунт Mini App": "Հեռացնել Mini App-ի հաշիվը",
  "Удалить близкого": "Հեռացնել հարազատին",
  "Удалить вариант": "Հեռացնել տարբերակը",
  "Удалить голос": "Հեռացնել ձայնը",
  "Удаляем…": "Հեռացնում ենք…",
  "Удаляется": "Հեռացվում է",
  "Українська": "Українська",
  "Условия использования": "Օգտագործման պայմաններ",
  "Файл": "Ֆայլ",
  "Формат": "Ձևաչափ",
  "Фото Telegram": "Telegram-ի լուսանկար",
  "Фото {0}": "Լուսանկար {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Լուսանկարն ու անունը վերցվում են ձեր Telegram պրոֆիլից։ Եթե դրանք փոխել եք, թարմացրեք տվյալներն այստեղ։",
  "Фото и фотосессия": "Լուսանկար և ֆոտոսեսիա",
  "Фото перед загрузкой": "Լուսանկարները վերբեռնելուց առաջ",
  "Фото профиля": "Պրոֆիլի լուսանկար",
  "Фото профиля Telegram": "Telegram-ի պրոֆիլի լուսանկար",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Լուսանկարները, ձայները, հարազատները և Mini App-ի տվյալները կհեռացվեն բոլոր ծառայություններից։ STEOS ID-ն և ֆինանսական անդորրագրերը կմնան։ Հեռացումը հնարավոր չէ չեղարկել։",
  "Фото:": "Լուսանկար՝",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Պրոֆիլի մի մասը ժամանակավորապես անհասանելի է։ Փորձեք թարմացնել։",
  "Читаем аудиофайлы…": "Կարդում ենք աուդիոֆայլերը…",
  "Что нового": "Ինչ նորություն կա",
  "Что нового пока не опубликовано или временно недоступно.": "Նորությունները դեռ հրապարակված չեն կամ ժամանակավորապես անհասանելի են։",
  "Что нового пока не опубликовано.": "Նորությունները դեռ հրապարակված չեն։",
  "Шаблоны": "Ձևանմուշներ",
  "Шаблоны и рилс": "Կաղապարներ և ռիլսեր",
  "Эта неделя": "Այս շաբաթ",
  "Этот голос используется:": "Այս ձայնն օգտագործվում է՝",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Այս գործարկումը դեռ հնարավոր չէ կրկնել։ Թարմացրեք ձայնի կարգավիճակը։",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Այս ձևաչափը չի աջակցվում։ Ընտրեք MP3, WAV, M4A, OGG կամ WebM։",
  "Язык аккаунта": "Հաշվի լեզու",
  "готова": "պատրաստ է",
  "готова частично": "մասամբ պատրաստ է",
  "дата недоступна": "ամսաթիվն անհասանելի է",
  "для переозвучки": "վերահնչյունավորման համար",
  "до {0}, потом {1}": "մինչև {0}, ապա՝ {1}",
  "другой тариф": "այլ սակագնային փաթեթ",
  "закончится {0}": "կավարտվի {0}-ին",
  "и": "և",
  "из": "-ից",
  "из 1:30 · минимум 0:02": "1:30-ից · նվազագույնը՝ 0:02",
  "лимит уточняется": "սահմանաչափը ճշտվում է",
  "не задан": "սահմանված չէ",
  "не назначен": "նշանակված չէ",
  "новых": "նոր",
  "образец": "նմուշ",
  "образца": "նմուշի",
  "образцов": "նմուշներ",
  "оплачено до {0}": "վճարված է մինչև {0}",
  "подарок до {0}": "նվեր՝ մինչև {0}",
  "пока недоступно": "առայժմ անհասանելի է",
  "политику конфиденциальности STEOS": "STEOS-ի գաղտնիության քաղաքականությունը",
  "продлится {0}": "կերկարաձգվի {0}",
  "речи.": "խոսք։",
  "токенов": "թոքեն",
  "условия": "պայմաններ",
  "уточняется": "ճշտվում է",
  "Қазақша": "Қазақша",
  "← Профиль": "← Պրոֆիլ",
  "▶ Прослушать": "▶ Լսել",
  "Озвучка": "Հնչյունավորում",
  "Клон": "Կլոն",
  "Студия": "Ստուդիա",
  "Баланс": "Մնացորդ",
  "История": "Պատմություն",
  "Ещё": "Ավելին",
  "Клонирование голоса": "Ձայնի կլոնավորում",
  "Партнёрство": "Գործընկերություն",
  "Добавить в чат": "Ավելացնել զրույցում",
  "Разделы": "Բաժիններ",
  "Главное меню": "Գլխավոր ընտրացանկ",
  "Выберите": "Ընտրել",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Միավորումից հետո բոլոր լուսանկարները պահպանվել են։ Կերպարը փոխելու համար թողեք մինչև հինգ լուսանկար։",
  "Абзацы": "Պարբերություններ",
  "Альбом": "Ալբոմ",
  "Аудио": "Աուդիո",
  "Без изменения": "Առանց փոփոխության",
  "Бесплатно по текущему тестовому dev-тарифу.": "Անվճար՝ ընթացիկ փորձնական dev սակագնով։",
  "Бесплатно по тестовому dev-тарифу": "Անվճար՝ փորձնական dev սակագնով",
  "В избранном пока пусто": "Ընտրյալներում դեռ ոչինչ չկա",
  "В очереди": "Հերթում",
  "Вариант {0}": "Տարբերակ {0}",
  "Введите текст до 1000 символов": "Մուտքագրեք մինչև 1000 նիշ",
  "Вернули": "Վերադարձվել է",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Գրառումը պատմություն վերադարձնել հնարավոր չի լինի։ Ֆայլը կմնա չաթում։",
  "Видео": "Տեսանյութ",
  "Виды работ": "Աշխատանքների տեսակները",
  "Все": "Բոլորը",
  "Вчера": "Երեկ",
  "Выбранный вариант": "Ընտրված տարբերակը",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Ընտրված տարբերակն անհասանելի է։ Վերադարձեք պրոֆիլ և թարմացրեք ցանկը։",
  "Выполняется": "Ընթացքում է",
  "Высота голоса": "Ձայնի բարձրություն",
  "Говорящее видео": "Խոսող տեսանյութ",
  "Голоса": "Ձայներ",
  "Дата неизвестна": "Ամսաթիվն անհայտ է",
  "Длительность": "Տևողություն",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Այս գործողության համար դեռ հրապարակված հասանելի գործիք չկա։",
  "Дополнительное поле": "Լրացուցիչ դաշտ",
  "Заголовок": "Վերնագիր",
  "Загружаем историю…": "Բեռնում ենք պատմությունը…",
  "Загружаем работу…": "Բեռնում ենք աշխատանքը…",
  "Загружаем результат…": "Բեռնում ենք արդյունքը…",
  "Загружаем…": "Բեռնում ենք…",
  "Загружено": "Բեռնված է",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Բեռնումը հաստատված չէ։ Շարունակեք այս ֆայլի ստուգումը։",
  "Заказ": "Պատվեր",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Պատվերը հաստատված չէ։ Շարունակելիս նույն բանալով կստուգվի նախորդ հարցումը։",
  "Заменить файл": "Փոխարինել ֆայլը",
  "Избранное: {0}": "Ընտրյալներ՝ {0}",
  "Инструмент обновляется. Обновите форму позже.": "Գործիքը թարմացվում է։ Ավելի ուշ թարմացրեք ձևը։",
  "Искать в {0} работах": "Որոնել {0} աշխատանքներում",
  "Искать в истории": "Որոնել պատմության մեջ",
  "Использовать фото выбранного варианта": "Օգտագործել ընտրված տարբերակի լուսանկարը",
  "Используется выбранный голос.": "Օգտագործվում է ընտրված ձայնը։",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Ստեղծման արդյունքը ճշտվում է։ Նոր աշխատանքն ինքնաբերաբար չի գործարկվի։",
  "К инструментам": "Անցնել գործիքներին",
  "Кавер": "Քավեր",
  "Карусель": "Կարուսել",
  "Ключевые слова": "Հիմնաբառեր",
  "Коллаж": "Կոլաժ",
  "Кратко": "Հակիրճ",
  "Кружки": "Տեսահաղորդագրություններ",
  "Кружок": "Տեսահաղորդագրություն",
  "Кто в кадре": "Ով է կադրում",
  "Название": "Անվանում",
  "Не получилось": "Չհաջողվեց",
  "Не удалось выполнить": "Չհաջողվեց կատարել",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Չհաջողվեց կատարել գործողությունն այս աշխատանքի հետ։ Թարմացրեք այն և փորձեք կրկին։",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Չհաջողվեց ավարտել ստեղծումը։ Փորձեք փոխել կարգավորումները։",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Չհաջողվեց բեռնել պատմությունը։ Փորձեք կրկին։",
  "Не удалось загрузить студию.": "Չհաջողվեց բեռնել ստուդիան։",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Չհաջողվեց բեռնել տարբերակի լուսանկարը։ Թարմացրեք պրոֆիլը։",
  "Не удалось обработать запись": "Չհաջողվեց մշակել ձայնագրությունը",
  "Не удалось озвучить текст": "Չհաջողվեց հնչյունավորել տեքստը",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Չհաջողվեց բացել գործիքը։ Փորձեք թարմացնել։",
  "Не удалось открыть результат. Попробуйте снова.": "Չհաջողվեց բացել արդյունքը։ Փորձեք կրկին։",
  "Не удалось отправить результат. Повторите отправку.": "Չհաջողվեց ուղարկել արդյունքը։ Կրկնեք ուղարկումը։",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Չհաջողվեց կապ հաստատել ծառայության հետ։ Փորձեք կրկին։",
  "Не удалось скопировать. Выделите текст вручную.": "Չհաջողվեց պատճենել։ Ընտրեք տեքստը ձեռքով։",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Չհաջողվեց պահպանել ուղարկումը։ Թույլատրեք ներդիրի պահոցը և փորձեք կրկին։",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Կրկնության որոշ ֆայլեր այլևս հասանելի չեն։ Վերբեռնեք դրանք կրկին։",
  "Ничего не нашли": "Ոչինչ չգտնվեց",
  "Нужно разных фото": "Անհրաժեշտ են տարբեր լուսանկարներ",
  "Обрабатываем запись": "Մշակում ենք ձայնագրությունը",
  "Озвучиваем текст": "Հնչյունավորում ենք տեքստը",
  "Озвучить": "Հնչյունավորել",
  "Озвучка готова": "Հնչյունավորումն ավարտված է",
  "Озвучка проекта": "Նախագծի հնչյունավորում",
  "Оплата": "Վճարում",
  "Оплачено донатом": "Վճարված է նվիրատվությամբ",
  "Определить автоматически": "Որոշել ինքնաբերաբար",
  "Основа": "Հիմք",
  "Открыть результат": "Բացել արդյունքը",
  "Отменено": "Չեղարկված",
  "Отправить в чат": "Ուղարկել չաթ",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Ուղարկումը չի ընդունվել։ Ստուգեք սխալի հաղորդագրությունը։",
  "Отправка принята. Бот доставит результат в чат.": "Ուղարկումն ընդունվել է։ Բոտը արդյունքը կհասցնի չաթ։",
  "Отправлено": "Ուղարկված է",
  "Переозвучить запись": "Կրկին հնչյունավորել ձայնագրությունը",
  "Переозвучка": "Կրկնակի հնչյունավորում",
  "Персонаж": "Կերպար",
  "Площадка": "Հարթակ",
  "Повтори движения": "Կրկնիր շարժումները",
  "Повторить": "Կրկնել",
  "Подпись": "Ենթագիր",
  "Подтверждаю право использовать загружаемые материалы": "Հաստատում եմ վերբեռնվող նյութերն օգտագործելու իրավունքը",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Հաստատում եմ այս լուսանկարներն օգտագործելու իրավունքը և պատկերված մարդկանց համաձայնությունը՝ տարբերակ ստեղծելու համար",
  "Поиск в истории": "Որոնում պատմության մեջ",
  "Показатели истории": "Պատմության ցուցանիշներ",
  "Показатели истории временно недоступны": "Պատմության ցուցանիշները ժամանակավորապես անհասանելի են",
  "Показать все работы": "Ցույց տալ բոլոր աշխատանքները",
  "Показать текст": "Ցույց տալ տեքստը",
  "Порядок": "Դասավորություն",
  "Почистить запись": "Մաքրել ձայնագրությունը",
  "Прежний голос недоступен. Выберите другой голос.": "Նախորդ ձայնն անհասանելի է։ Ընտրեք այլ ձայն։",
  "Преимущества": "Առավելություններ",
  "Проверьте заполненные поля. Заказ не создан.": "Ստուգեք լրացված դաշտերը։ Պատվերը չի ստեղծվել։",
  "Проверяем итог операции": "Ստուգում ենք գործողության արդյունքը",
  "Проверяем отправку…": "Ստուգում ենք ուղարկումը…",
  "Проверяем результат": "Ստուգում ենք արդյունքը",
  "Проверяем списание токенов": "Ստուգում ենք թոքենների գանձումը",
  "Продолжить проверку озвучки": "Շարունակել հնչյունավորման ստուգումը",
  "Работ пока нет": "Դեռ աշխատանքներ չկան",
  "Работ: {0}": "Աշխատանքներ՝ {0}",
  "Работа": "Աշխատանք",
  "Работа больше не найдена. Обновите историю.": "Աշխատանքն այլևս չի գտնվել։ Թարմացրեք պատմությունը։",
  "Работа из истории": "Աշխատանք պատմությունից",
  "Работа не прошла проверку.": "Աշխատանքը չի անցել ստուգումը։",
  "Работа обновилась. Загрузите её ещё раз.": "Աշխատանքը թարմացվել է։ Վերբեռնեք այն կրկին։",
  "Распознавание": "Ճանաչում",
  "Распознанный текст": "Ճանաչված տեքստ",
  "Распознать речь": "Ճանաչել խոսքը",
  "Расшифровка": "Տառադարձում",
  "Режим озвучки": "Հնչյունավորման ռեժիմ",
  "Результат": "Արդյունք",
  "Результат больше недоступен": "Արդյունքն այլևս անհասանելի է",
  "Результат операции уточняется. Повторный запуск отключён.": "Գործողության արդյունքը ճշտվում է։ Կրկնակի գործարկումն անջատված է։",
  "Результат отправки пока неизвестен. Повторите проверку.": "Ուղարկման արդյունքը դեռ անհայտ է։ Կրկնեք ստուգումը։",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Ուղարկման արդյունքը դեռ անհայտ է։ Կրկնեք նույն բանալիով։",
  "Результат переозвучки": "Կրկնակի հնչյունավորման արդյունք",
  "Результат работы": "Աշխատանքի արդյունք",
  "Реплики": "Խոսքեր",
  "Речевая запись": "Խոսքի ձայնագրություն",
  "Рилс": "Ռիլս",
  "Сегодня": "Այսօր",
  "Сейчас создаётся": "Ստեղծվում է հիմա",
  "Сервис сейчас недоступен.": "Ծառայությունն այս պահին անհասանելի է։",
  "Сессия истекла. Откройте приложение заново.": "Նիստի ժամկետը լրացել է։ Բացեք հավելվածը կրկին։",
  "Синтез": "Սինթեզ",
  "Скачать": "Ներբեռնել",
  "Скачать все файлы": "Ներբեռնել բոլոր ֆայլերը",
  "Скачать набор": "Ներբեռնել փաթեթը",
  "Скопировано": "Պատճենված է",
  "Скопировать": "Պատճենել",
  "Слайды": "Սլայդներ",
  "Слишком много запросов. Подождите немного.": "Չափազանց շատ հարցումներ։ Մի փոքր սպասեք։",
  "Слушать результат": "Լսել արդյունքը",
  "Смена голоса": "Ձայնի փոփոխություն",
  "Сначала новые": "Սկզբում՝ նորերը",
  "Сначала старые": "Սկզբում՝ հները",
  "Создать": "Ստեղծել",
  "Создаётся": "Ստեղծվում է",
  "Списано": "Գանձված է",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Կարգավիճակը դեռ հաստատված չէ։ Ստուգում ենք նախորդ պատվերը։",
  "Статус текущих заказов временно недоступен": "Ընթացիկ պատվերների կարգավիճակը ժամանակավորապես անհասանելի է",
  "Стиль": "Ոճ",
  "Стоимость": "Արժեք",
  "Сцена": "Տեսարան",
  "Съёмка": "Նկարահանում",
  "Текст": "Տեքստ",
  "Текст для озвучки": "Հնչյունավորման տեքստ",
  "Текст песни": "Երգի բառեր",
  "Текст поста": "Գրառման տեքստ",
  "Товар": "Ապրանք",
  "Удалить из истории": "Ջնջել պատմությունից",
  "Удалить из истории?": "Ջնջե՞լ պատմությունից",
  "Уточняем результат": "Ճշտում ենք արդյունքը",
  "Уточняем состояние сохранённого заказа…": "Ճշտում ենք պահպանված պատվերի կարգավիճակը…",
  "Файл в чате останется": "Ֆայլը կմնա չաթում",
  "Файлов: {0}": "Ֆայլեր՝ {0}",
  "Форма недоступна.": "Ձևն անհասանելի է։",
  "Формат отправки": "Ուղարկման ձևաչափ",
  "Фото": "Լուսանկար",
  "Фотосессии": "Ֆոտոսեսիաներ",
  "Фотосессия": "Ֆոտոսեսիա",
  "Фотосессия товара": "Ապրանքի ֆոտոսեսիա",
  "Части": "Մասեր",
  "Шаблон": "Կաղապար",
  "Эта работа недоступна вашему аккаунту.": "Այս աշխատանքը հասանելի չէ ձեր հաշվի համար։",
  "Это вся история": "Սա ամբողջ պատմությունն է",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Այս գործիքն այժմ անհասանելի է։ Փորձեք թարմացնել ձևը։",
  "Язык записи": "Ձայնագրության լեզու",
  "MP3 · пауза между репликами 0,6 с": "MP3 · դադար խոսքերի միջև՝ 0,6 վրկ",
  "{0} / 1 000 знаков": "{0} / 1 000 նիշ",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 նիշ · տարբերակ {1}",
  "{0} реплик": "{0} խոսք",
  "{0} ролей · {1} новых реплик": "{0} դեր · {1} նոր խոսք",
  "Аудио больше недоступно. Обновите статус проекта.": "Աուդիոն այլևս հասանելի չէ։ Թարմացրեք նախագծի կարգավիճակը։",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Բուֆերն անհասանելի է։ Տեղադրեք տեքստը դաշտում ձեռքով։",
  "В проекте должно быть от 1 до 50 ролей.": "Նախագծում պետք է լինի 1-ից 50 դեր։",
  "В проекте может быть не больше 500 реплик.": "Նախագծում չի կարող լինել 500-ից ավելի խոսք։",
  "Вставить из буфера": "Տեղադրել բուֆերից",
  "Вставить сценарий": "Տեղադրել սցենարը",
  "Выберите голос для каждой непустой роли.": "Ընտրեք ձայն յուրաքանչյուր ոչ դատարկ դերի համար։",
  "Выше": "Վերև",
  "Голос {0}": "Ձայն {0}",
  "Голос роли": "Դերի ձայնը",
  "Готовим аудио…": "Պատրաստում ենք աուդիոն…",
  "Добавить {0} реплик": "Ավելացնել {0} խոսք",
  "Добавьте реплику или вставьте сценарий.": "Ավելացրեք խոսք կամ տեղադրեք սցենարը։",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Սպասեք ընդհանուր ֆայլի բեռնմանը և կրկին փորձեք։",
  "Дублировать": "Կրկնօրինակել",
  "Загружаем аудио…": "Բեռնում ենք աուդիոն…",
  "Загружаем проекты…": "Բեռնում ենք նախագծերը…",
  "Загрузить версию сервера": "Բեռնել սերվերի տարբերակը",
  "Закрыть раздел без сохранения изменений?": "Փակե՞լ բաժինն առանց փոփոխությունները պահպանելու։",
  "Заменить текущие роли и реплики?": "Փոխարինե՞լ ընթացիկ դերերն ու խոսքերը։",
  "Заменить текущий сценарий": "Փոխարինել ընթացիկ սցենարը",
  "Изменить сценарий": "Փոփոխել սցենարը",
  "Имя роли": "Դերի անունը",
  "Кто говорит": "Ով է խոսում",
  "Мои проекты": "Իմ նախագծերը",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Սեղմեք նվագարկման կոճակը նվագարկիչում՝ ձայնը միացնելու համար։",
  "Название проекта": "Նախագծի անվանումը",
  "Название слишком длинное.": "Անվանումը չափազանց երկար է։",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Չհաջողվեց վերականգնել գործողությունները։ Կրկին մի գործարկեք ձայնավորումը․ ստուգեք պատմությունը։",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Չհաջողվեց կատարել գործողությունը։ Փոփոխությունները մնում են էկրանին։",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Չհաջողվեց բեռնել աուդիոն։ Ստուգեք կապը և կրկին փորձեք։",
  "Не удалось озвучить проект": "Չհաջողվեց ձայնավորել նախագիծը",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Չհաջողվեց պատրաստել աուդիոն։ Ստուգեք խոսքը և ընտրված ձայնը։",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Չհաջողվեց ստուգել նախագծի սեփականատիրոջը։ Թարմացրեք էջը։",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Չհաջողվեց կապ հաստատել սերվերի հետ։ Ստուգեք կապը և կրկին փորձեք։",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Circle-ի միջոցները չեն բավարարում։ Լիցքավորեք հաշիվը և կրկին փորձեք։",
  "Ниже": "Ներքև",
  "Новый дубль реплики": "Խոսքի նոր կրկնօրինակ",
  "Общий файл · MP3": "Ընդհանուր ֆայլ · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Ձայներից մեկն այլևս հասանելի չէ։ Ընտրեք այլ ձայն։",
  "Озвучено реплик: {0} из {1}": "Ձայնավորված խոսքեր՝ {0}՝ {1}-ից",
  "Озвучиваем проект": "Ձայնավորում ենք նախագիծը",
  "Озвучить · {0} Circle": "Ձայնավորել · {0} Circle",
  "Озвучить проект": "Ձայնավորել նախագիծը",
  "Озвучка проектов": "Նախագծերի հնչյունավորում",
  "Озвучка уже выполняется. Дождитесь результата.": "Ձայնավորումն արդեն ընթանում է։ Սպասեք արդյունքին։",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "Գործողությունն արդեն ընդունվել է, կամ դրա արդյունքն անհայտ է։ Ստուգեք նախորդ հարցումը։",
  "Отбросить локальные изменения и загрузить версию сервера?": "Մերժե՞լ տեղային փոփոխությունները և բեռնել սերվերի տարբերակը։",
  "Открыть в истории": "Բացել պատմության մեջ",
  "Отменить изменения": "Չեղարկել փոփոխությունները",
  "Отменить несохранённые изменения?": "Չեղարկե՞լ չպահպանված փոփոխությունները։",
  "Перед озвучкой дождитесь сохранения изменений.": "Ձայնավորումից առաջ սպասեք փոփոխությունների պահպանմանը։",
  "Переозвучить": "Կրկին ձայնավորել",
  "Переозвучить реплику": "Կրկին ձայնավորել խոսքը",
  "Повторить проверку": "Կրկնել ստուգումը",
  "Подтвердить и запустить": "Հաստատել և գործարկել",
  "Подтверждение озвучки": "Ձայնավորման հաստատում",
  "Проверить прежний запрос": "Ստուգել նախորդ հարցումը",
  "Проверить статус": "Ստուգել կարգավիճակը",
  "Проверьте роли, голоса и длину реплик.": "Ստուգեք դերերը, ձայներն ու խոսքերի երկարությունը։",
  "Проект больше недоступен.": "Նախագիծն այլևս հասանելի չէ։",
  "Проект длиннее 20 000 знаков.": "Նախագիծը գերազանցում է 20 000 նիշը։",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Նախագիծը փոխվել է մեկ այլ պատուհանում։ Համեմատեք ձեր տարբերակը և բեռնեք թարմացվածը։",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Նախագիծը փոխվել է։ Պահպանեք այն և կրկին ստուգեք գինը։",
  "Проект или результат больше недоступен.": "Նախագիծը կամ արդյունքն այլևս հասանելի չէ։",
  "Проект озвучен": "Նախագիծը ձայնավորվել է",
  "Проекты {0}": "Նախագծեր {0}",
  "Прослушать": "Լսել",
  "Прослушать реплику": "Լսել խոսքը",
  "Прослушать текущую версию": "Լսել ընթացիկ տարբերակը",
  "Прослушивание в очереди": "Լսումը հերթում է",
  "Прослушивание реплики": "Խոսքի լսում",
  "Результат изменился. Загрузите его актуальную версию.": "Արդյունքը փոխվել է։ Բեռնեք դրա արդիական տարբերակը։",
  "Результат озвучки проекта": "Նախագծի ձայնավորման արդյունքը",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Արդյունքը դեռ ճշտվում է։ Նոր գեներացումն ինքնաբերաբար չի մեկնարկի։",
  "Реплика {0}": "Խոսք {0}",
  "Реплика длиннее 1 000 знаков.": "Խոսքը գերազանցում է 1 000 նիշը։",
  "Реплики · {0}": "Խոսքեր · {0}",
  "Реплику {0} выше": "Խոսք {0}-ը տեղափոխել վերև",
  "Реплику {0} ниже": "Խոսք {0}-ը տեղափոխել ներքև",
  "Роли и голоса": "Դերեր և ձայներ",
  "Роль {0}": "Դեր {0}",
  "Роль реплики": "Խոսքի դերը",
  "Скачать MP3": "Ներբեռնել MP3",
  "Слишком много запросов. Подождите и повторите проверку.": "Չափազանց շատ հարցումներ։ Սպասեք և կրկին փորձեք ստուգումը։",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Ստեղծեք նախագիծ, ապա տեղադրեք սցենարը կամ ավելացրեք դերեր և խոսքեր։",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Արժեքը հաստատվել է սերվերի կողմից։ Նույն հարցումը կրկին ստուգելը նոր գանձում չի առաջացնում։",
  "Стоимость: {0} Circle": "Արժեքը՝ {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "«Անուն․ խոսք» տողերը կդառնան դերեր և խոսքեր։ Ժամային նշումները կարելի է թողնել։",
  "Сценарий": "Սցենար",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Սցենարը փոխվել է։ Այս աուդիոուղին պատկանում է նախագծի նախորդ տարբերակին։",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Դերերով սցենար․ յուրաքանչյուր դեր խոսում է իր ձայնով։",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Տեքստը կամ ձայնը փոխվել է։ Ընթացիկ տարբերակի համար անհրաժեշտ է նոր լսում։",
  "Текст реплики": "Խոսքի տեքստը",
  "Удалить проект": "Ջնջել նախագիծը",
  "Удалить реплику {0}": "Ջնջել {0} խոսքը",
  "Удалить реплику?": "Ջնջե՞լ խոսքը։",
  "Удалить роль {0}": "Ջնջել {0} դերը",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "Ջնջե՞լ «{0}» դերը՝ իր խոսքերի հետ միասին ({1})։",
  "Удалить этот проект?": "Ջնջե՞լ այս նախագիծը։",
  "Укажите имя каждой роли.": "Նշեք յուրաքանչյուր դերի անունը։",
  "Уточняем результат озвучки": "Ճշտում ենք ձայնավորման արդյունքը",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Գինը փոխվել է։ Գործարկելուց առաջ ստուգեք նոր գինը։",
  "есть несохранённые изменения": "կան չպահպանված փոփոխություններ",
  "сохранено": "պահպանված է",
  "＋ Новый проект": "＋ Նոր նախագիծ",
  "＋ Реплика": "＋ Խոսք",
  "＋ Роль": "＋ Դեր",
  "Circle из пакетов без срока действия.": "Առանց գործողության ժամկետի Circle փաթեթներ։",
  "Circle каждый месяц": "Circle ամեն ամիս",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle-ը տրամադրվում է յուրաքանչյուր {0} օրը մեկ, առաջին փաթեթը՝ անմիջապես։",
  "Circle этой партии действуют до {0}": "Այս փաթեթի Circle-ները գործում են մինչև {0}",
  "{0} Circle каждый месяц": "Ամեն ամիս {0} Circle",
  "{0} Circle каждый месяц · до {1} своих голосов": "Ամեն ամիս {0} Circle · մինչև {1} սեփական ձայն",
  "{0} мес.": "{0} ամս․",
  "Баланс и профиль": "Մնացորդ և պրոֆիլ",
  "В текущем месяце осталось {0} из {1} Circle": "Ընթացիկ ամսում մնացել է {0} Circle՝ {1}-ից",
  "Ваш текущий тариф": "Ձեր ընթացիկ սակագնային պլանը",
  "Включить тестовое продление": "Միացնել փորձնական երկարաձգումը",
  "Выбор тарифа": "Ընտրել սակագնային պլանը",
  "Действует до {0}": "Գործում է մինչև {0}",
  "Для этой подписки продление пока недоступно.": "Այս բաժանորդագրության երկարաձգումը դեռ հասանելի չէ։",
  "До {0} своих голосов": "Մինչև {0} սեփական ձայն",
  "До {0} сохраняется текущий тариф.": "Մինչև {0} կպահպանվի ընթացիկ սակագնային պլանը։",
  "Докупить Circle": "Գնել լրացուցիչ Circle",
  "Доступные сроки": "Հասանելի ժամկետներ",
  "Загружаем подписку…": "Բաժանորդագրությունը բեռնվում է…",
  "Запланировать переход": "Պլանավորել անցումը",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "Հարցումը չի համապատասխանում պահպանված գործողությանը։ Մի՛ կրկնեք գնումը․ դիմեք աջակցման ծառայությանը։",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Նախորդ հարցման արդյունքը պետք է ստուգել։ Նոր գնումն առայժմ արգելափակված է։",
  "Начислить {0} тестовых Circle": "Ավելացնել {0} փորձնական Circle",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Չհաջողվեց վերականգնել գործողությունը։ Նոր գնումից առաջ ստուգեք բաժանորդագրությունը։",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Գործողությունը հաստատված է։ Թարմացրեք տվյալները․ գնումը կրկնելու կարիք չկա։",
  "Оставить текущий тариф": "Պահպանել ընթացիկ սակագնային պլանը",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Երկարաձգումը չեղարկելու դեպքում սակագնային պլանն ու սահմանաչափերը կպահպանվեն մինչև վճարված ժամկետի ավարտը։",
  "Отменить продление": "Չեղարկել երկարաձգումը",
  "Оформить dev-подписку": "Ակտիվացնել dev-բաժանորդագրությունը",
  "Пакет Circle начислен.": "Circle փաթեթը տրամադրվել է։",
  "Пакеты Circle доступны с активной подпиской.": "Circle փաթեթները հասանելի են ակտիվ բաժանորդագրության դեպքում։",
  "Перейти на выбранный тариф": "Անցնել ընտրված սակագնային պլանին",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Անցումը կսկսվի ընթացիկ բաժանորդագրության ավարտից հետո։ Այժմ վճարում չի պահանջվում։",
  "Подписка": "Բաժանորդագրություն",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Բաժանորդագրությունը ժամանակավորապես անհասանելի է։ Փորձեք թարմացնել տվյալները։",
  "Подписка не продлится": "Բաժանորդագրությունը չի երկարաձգվի",
  "Подписка обновлена.": "Բաժանորդագրությունը թարմացվել է։",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Բաժանորդագրությունն արդեն ակտիվ է։ Թարմացրեք տվյալները և ընտրեք հասանելի գործողությունը։",
  "Подписка уже закончилась. Обновите данные.": "Բաժանորդագրությունն արդեն ավարտվել է։ Թարմացրեք տվյալները։",
  "Подтвердить": "Հաստատել",
  "Подтверждение подписки": "Բաժանորդագրության հաստատում",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Գնումն այժմ անհասանելի է։ Իրական վճարումները միացված չեն։",
  "Получить dev-пакет бесплатно": "Ստանալ անվճար dev-փաթեթ",
  "Потом: {0}": "Ավելի ուշ՝ {0}",
  "Предыдущая подписка закончилась {0}": "Նախորդ բաժանորդագրությունն ավարտվել է {0}",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Վճարված ժամկետը երկարաձգելիս նոր փաթեթը կտրամադրվի հաջորդ ժամանակահատվածում։",
  "Проверка операции": "Գործողության ստուգում",
  "Продление включено": "Երկարաձգումը միացված է",
  "Продлить подписку": "Երկարաձգել բաժանորդագրությունը",
  "Свои голоса": "Սեփական ձայներ",
  "Свои голоса: {0} из {1}": "Սեփական ձայներ՝ {0}՝ {1}-ից",
  "Сравнить тарифы": "Համեմատել սակագնային պլանները",
  "Срок": "Ժամկետ",
  "Срок подписки": "Բաժանորդագրության ժամկետ",
  "Срок: {0} мес.": "Ժամկետ՝ {0} ամս․",
  "Тариф останется до конца срока. Следующего продления не будет.": "Սակագնային պլանը կպահպանվի մինչև ժամկետի ավարտը։ Հաջորդ երկարաձգումը չի կատարվի։",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Սակագնային պլաններն առայժմ անհասանելի են։ Փորձեք ավելի ուշ թարմացնել տվյալները։",
  "Текущий тариф": "Ընթացիկ սակագնային պլան",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Փորձնական dev-կատալոգ։ Իրական վճարումներ չկան․ տրամադրվում են փորձնական Circle-ներ։",
  "Управление подпиской": "Բաժանորդագրության կառավարում",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Սակագնային պլանի պայմանները փոխվել են։ Հաստատելուց առաջ թարմացրեք տվյալները։",
  "Что входит": "Ինչ է ներառված",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Սա անվճար dev-գործողություն է։ Գումար և Telegram Stars չեն գանձվում։",
  "Этот переход между тарифами недоступен.": "Սակագնային պլանների միջև այս անցումը հասանելի չէ։",
  "Этот тариф больше недоступен. Обновите список.": "Այս սակագնային պլանն այլևս հասանելի չէ։ Թարմացրեք ցանկը։",
  "QR-код": "QR կոդ",
  "QR-код приглашения": "Հրավերի QR կոդ",
  "{0} из {1} · {2} Circle": "{0}՝ {1}-ից · {2} Circle",
  "Виды заданий": "Առաջադրանքների տեսակները",
  "Выполнение этого задания пока недоступно.": "Այս առաջադրանքը դեռ հասանելի չէ։",
  "Готовим материал…": "Պատրաստում ենք նյութը…",
  "Действие подтверждено. Обновляем задания.": "Գործողությունը հաստատված է։ Թարմացնում ենք առաջադրանքները։",
  "День {0}": "{0}-րդ օրը",
  "День {0} из {1}": "{0}-րդ օրը՝ {1}-ից",
  "Дней подряд: {0}": "Անընդմեջ օրեր՝ {0}",
  "Друзья": "Ընկերներ",
  "Ежедневная серия": "Ամենօրյա շարք",
  "Ежедневные": "Ամենօրյա",
  "Есть награды": "Կան պարգևներ",
  "Забрать {0} Circle": "Ստանալ {0} Circle",
  "Загружаем награды…": "Բեռնում ենք պարգևները…",
  "Задание ещё не выполнено. Обновите прогресс.": "Առաջադրանքը դեռ կատարված չէ։ Թարմացրեք առաջընթացը։",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "Առաջադրանքը հաշվում է սթորի հրապարակելու պատուհանի բացումը։ Telegram-ը չի հաստատում հրապարակումը։",
  "Заданий в этой группе пока нет.": "Այս խմբում դեռ առաջադրանքներ չկան։",
  "Задания дня": "Օրվա առաջադրանքները",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Մուտք գործեք ամեն օր։ Մեկ օր բաց թողնելու դեպքում շարքը սկսվում է նորից։",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Նախորդ հարցման արդյունքը պետք է ստուգել։ Նոր պարգևների հաշվեգրումը դեռ արգելափակված է։",
  "Копирование недоступно. Выделите текст вручную.": "Պատճենումը հասանելի չէ։ Ընտրեք տեքստը ձեռքով։",
  "Материал для сторис": "Նյութ սթորիի համար",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Պարգևը հաստատված է։ Թարմացրեք տվյալները․ կրկին հաշվեգրելու կարիք չկա։",
  "Награда получена": "Պարգևը ստացված է",
  "Награда получена. Завтра +{0} Circle": "Պարգևը ստացված է։ Վաղը՝ +{0} Circle",
  "Награда уже получена. Обновите данные.": "Պարգևն արդեն ստացված է։ Թարմացրեք տվյալները։",
  "Награды временно недоступны. Попробуйте обновить данные.": "Պարգևները ժամանակավորապես անհասանելի են։ Փորձեք թարմացնել տվյալները։",
  "Награды за друзей": "Պարգևներ ընկերների համար",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Պարգևները տրվում են Circle-ով․ դրանք կարելի է ծախսել STEOS-ում, բայց դուրս բերել հնարավոր չէ։",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Հաշվեգրումը հաստատված չէ։ Ստուգեք նախորդ հարցումը․ նոր պարգևը դեռ արգելափակված է։",
  "Начисления приостановлены.": "Հաշվեգրումները կասեցված են։",
  "Начислено {0} Circle": "Հաշվեգրվել է {0} Circle",
  "Начислено: {0} Circle": "Հաշվեգրվել է՝ {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Չհաջողվեց վերականգնել պարգևի հարցումը։ Ստուգեք մնացորդը և դիմեք աջակցման ծառայությանը։",
  "Не удалось загрузить QR-код.": "Չհաջողվեց բեռնել QR կոդը։",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Չհաջողվեց բացել սթորի ուղարկելու պատուհանը։ Պարգևը չի հաշվեգրվել։",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Չհաջողվեց պատրաստել սթորին։ Փորձեք կրկին։",
  "Новый день: {0}": "Նոր օր՝ {0}",
  "Обновить награды": "Թարմացնել պարգևները",
  "Обновятся: {0}": "Կթարմացվեն՝ {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Բացեք Mini App-ը Telegram-ում, որն աջակցում է սթորիներին։",
  "Открыть STEOS ID в профиле": "Բացել STEOS ID-ն պրոֆիլում",
  "Открыть сторис": "Բացել սթորին",
  "Отправить в сторис": "Ուղարկել սթորի",
  "Партнёрские данные временно недоступны.": "Գործընկերոջ տվյալները ժամանակավորապես անհասանելի են։",
  "Партнёрство · Статистика, материалы и вывод": "Գործընկերություն · Վիճակագրություն, նյութեր և դուրսբերում",
  "Первые шаги": "Առաջին քայլերը",
  "Перейти к заданию": "Անցնել առաջադրանքին",
  "Получить ежедневную награду": "Ստանալ ամենօրյա պարգևը",
  "Приглашено: {0} · Покупателей: {1}": "Հրավիրված է՝ {0} · Գնորդներ՝ {1}",
  "Прогресс задания": "Առաջադրանքի առաջընթացը",
  "Прогресс задания временно недоступен.": "Առաջադրանքի առաջընթացը ժամանակավորապես անհասանելի է։",
  "Промокод": "Պրոմոկոդ",
  "Разовые": "Միանվագ",
  "Скопировать приглашение": "Պատճենել հրավերը",
  "Скопировать промокод": "Պատճենել պրոմոկոդը",
  "Ссылка приглашения": "Հրավերի հղում",
  "Сторис в Telegram": "Սթորիներ Telegram-ում",
  "Челленджи недели": "Շաբաթվա մարտահրավերները",
  "Circle используются внутри STEOS": "Circle-ն օգտագործվում է STEOS-ում",
  "Telegram подтвердил отправку сообщения.": "Telegram-ը հաստատել է հաղորդագրության ուղարկումը։",
  "Без покупок": "Առանց գնումների",
  "В этом списке пока нет друзей.": "Այս ցանկում դեռ ընկերներ չկան։",
  "Возможен вывод по условиям программы": "Հնարավոր է դուրսբերում՝ ծրագրի պայմանների համաձայն",
  "Вопросы": "Հարցեր",
  "Всё время": "Ամբողջ ժամանակահատվածը",
  "Вы здесь": "Դուք այստեղ եք",
  "Выберите PDF, JPG или PNG.": "Ընտրեք PDF, JPG կամ PNG։",
  "Выберите плательщика": "Ընտրեք վճարողին",
  "Выбрать чат в Telegram": "Ընտրել Telegram-ի զրույցը",
  "Выбрать чат для отправки": "Ընտրել զրույց՝ ուղարկելու համար",
  "Вывод": "Դուրսբերում",
  "Вывод недоступен на текущем уровне.": "Դուրսբերումը հասանելի չէ ընթացիկ մակարդակում։",
  "Вывод сейчас недоступен.": "Դուրսբերումը ներկայում հասանելի չէ։",
  "Вывод средств": "Միջոցների դուրսբերում",
  "Выплачен": "Վճարված է",
  "Выставьте счёт на": "Հաշիվը դուրս գրել՝",
  "Для вывода войдите в STEOS ID.": "Դուրսբերման համար մուտք գործեք STEOS ID։",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Հաշվարկի համար անհրաժեշտ են հրապարակված մակարդակներն ու սակագները։",
  "До уровня «{0}»: ещё {1} покупателей": "«{0}» մակարդակին հասնելու համար՝ ևս {1} գնորդ",
  "Доступно к выводу": "Դուրսբերման համար հասանելի է",
  "Доступных шаблонов пока нет.": "Դեռ հասանելի ձևանմուշներ չկան։",
  "Доход": "Եկամուտ",
  "Если купят {0} друзей": "Եթե {0} ընկերներ գնեն",
  "Есть покупки": "Գնումներ կան",
  "За этот период начислений пока нет.": "Այս ժամանակահատվածի համար դեռ հաշվեգրումներ չկան։",
  "Загружаем QR-код…": "Բեռնում ենք QR կոդը…",
  "Загружаем друзей…": "Բեռնում ենք ընկերներին…",
  "Загружаем материалы…": "Բեռնում ենք նյութերը…",
  "Загружаем партнёрские данные…": "Բեռնում ենք գործընկերային տվյալները…",
  "Загрузите проверенный счёт на оплату.": "Վերբեռնեք ստուգված վճարման հաշիվը։",
  "Заказать материал в чат": "Պատվիրել նյութը զրույցում",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Հարցումն ընդունվել է։ Նյութի առաքումը զրույցում դեռ հաստատված չէ։",
  "Заявка принята. Статус выплаты появится в истории.": "Հայտն ընդունվել է։ Վճարման կարգավիճակը կհայտնվի պատմության մեջ։",
  "Заявок на вывод пока нет.": "Դուրսբերման հայտեր դեռ չկան։",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Վճարման տվյալների փոփոխությունն արգելափակված է մինչև այս հայտի արդյունքի ստացումը։",
  "Имя получателя": "Ստացողի անունը",
  "История выводов": "Դուրսբերումների պատմություն",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Հարցման արդյունքը պետք է ստուգել։ Նոր նյութը դեռ արգելափակված է։",
  "Как определяется уровень?": "Ինչպե՞ս է որոշվում մակարդակը։",
  "Как это работает": "Ինչպես է սա աշխատում",
  "Калькулятор станет доступен после публикации расчётной политики.": "Հաշվիչը հասանելի կդառնա հաշվարկման քաղաքականության հրապարակումից հետո։",
  "Количество друзей": "Ընկերների քանակը",
  "Материалы": "Նյութեր",
  "Материалы временно недоступны. Попробуйте обновить список.": "Նյութերը ժամանակավորապես անհասանելի են։ Փորձեք թարմացնել ցանկը։",
  "Материалы пока недоступны.": "Նյութերն առայժմ անհասանելի են։",
  "Месяц": "Ամիս",
  "Минимальная сумма": "Նվազագույն գումար",
  "На рассмотрении": "Դիտարկվում է",
  "Налоговый номер": "Հարկային համար",
  "Начисления за период": "Հաշվեգրումներ ժամանակահատվածի համար",
  "Начислено Circle": "Հաշվեգրվել է Circle",
  "Начислено за период: {0} Circle": "Հաշվեգրվել է ժամանակահատվածի համար՝ {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Չհաջողվեց անվտանգ պահպանել հայտը կամ ստուգել սեփականատիրոջը։ Ուղարկումը չի կատարվել։",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Չհաջողվեց վերականգնել ուղարկման գործընթացը։ Նոր հարցում կատարելուց առաջ դիմեք աջակցման ծառայությանը։",
  "Не удалось загрузить друзей.": "Չհաջողվեց բեռնել ընկերներին։",
  "Не удалось загрузить историю выводов.": "Չհաջողվեց բեռնել դուրսբերումների պատմությունը։",
  "Не удалось загрузить тарифы.": "Չհաջողվեց բեռնել սակագները։",
  "Не удалось открыть отправку в Telegram.": "Չհաջողվեց բացել Telegram-ում ուղարկման գործառույթը։",
  "Не удалось проверить владельца. Обновите страницу.": "Չհաջողվեց ստուգել սեփականատիրոջը։ Թարմացրեք էջը։",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Չհաջողվեց կարդալ պահպանված հայտը։ Նոր դուրսբերումն արգելափակված է։",
  "Не удалось сохранить состояние отправки.": "Չհաջողվեց պահպանել ուղարկման վիճակը։",
  "Неделя": "Շաբաթ",
  "Нет данных": "Տվյալներ չկան",
  "Новая заявка": "Նոր հայտ",
  "Новая заявка на вывод сейчас недоступна.": "Նոր դուրսբերման հայտը ներկայում հասանելի չէ։",
  "О программе": "Ծրագրի մասին",
  "Обзор": "Ակնարկ",
  "Обновите страницу или обратитесь в поддержку.": "Թարմացրեք էջը կամ դիմեք աջակցման ծառայությանը։",
  "Обновить историю выводов": "Թարմացնել դուրսբերումների պատմությունը",
  "Обновить материалы": "Թարմացնել նյութերը",
  "От {0} покупателей": "{0} գնորդից",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Պատասխան չի ստացվել։ Ստուգեք նույն հայտը․ դրա տվյալներն ու բանալին պահպանված են։",
  "Отклонён": "Մերժված է",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Բացեք Mini App-ը Telegram-ում, որն աջակցում է նյութերի ուղարկմանը։",
  "Открыть сторис в Telegram": "Բացել պատմությունը Telegram-ում",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Ուղարկումը հաստատված չէ։ Կրկնակի փորձը կստուգի նախորդ հարցումը՝ առանց նոր ուղարկման։",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Ուղարկումը չեղարկվել է։ Կարող եք կրկին բացել զրույցի ընտրությունը։",
  "Оценка дохода": "Եկամտի գնահատում",
  "Оценка за {0} месяцев: {1} Circle": "Գնահատում {0} ամսվա համար՝ {1} Circle",
  "Оценка за месяц: {0} Circle": "Ամսական գնահատում՝ {0} Circle",
  "Переходы": "Անցումներ",
  "Период обзора": "Ակնարկի ժամանակահատվածը",
  "Плательщик": "Վճարող",
  "Подать заявку на вывод": "Ներկայացնել դուրսբերման հայտ",
  "Подготовить QR-код": "Պատրաստել QR կոդը",
  "Подготовить другой материал": "Պատրաստել մեկ այլ նյութ",
  "Подготовить материал": "Պատրաստել նյութը",
  "Поделитесь своей ссылкой или промокодом.": "Կիսվեք ձեր հղմամբ կամ պրոմոկոդով։",
  "Поделиться": "Կիսվել",
  "Пока без покупок": "Առայժմ գնումներ չկան",
  "Пока недоступно": "Առայժմ անհասանելի է",
  "Покупатели": "Գնորդներ",
  "Покупки друзей учитывает сервер STEOS ID.": "Ընկերների գնումները հաշվառում է STEOS ID սերվերը։",
  "Полные условия программы": "Ծրագրի ամբողջական պայմանները",
  "Пользователь": "Օգտատեր",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "Փորձեք STEOS-ը՝ {0}\nՊրոմոկոդ՝ {1}",
  "Привязка до: {0}": "Կապակցումը գործում է մինչև՝ {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "Հրավիրված ընկերոջ կապակցումն ուժի մեջ է {0} ամիս։",
  "Приглашён: {0}": "Հրավիրվել է՝ {0}",
  "Проверить загрузку счёта": "Ստուգել հաշվի վերբեռնումը",
  "Проверить ту же заявку": "Ստուգել նույն հայտը",
  "Проверьте налоговый номер получателя.": "Ստուգեք ստացողի հարկային համարը։",
  "Проверьте реквизиты и счёт.": "Ստուգեք վճարման տվյալներն ու հաշիվը։",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Ստուգեք դուրսբերման գումարը․ այն պետք է լինի ամբողջ թիվ և թույլատրելի միջակայքում։",
  "Проверяем владельца…": "Ստուգում ենք սեփականատիրոջը…",
  "Проверяем заявку или счёт…": "Ստուգում ենք հայտը կամ հաշիվը…",
  "Процент и доступность вывода определяет опубликованная программа.": "Տոկոսը և դուրսբերման հասանելիությունը որոշվում են հրապարակված ծրագրով։",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Տոկոսները, ժամկետներն ու սահմանափակումները ներկայացված են սերվերի հրապարակված տվյալների հիման վրա։",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "Հաշվի ֆայլի չափը պետք է լինի 1 բայթից մինչև 10 ՄԲ։",
  "Регистрации": "Գրանցումներ",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Հաշվի վերբեռնման արդյունքն անհայտ է։ Ստուգեք վերբեռնումը՝ առանց ֆայլը կրկին ուղարկելու։",
  "Скачать PNG": "Ներբեռնել PNG",
  "Сколько действует привязка друга?": "Որքա՞ն ժամանակ է գործում ընկերոջ կապակցումը։",
  "Скопировать текст": "Պատճենել տեքստը",
  "Сохранена неподтверждённая заявка": "Պահպանվել է չհաստատված հայտ",
  "Срок рассмотрения, дней": "Դիտարկման ժամկետը՝ օրերով",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Հղումն ու պրոմոկոդը ավելացվում են սերվերի կողմից։ Ընտրեք հասանելի նյութը։",
  "Ссылка на полный документ условий пока не опубликована.": "Պայմանների ամբողջական փաստաթղթի հղումը դեռ հրապարակված չէ։",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Պատմությունը բացվել է Telegram-ում։ Հրապարակումը պետք է հաստատել խմբագրիչում։",
  "Сумма в Circle": "Գումարը Circle-ով",
  "Сумма меньше минимальной суммы вывода.": "Գումարը նվազագույն դուրսբերման գումարից փոքր է։",
  "Сумма превышает доступный остаток.": "Գումարը գերազանցում է հասանելի մնացորդը։",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Վճարման հաշիվ · PDF, JPG կամ PNG, մինչև 10 ՄԲ",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Հաշիվը չի վերբեռնվել կամ չի անցել ստուգումը։ Ընտրեք PDF, JPG կամ PNG ֆայլ՝ մինչև 10 ՄԲ չափով։",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "Հաշիվը դեռ հաստատված չէ։ Կրկնեք ստուգումը կամ ընտրեք մեկ այլ ֆայլ։",
  "Счёт проверен": "Հաշիվը ստուգված է",
  "Текст приглашения": "Հրավերի տեքստը",
  "Текст сообщения": "Հաղորդագրության տեքստը",
  "Тексты": "Տեքստեր",
  "Тестовая заявка": "Թեստային հայտ",
  "Тестовая программа dev. Реальные выплаты выключены.": "dev թեստային ծրագիր։ Իրական վճարումներն անջատված են։",
  "Тестовая программа: реальные выплаты отключены.": "Թեստային ծրագիր․ իրական վճարումներն անջատված են։",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "dev թեստային հաշվարկ։ Սա գնահատական է, հաշվեգրում չի կատարվում։",
  "Укажите имя получателя: до 200 символов.": "Նշեք ստացողի անունը՝ առավելագույնը 200 նիշ։",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Մակարդակը սերվերը որոշում է հաշվառված գնորդների թվով։ Տեսեք «Մակարդակներ» ներդիրը։",
  "Уровни": "Մակարդակներ",
  "Условия начислений пока не опубликованы.": "Հաշվեգրումների պայմանները դեռ հրապարակված չեն։",
  "Условия программы": "Ծրագրի պայմանները",
  "Учёт переходов по ссылке пока недоступен.": "Հղումով անցումների հաշվառումն առայժմ հասանելի չէ։",
  "Фильтр друзей": "Ընկերների զտիչ",
  "Что делать, если данные не обновились?": "Ի՞նչ անել, եթե տվյալները չեն թարմացվել։",
  "Шаги": "Քայլեր",
  "Баннер": "Բաներ",
  "QR-постер": "QR պաստառ",
  "{0} / 300 знаков": "{0} / 300 նիշ",
  "· до 20 МБ": "· մինչև 20 ՄԲ",
  "Агент готовит ответ…": "Գործակալը պատրաստում է պատասխանը…",
  "Аудиозапись": "Աուդիագրառում",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Անվճար է միայն dev-ում։ Մինչև 30 վայրկյան և 10 ՄԲ։ Ուղարկելուց առաջ կարող եք խմբագրել տեքստը։",
  "Ваш вопрос": "Ձեր հարցը",
  "Вопрос или название инструмента": "Հարց կամ գործիքի անվանում",
  "Вопросов: {0}": "Հարցեր՝ {0}",
  "Вопросы · {0}": "Հարցեր · {0}",
  "Восстанавливаем чат…": "Վերականգնում ենք զրույցը…",
  "Все сервисы работают": "Բոլոր ծառայություններն աշխատում են",
  "Выберите MP3, WAV или M4A до 20 МБ.": "Ընտրեք մինչև 20 ՄԲ չափի MP3, WAV կամ M4A ֆայլ։",
  "Выберите инструкцию к нужному инструменту или странице.": "Ընտրեք անհրաժեշտ գործիքի կամ էջի հրահանգը։",
  "Диктовать вопрос": "Թելադրել հարցը",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Թելադրումը հաստատված չէ։ Կրկին ստուգեք նախորդ հարցումը կամ վերբեռնումը։",
  "До": "Մինչև",
  "Ещё спрашивают": "Նաև հարցնում են",
  "Загружаем справку…": "Բեռնում ենք օգնության նյութերը…",
  "Загружаем статус…": "Բեռնում ենք կարգավիճակը…",
  "Закрыть чат": "Փակել զրույցը",
  "ИИ-агент поддержки": "Աջակցության AI գործակալ",
  "ИИ-агент сейчас недоступен.": "AI գործակալն այս պահին անհասանելի է։",
  "Инструкции": "Հրահանգներ",
  "Инструкции · {0}": "Հրահանգներ · {0}",
  "Инструкции пока не опубликованы.": "Հրահանգները դեռ հրապարակված չեն։",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Հարցման արդյունքը դեռ հայտնի չէ։ Նոր հարց չի ուղարկվում։",
  "Как пользоваться STEOS": "Ինչպես օգտվել STEOS-ից",
  "Кружки и говорящие видео": "Կլոր տեսանյութեր և խոսող տեսանյութեր",
  "Медленнее обычного": "Սովորականից դանդաղ",
  "Написать агенту": "Գրել գործակալին",
  "Начать": "Սկսել",
  "Начать новую диктовку": "Սկսել նոր թելադրումը",
  "Не помогло": "Չօգնեց",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Չհաջողվեց վերականգնել թելադրումը։ Նոր հարցման ուղարկումն արգելափակված է։",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Չհաջողվեց վերականգնել զրույցը։ Դիմեք աջակցությանը։",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Չհաջողվեց բեռնել աջակցության նյութերը։ Փորձեք կրկին։",
  "Не удалось загрузить статус сервисов.": "Չհաջողվեց բեռնել ծառայությունների կարգավիճակը։",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Չհաջողվեց հաստատել պատասխանը։ Կարող եք սկսել նոր զրույց կամ գրել աջակցությանը։",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Չհաջողվեց ստանալ պատասխանը։ Կրկին ստուգեք՝ առանց նոր հարց տալու։",
  "Не удалось проверить владельца чата. Повторите открытие.": "Չհաջողվեց ստուգել զրույցի սեփականատիրոջը։ Կրկին բացեք զրույցը։",
  "Не удалось сохранить новый чат.": "Չհաջողվեց պահպանել նոր զրույցը։",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Չհաջողվեց պահպանել գնահատականը։ Փորձեք կրկին։",
  "Недоступен": "Անհասանելի է",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Որոշ ծառայություններ սովորականից դանդաղ են աշխատում։ Բացել կարգավիճակը",
  "Нет подтверждённых данных": "Հաստատված տվյալներ չկան",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Ոչինչ չգտնվեց։ Փորձեք այլ բառեր կամ հարցրեք AI գործակալին։",
  "Новый чат": "Նոր զրույց",
  "Обзор приложения": "Հավելվածի ակնարկ",
  "Обновить справку": "Թարմացնել օգնության նյութերը",
  "Обновить статус": "Թարմացնել կարգավիճակը",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Հրապարակված ստուգում։ Ավտոմատ մոնիթորինգ չի հայտարարվում։",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Պատասխանը հաստատված չէ։ Ստուգեք նախորդ հարցումը կամ գրեք աջակցությանը։",
  "Отвечает по опубликованной справке STEOS": "Պատասխանում է STEOS-ի հրապարակված օգնության նյութերի հիման վրա",
  "Открыть инструкции": "Բացել հրահանգները",
  "Открыть инструкцию": "Բացել հրահանգը",
  "Открыть инструмент": "Բացել գործիքը",
  "Открыть ответ справки": "Բացել օգնության պատասխանը",
  "Открыть раздел": "Բացել բաժինը",
  "Отправить вопрос": "Ուղարկել հարցը",
  "Оценка ответа": "Պատասխանի գնահատականը",
  "Очистить поиск": "Մաքրել որոնումը",
  "Поиск по справке": "Որոնել օգնության նյութերում",
  "Полезно": "Օգտակար է",
  "Помощь": "Օգնություն",
  "Популярные вопросы": "Հանրաճանաչ հարցեր",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "Վերջին ստուգումը հնացած է։ Ընթացիկ վիճակն անհայտ է։",
  "Посмотреть короткий обзор": "Դիտել կարճ ակնարկը",
  "Предыдущая": "Նախորդ",
  "Проверено: {0}": "Ստուգվել է՝ {0}",
  "Проверить диктовку": "Ստուգել թելադրումը",
  "Пропустить": "Բաց թողնել",
  "Работает": "Աշխատում է",
  "Распознать вопрос": "Ճանաչել հարցը",
  "Распознаём вопрос…": "Ճանաչում ենք հարցը…",
  "Результаты поиска": "Որոնման արդյունքներ",
  "Следующая": "Հաջորդ",
  "Советы": "Խորհուրդներ",
  "Справка пока не опубликована.": "Օգնության նյութերը դեռ հրապարակված չեն։",
  "Спросите что угодно": "Հարցրեք ցանկացած բան",
  "Спросить ИИ-агента": "Հարցնել AI գործակալին",
  "Спросить ИИ-агента поддержки": "Հարցնել աջակցության AI գործակալին",
  "Статус": "Կարգավիճակ",
  "Статус сервисов": "Ծառայությունների կարգավիճակ",
  "Статус сервисов пока не публикуется.": "Ծառայությունների կարգավիճակն առայժմ չի հրապարակվում։",
  "Статья недоступна": "Հոդվածն անհասանելի է",
  "Темы": "Թեմաներ",
  "Темы пока не опубликованы.": "Թեմաները դեռ հրապարակված չեն։",
  "Точного ответа в справке нет.": "Օգնության նյութերում ճշգրիտ պատասխան չկա։",
  "Чат не отправляет сообщения человеку автоматически.": "Զրույցն ինքնաբերաբար հաղորդագրություններ չի ուղարկում մարդուն։",
  "Читаем запись…": "Կարդում ենք ձայնագրությունը…",
  "Эта статья больше не входит в опубликованную справку.": "Այս հոդվածն այլևս ներառված չէ հրապարակված օգնության նյութերում։",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Ընտրեք մինչև {0} ՄԲ MP3, WAV կամ M4A ֆայլ։",
  "До {0} · до {1} МБ": "Մինչև {0} · մինչև {1} ՄԲ",
  "Нужна запись от 1 секунды до {0}.": "Անհրաժեշտ է առնվազն 1 վայրկյան տևողությամբ և մինչև {0} տևողության ձայնագրություն։",
  "Остановить запись · {0}": "Դադարեցնել ձայնագրությունը · {0}",
  "{0} C/сек": "{0} վրկ/վ",
  "Все инструменты": "Բոլոր գործիքները",
  "Все шаблоны": "Բոլոր ձևանմուշները",
  "Вся подборка": "Ամբողջ հավաքածուն",
  "Выбрать, кто играет": "Ընտրել՝ ով է խաղում",
  "Голос и музыка": "Ձայն և երաժշտություն",
  "Двое": "Երկուսը",
  "Дети": "Երեխաներ",
  "Дешевле": "Ավելի էժան",
  "Для бизнеса": "Բիզնեսի համար",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Այս գործողության համար հասանելի են մի քանի ձևանմուշներ։ Ընտրեք հարմարը կատալոգից։",
  "Загружаем шаблон…": "Բեռնում ենք ձևանմուշը…",
  "Закрыть поиск": "Փակել որոնումը",
  "Закрыть превью": "Փակել նախադիտումը",
  "Инструменты": "Գործիքներ",
  "Искать во всех шаблонах": "Որոնել բոլոր ձևանմուշներում",
  "Короче": "Ավելի կարճ",
  "Кто играет": "Ով է խաղում",
  "Найти инструмент или шаблон": "Գտնել գործիք կամ ձևանմուշ",
  "Не удалось загрузить выбранный вариант.": "Չհաջողվեց բեռնել ընտրված տարբերակը։",
  "Не удалось загрузить шаблон. Обновите превью.": "Չհաջողվեց բեռնել ձևանմուշը։ Թարմացրեք նախադիտումը։",
  "Не удалось открыть инструмент.": "Չհաջողվեց բացել գործիքը։",
  "Несколько": "Մի քանիսը",
  "Новые": "Նորերը",
  "Один": "Մեկը",
  "от {0} C": "{0} C-ից",
  "от {0} C/сек": "{0} C/վրկ-ից",
  "От {0} Circle": "{0} Circle-ից",
  "От А до Я": "Ա-ից Ֆ",
  "Очистить": "Մաքրել",
  "Питомцы": "Ընտանի կենդանիներ",
  "По желанию": "Ըստ ցանկության",
  "Подборка пока недоступна.": "Հավաքածուն դեռ անհասանելի է։",
  "Подборки": "Հավաքածուներ",
  "Поиск": "Որոնում",
  "Пока нет доступных шаблонов": "Դեռ հասանելի ձևանմուշներ չկան",
  "Популярные": "Հանրաճանաչները",
  "После": "Հետո",
  "Превью шаблона": "Ձևանմուշի նախադիտում",
  "Пример результата пока не опубликован.": "Արդյունքի օրինակը դեռ հրապարակված չէ։",
  "Пример сейчас недоступен.": "Օրինակն այս պահին անհասանելի է։",
  "Рекомендуем": "Առաջարկվող",
  "Смотреть все": "Դիտել բոլորը",
  "Сначала": "Դասավորել",
  "Сравнить до и после": "Համեմատել առաջ և հետո",
  "Стилей: {0}. Выбор на следующем шаге.": "Ոճեր՝ {0}։ Ընտրությունը՝ հաջորդ քայլում։",
  "Удерживайте для просмотра": "Պահեք՝ դիտելու համար",
  "Цена уточняется в форме создания.": "Գինը կհստակեցվի ստեղծման ձևում։",
  "Частые вопросы": "Հաճախ տրվող հարցեր",
  "Что нужно": "Ինչ է անհրաժեշտ",
  "Что хотите сделать?": "Ի՞նչ եք ուզում անել։",
  "Шаблоны и подборки": "Ձևանմուշներ և հավաքածուներ",
  "Это действие пока недоступно.": "Այս գործողությունն առայժմ անհասանելի է։",
  "е": "ե",
  "за секунду": "մեկ վայրկյանում",
  "ё": "ё",
  "{0} C в минуту": "{0} C մեկ րոպեում",
  "{0} C за 100 знаков": "{0} C՝ 100 նիշի համար",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Նիստի սեփականատերը փոխվել է։ Էջը թարմացնելուց հետո վերադարձեք ստուդիա։",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Չհաջողվեց վերականգնել պահպանված հայտը։ Նոր գեներացումն արգելափակված է։",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Չհաջողվեց թարմացնել պահպանված հայտը։ Նոր գեներացումն արգելափակված է։",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Չհաջողվեց ստուգել սեփականատիրոջը։ Նոր գեներացումն արգելափակված է։",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Չհաջողվեց պահպանել հայտը։ Ուղարկումը չի կատարվել։",
  "от {0} C в минуту": "{0} C-ից մեկ րոպեում",
  "от {0} C за 100 знаков": "{0} C-ից՝ 100 նիշի համար",
  "Проверить статус заказа": "Ստուգել պատվերի կարգավիճակը",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Կարգավիճակը դեռ հաստատված չէ։ Ավելի ուշ կրկին ստուգեք նույն պատվերը։",
  "в минуту": "մեկ րոպեում",
  "за 100 знаков": "100 նիշի համար",
  "Анимация звука": "Ձայնի անիմացիա",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "Տեսանյութում կմնա բնօրինակ խոսքը։ Ընտրեք մինչև մեկ րոպե տևողությամբ հատված։",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "Տեսանյութում կմնան բնօրինակ բառերը։ Կարելի է փոխել ձայնը։ Ընտրեք մինչև մեկ րոպե տևողությամբ հատված։",
  "Вид персонажа": "Կերպարի տեսքը",
  "Видео готово": "Տեսանյութը պատրաստ է",
  "Видео не создано": "Տեսանյութը չի ստեղծվել",
  "Волна": "Ալիք",
  "Выберите, кто говорит": "Ընտրեք, թե ով է խոսում",
  "Выбранное фото": "Ընտրված լուսանկարը",
  "Движение": "Շարժում",
  "Добавьте видео": "Ավելացրեք տեսանյութ",
  "Дополнительная настройка": "Լրացուցիչ կարգավորում",
  "Другой голос для записи": "Ձայնագրության համար այլ ձայն",
  "Ещё вариант": "Եվս մեկ տարբերակ",
  "Ещё настройки": "Լրացուցիչ կարգավորումներ",
  "Изменить данные": "Փոխել տվյալները",
  "Источник": "Աղբյուր",
  "Источник лица": "Դեմքի աղբյուր",
  "Источник речи": "Խոսքի աղբյուր",
  "Кадр по вертикали": "Ուղղահայաց կադր",
  "Кадр по горизонтали": "Հորիզոնական կադր",
  "Каких движений избегать": "Ինչ շարժումներից խուսափել",
  "Конец фрагмента, секунды": "Հատվածի ավարտը, վայրկյաններ",
  "Кружком": "Տեսահաղորդագրությամբ",
  "Кружок готов": "Շրջանաձև տեսանյութը պատրաստ է",
  "Кружок не создан": "Շրջանաձև տեսանյութը չի ստեղծվել",
  "Люди и персонажи": "Մարդիկ և կերպարներ",
  "Напишите текст или добавьте запись": "Գրեք տեքստ կամ ավելացրեք ձայնագրություն",
  "Начало фрагмента, секунды": "Հատվածի սկիզբը, վայրկյաններ",
  "Не удалось загрузить виды персонажа.": "Չհաջողվեց բեռնել կերպարների տեսակները։",
  "Не удалось загрузить людей и персонажей.": "Չհաջողվեց բեռնել մարդկանց և կերպարներին։",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Չհաջողվեց հաստատել պատվերի ավարտը։ Նոր գեներացում չի սկսվել։",
  "Не удалось проверить доставку. Откройте историю заказа.": "Չհաջողվեց ստուգել առաքումը։ Բացեք պատվերի պատմությունը։",
  "Оставить голос записи": "Պահպանել ձայնագրության ձայնը",
  "Открыть в чате": "Բացել չաթում",
  "Отправлено в чат": "Ուղարկվել է չաթ",
  "По умолчанию": "Լռելյայն",
  "Подтвердите право использовать материалы": "Հաստատեք նյութերն օգտագործելու իրավունքը",
  "Полосы": "Շերտեր",
  "Портретное": "Դիմանկարային",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "Նախորդ պատվերը դեռ ավարտված չէ։ Նախ ստուգեք դրա արդյունքը։",
  "Приближение": "Խոշորացում",
  "Проверка отклонила материал. Измените исходные данные.": "Ստուգումը մերժել է նյութը։ Փոխեք սկզբնական տվյալները։",
  "Продолжить проверку отправки": "Շարունակել ուղարկման ստուգումը",
  "Результат недоступен. Проверьте историю заказа.": "Արդյունքն անհասանելի է։ Ստուգեք պատվերի պատմությունը։",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Ուղարկման արդյունքը դեռ հաստատված չէ։ Շարունակեք ստուգումը նույն բանալիով։",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Արդյունքը դեռ հաստատված չէ։ Ստուգեք այս պատվերը՝ նախքան նորը ստեղծելը։",
  "Своё видео": "Սեփական տեսանյութը",
  "Своё фото": "Սեփական լուսանկարը",
  "Создание сейчас недоступно": "Ստեղծումն այս պահին անհասանելի է",
  "Создать кружок": "Ստեղծել տեսահաղորդագրություն",
  "Создаём видео": "Ստեղծվում է տեսանյութը",
  "Списание возвращено": "Գումարի գանձումը վերադարձվել է",
  "Тестовый заказ без списания": "Թեստային պատվեր՝ առանց գումարի գանձման",
  "Файлом": "Ֆայլով",
  "Фоновый звук": "Ֆոնային ձայն",
  "Фото с лицом": "Դեմքով լուսանկար",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Գինը կամ գործիքի տարբերակը փոխվել է։ Թարմացրեք ձևը և ստուգեք արժեքը։",
  "Человек или персонаж": "Մարդ կամ կերպար",
  "Что скажет?": "Ի՞նչ կասի։",
  "Напишите не меньше {0} знаков": "Գրեք առնվազն {0} նիշ",
  "Текст отклонён проверкой. Измените текст.": "Տեքստը մերժվել է ստուգման արդյունքում։ Փոփոխեք տեքստը։",
  "В видео прозвучат новые слова.": "Տեսանյութում կհնչեն նոր բառեր։",
  "Если речь длиннее видео, ролик повторится.": "Եթե խոսքը տեսանյութից երկար լինի, տեսանյութը կկրկնվի։",
  "Исходная речь": "Սկզբնական խոսք",
  "Новая запись": "Նոր ձայնագրություն",
  "Новые слова текстом": "Նոր բառերը՝ տեքստով",
  "Речь в видео": "Խոսքը տեսանյութում",
  "Размер файла не должен превышать {0} МБ.": "Ֆայլի չափը չպետք է գերազանցի {0} ՄԲ։",
  "До {0} МБ": "Մինչև {0} ՄԲ",
  "Альбомное": "Հորիզոնական",
  "Альбомом": "Ալբոմի ձևաչափով",
  "Без стиля": "Առանց ոճի",
  "В новом стиле": "Նոր ոճով",
  "Вариант": "Տարբերակ",
  "Во весь экран": "Ամբողջ էկրանով",
  "Восстановить фото": "Վերականգնել լուսանկարը",
  "Все стили": "Բոլոր ոճերը",
  "Все темы": "Բոլոր թեմաները",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Ընտրեք գործիքների ցանկից գործիքը, ապա հաստատեք լուսանկարի օգտագործումը։",
  "Выберите подходящее фото до {0} МБ.": "Ընտրեք համապատասխան լուսանկար՝ մինչև {0} ՄԲ չափով։",
  "Выберите стиль или свой референс": "Ընտրեք ոճ կամ ձեր սեփական օրինակելի պատկեր",
  "Выбран свой референс": "Ընտրված է ձեր սեփական օրինակելի պատկերը",
  "Выбрать стиль": "Ընտրել ոճը",
  "Двигайте картинку, чтобы выбрать кадр": "Շարժեք պատկերը՝ կադրը ընտրելու համար",
  "Диафрагма": "Դիաֆրագմա",
  "Добавить человека": "Ավելացնել մարդ",
  "Добавьте описание, от 10 знаков": "Ավելացրեք նկարագրություն՝ առնվազն 10 նիշ",
  "Загрузите фото": "Վերբեռնեք լուսանկար",
  "Заполните обязательные поля": "Լրացրեք պարտադիր դաշտերը",
  "Изменить фото": "Փոխել լուսանկարը",
  "Использовать выбранное фото результата": "Օգտագործել արդյունքի ընտրված լուսանկարը",
  "Кадр": "Կադր",
  "Кадрирование": "Կադրի կտրում",
  "Как у фото": "Ինչպես լուսանկարում",
  "Камера": "Տեսախցիկ",
  "Найти настройку съёмки": "Գտնել նկարահանման կարգավորումը",
  "Найти стиль": "Գտնել ոճը",
  "Настройки съёмки недоступны.": "Նկարահանման կարգավորումներն անհասանելի են։",
  "Начать новое улучшение": "Սկսել նոր բարելավում",
  "Не выбран": "Ընտրված չէ",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Չհաջողվեց վերականգնել բարելավումը։ Նորից ուղարկելու հնարավորությունն արգելափակված է։",
  "Не удалось загрузить режимы фото.": "Չհաջողվեց բեռնել լուսանկարի ռեժիմները։",
  "Не удалось загрузить фото.": "Չհաջողվեց բեռնել լուսանկարը։",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Չհաջողվեց օգտագործել արդյունքի լուսանկարը։ Բացեք սկզբնական պատվերը և փորձեք կրկին։",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Չհաջողվեց բացել ռեժիմը։ Փորձեք կրկին։",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Չհաջողվեց փոխանցել ընտրված լուսանկարը։ Փորձեք կրկին։",
  "Не удалось проверить владельца.": "Չհաջողվեց ստուգել սեփականատիրոջը։",
  "Не удалось прочитать фото.": "Չհաջողվեց կարդալ լուսանկարը։",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Չհաջողվեց բարելավել տեքստը։ Սկզբնական տեքստը պահպանվել է։",
  "О стиле": "Ոճի մասին",
  "Объектив": "Օբյեկտիվ",
  "Оживить фото": "Կենդանացնել լուսանկարը",
  "Описание во весь экран": "Նկարագրությունը՝ ամբողջ էկրանով",
  "Описание длиннее допустимого": "Նկարագրությունը գերազանցում է թույլատրելի երկարությունը",
  "По вертикали": "Ուղղահայաց",
  "По горизонтали": "Հորիզոնական",
  "По описанию": "Ըստ նկարագրության",
  "Повторить прежнее улучшение": "Կրկնել նախորդ բարելավումը",
  "Подтвердите права на материалы": "Հաստատեք նյութերի օգտագործման իրավունքը",
  "Пример": "Օրինակ",
  "Проверить улучшение": "Ստուգել բարելավումը",
  "Проверяем фото…": "Ստուգում ենք լուսանկարը…",
  "Ракурс": "Նկարահանման անկյուն",
  "Раскрасить чёрно-белое": "Գունավորել սև-սպիտակ լուսանկարը",
  "Режим фото": "Լուսանկարի ռեժիմ",
  "Референс должен быть не меньше 256 × 256 пикселей.": "Օրինակելի պատկերը պետք է լինի առնվազն 256 × 256 պիքսել։",
  "Свернуть": "Ծալել",
  "Свет": "Լույս",
  "Свой референс": "Սեփական օրինակելի պատկեր",
  "Свой референс сейчас недоступен": "Սեփական օրինակելի պատկերն այս պահին անհասանելի է",
  "Сделать рилс": "Ստեղծել ռիլս",
  "Сколько фото": "Լուսանկարների քանակը",
  "Создать фото": "Ստեղծել լուսանկար",
  "Создаём фото": "Ստեղծում ենք լուսանկարը",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Բարելավման ստուգման ժամկետը լրացել է։ Սկզբնական տեքստը պահպանվել է։",
  "Тема стиля": "Ոճի թեմա",
  "Убрать из кадра": "Հեռացնել կադրից",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "Բարելավումը դեռ հաստատված չէ։ Սկզբնական տեքստը պահպանվել է։",
  "Улучшить": "Բարելավել",
  "Формат файла": "Ֆայլի ձևաչափ",
  "Фото готовы": "Լուսանկարները պատրաստ են",
  "Фото на аватарку": "Անձնագրային լուսանկար",
  "Фото не создано": "Լուսանկարը չի ստեղծվել",
  "Цвет": "Գույն",
  "Что дальше": "Ինչ անել հետո",
  "Что делает в кадре": "Ինչ է անում կադրում",
  "Выберите разных людей в кадре": "Ընտրեք տարբեր մարդկանց կադրի համար",
  "Измените описание и попробуйте улучшить его снова.": "Փոխեք նկարագրությունը և կրկին փորձեք բարելավել այն։",
  "Использовать референс": "Օգտագործել ռեֆերենսը",
  "Авто": "Ավտոմատ",
  "Без движения": "Առանց շարժման",
  "Видео должно длиться не меньше секунды": "Տեսանյութը պետք է տևի առնվազն մեկ վայրկյան",
  "Выберите главное фото": "Ընտրեք հիմնական լուսանկարը",
  "Выберите один исходный файл": "Ընտրեք մեկ սկզբնական ֆայլ",
  "Выберите файл подходящего формата и размера": "Ընտրեք համապատասխան ձևաչափի և չափի ֆայլ",
  "Выберите фрагмент от 1 до 10 секунд": "Ընտրեք 1–10 վայրկյան հատված",
  "Главное фото": "Հիմնական լուսանկար",
  "Длительность исходника: {0} с": "Սկզբնական տևողություն՝ {0} վ",
  "Добавить речь": "Ավելացնել խոսք",
  "Загрузите видео": "Վերբեռնեք տեսանյութ",
  "Загрузите фото или видео": "Վերբեռնեք լուսանկար կամ տեսանյութ",
  "Загрузить": "Վերբեռնել",
  "Загрузить видео": "Վերբեռնել տեսանյութ",
  "Загрузить фото": "Վերբեռնել լուսանկար",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Սկզբնական ձայնը չի պահպանվում․ մոդելը ստեղծում է նոր ձայն։",
  "Звук от модели": "Մոդելի ստեղծած ձայն",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Մոդելը ստեղծում է ֆոնային ձայն, աղմուկներ և երաժշտություն։ Խոսքը կարելի է ավելացնել հետո։",
  "Использовать видео результата": "Օգտագործել արդյունքի տեսանյութը",
  "Исходное видео": "Սկզբնական տեսանյութ",
  "Исходный файл": "Սկզբնական ֆայլ",
  "Как двигаться": "Ինչպես շարժվել",
  "Конец фрагмента, мс": "Հատվածի վերջը, մվ",
  "Конец, секунды": "Վերջը, վայրկյան",
  "Люди в кадре недоступны для этого режима": "Այս ռեժիմում կադրում մարդիկ հասանելի չեն",
  "Начало фрагмента, мс": "Հատվածի սկիզբը, մվ",
  "Начало, секунды": "Սկիզբը, վայրկյան",
  "Не удалось загрузить режимы видео.": "Չհաջողվեց բեռնել տեսանյութի ռեժիմները։",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Չհաջողվեց օգտագործել արդյունքի տեսանյութը։ Բացեք սկզբնական պատվերը և փորձեք կրկին։",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Չհաջողվեց փոխանցել տեսանյութը։ Բացեք սկզբնական պատվերը և փորձեք կրկին։",
  "Новое": "Նոր",
  "Объёмное фото создаётся без звука": "Ծավալային լուսանկարն ստեղծվում է առանց ձայնի",
  "Первый кадр": "Առաջին կադր",
  "Продолжить загрузку": "Շարունակել վերբեռնումը",
  "Разрешение": "Լուծաչափ",
  "Режим видео": "Տեսանյութի ռեժիմ",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Կօգտագործենք հիմնական լուսանկարը։ Ընտրեք հիմնական լուսանկարը կտրելու համար։",
  "Снять": "Նկարել",
  "Снять видео": "Նկարել տեսանյութ",
  "Создать видео": "Ստեղծել տեսանյութ",
  "Темп": "Տեմպ",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Գործիքը սահմանում է ձևաչափը՝ ուղղահայաց 3:4, 5 վայրկյան տեսանյութ",
  "Фото товара": "Ապրանքի լուսանկարներ",
  "Фрагмент от 1 до 10 секунд": "1–10 վայրկյան հատված",
  "Хит": "Հանրաճանաչ",
  "Что изменить": "Ինչ փոխել",
  "Этот режим видео пока недоступен": "Տեսանյութի այս ռեժիմը դեռ հասանելի չէ",
  "Как у исходника": "Ինչպես սկզբնականում",
  "Со звуком": "Ձայնով",
  "Без звука": "Առանց ձայնի",
  "5 секунд": "5 վայրկյան",
  "10 секунд": "10 վայրկյան",
  "Не удалось прочитать файл.": "Չհաջողվեց կարդալ ֆայլը։",
  "1. Видео с вами": "1. Տեսանյութ ձեզ հետ",
  "1. Видео с движениями": "1. Շարժումների տեսանյութ",
  "2. Кем стать": "2. Ով դառնալ",
  "2. Кто повторит": "2. Ով կկրկնի",
  "Видео должно длиться не меньше {0} секунд": "Տեսանյութը պետք է տևի առնվազն {0} վայրկյան",
  "Водяной знак — недоступен": "Ջրանիշ՝ անհասանելի",
  "Вы, близкий или персонаж": "Դուք, մտերիմը կամ կերպարը",
  "Выберите допустимый фрагмент видео": "Ընտրեք թույլատրելի տևողությամբ հատված",
  "Выберите одного героя": "Ընտրեք մեկ հերոս",
  "Выберите фон": "Ընտրեք ֆոն",
  "Выберите, кто повторит движения": "Ընտրեք՝ ով կկրկնի շարժումները",
  "Голос героя — недоступен": "Հերոսի ձայն՝ անհասանելի",
  "Другой голос — недоступен": "Այլ ձայն՝ անհասանելի",
  "Загрузите видео с движениями": "Վերբեռնեք շարժումների տեսանյութ",
  "Из видео": "Տեսանյութից",
  "Изменить людей и свои фото": "Փոփոխել մարդկանց և ձեր լուսանկարները",
  "Источник героя": "Հերոսի աղբյուր",
  "Исходный звук сохраняется, если он есть в ролике.": "Սկզբնական ձայնը պահպանվում է, եթե տեսանյութում այն կա։",
  "Кадр, ракурс и фон берутся с фото героя.": "Կադրը, դիտանկյունը և ֆոնը վերցվում են հերոսի լուսանկարից։",
  "Кто повторит движения": "Ով կկրկնի շարժումները",
  "На фото должны быть видны голова, плечи и корпус.": "Լուսանկարում պետք է երևան գլուխը, ուսերը և իրանը։",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Կադրում պետք է լինի մեկ մարդ։ Լուսանկարում և տեսանյութում պետք է երևան գլուխը, ուսերը և իրանը։",
  "Подтвердите права и согласие человека": "Հաստատեք իրավունքները և անձի համաձայնությունը",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Հաստատում եմ նյութերի նկատմամբ իրավունքները և անձի համաձայնությունը՝ իր պատկերի օգտագործման համար",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Կլոր տեսանյութի փոխարկումն անհասանելի է․ արդյունքի ձայնային ուղին հաստատված չէ։",
  "Режим движения": "Շարժման ռեժիմ",
  "С героя": "Հերոսից",
  "Смена голоса пока недоступна": "Ձայնի փոփոխությունը դեռ հասանելի չէ",
  "Снять выбор": "Չեղարկել ընտրությունը",
  "Сохранение исходного звука не подтверждено.": "Սկզբնական ձայնի պահպանումը հաստատված չէ։",
  "Стать персонажем": "Դառնալ կերպար",
  "Сцена и движения берутся из видео; внешность может отличаться.": "Տեսարանը և շարժումները վերցվում են տեսանյութից․ արտաքին տեսքը կարող է տարբերվել։",
  "Только свои фото или с согласием человека на фото": "Միայն ձեր լուսանկարները կամ լուսանկարում պատկերված անձի համաձայնությամբ",
  "Фон": "Ֆոն",
  "Фото героя": "Հերոսի լուսանկար",
  "Фрагмент от {0} до {1} секунд": "{0}–{1} վայրկյան հատված",
  "{0} символов": "{0} նիշ",
  "Авито": "Avito",
  "Английский": "Անգլերեն",
  "Выберите аудио или видео": "Ընտրեք աուդիո կամ տեսանյութ",
  "Выбрать": "Ընտրել",
  "Гарантия": "Երաշխիք",
  "Да": "Այո",
  "Для чего нужен промпт": "Պրոմպտի նպատակը",
  "Для этого инструмента сократите текст до 500 символов.": "Այս գործիքի համար կրճատեք տեքստը մինչև 500 նիշ։",
  "Добавьте текст": "Ավելացրեք տեքստ",
  "Добавьте файл": "Ավելացրեք ֆայլ",
  "Дополнительные варианты": "Լրացուցիչ տարբերակներ",
  "Дополнительные варианты пока не подтверждены.": "Լրացուցիչ տարբերակները դեռ հաստատված չեն։",
  "Дружелюбный": "Ընկերական",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Վերբեռնեք ձայնագրություն կամ ձայնագրեք ձեր ձայնը։ Ճանաչումը կսկսվի հաստատումից հետո։",
  "Исходное фото": "Սկզբնական լուսանկար",
  "Как изменить текст": "Ինչպես փոխել տեքստը",
  "Комплект": "Հավաքածու",
  "Короткий": "Կարճ",
  "Материал": "Նյութ",
  "Музыка": "Երաժշտություն",
  "На весь экран": "Ամբողջ էկրանով",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Չհաջողվեց բացել գործիքը։ Ստուգեք հաշիվը և տեքստի երկարությունը։",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Չհաջողվեց հաստատել լրացուցիչ տարբերակները։ Ստուգեք նույն հարցումը։",
  "Не удалось скачать текст.": "Չհաջողվեց ներբեռնել տեքստը։",
  "Не удалось скопировать текст.": "Չհաջողվեց պատճենել տեքստը։",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Չհաջողվեց պահպանել սևագիրը։ Ստեղծումն արգելափակված է՝ տվյալները չկորցնելու համար։",
  "Нейтральный": "Չեզոք",
  "Нет": "Ոչ",
  "Объём описания": "Նկարագրության ծավալը",
  "Описание товара": "Ապրանքի նկարագրություն",
  "Повторить запрос с тем же ключом": "Կրկնել նույն բանալիով",
  "Подарочный": "Նվերային",
  "Подробнее": "Ավելի մանրամասն",
  "Подробный": "Մանրամասն",
  "Подтверждаю права на материалы": "Հաստատում եմ նյութերի նկատմամբ իրավունքները",
  "Пожелания": "Ցանկություններ",
  "Показать время": "Ցույց տալ ժամանակը",
  "Показать всё": "Ցույց տալ բոլորը",
  "Премиальный": "Պրեմիում",
  "Проверить тот же запрос": "Ստուգել նույն հարցումը",
  "Продающий": "Վաճառող",
  "Промпт из видео пока недоступен.": "Տեսանյութից պրոմպտը դեռ անհասանելի է։",
  "Промпт из фото": "Պրոմպտ լուսանկարից",
  "Разделить по собеседникам": "Բաժանել ըստ զրուցակիցների",
  "Размеры": "Չափեր",
  "Распознавание по ссылке YouTube пока недоступно.": "YouTube հղումով ճանաչումը դեռ անհասանելի է։",
  "Распознать": "Ճանաչել",
  "Редактировать текст": "Խմբագրել տեքստը",
  "Сайт": "Կայք",
  "Сбросить сохранённый черновик": "Մաքրել պահպանված սևագիրը",
  "Скачать TXT": "Ներբեռնել TXT",
  "Скопировать весь текст": "Պատճենել ամբողջ տեքստը",
  "Собеседник {0}": "Զրուցակից {0}",
  "Создать промпт": "Ստեղծել պրոմպտ",
  "Создать сценарий": "Ստեղծել սցենար",
  "Создаём текст": "Ստեղծում ենք տեքստը",
  "Сократите пожелания": "Կրճատեք ցանկությունները",
  "Сократите текст": "Կրճատեք տեքստը",
  "Список": "Ցանկ",
  "Текст готов": "Տեքստը պատրաստ է",
  "Текст из аудио и видео": "Տեքստ աուդիոյից և տեսանյութից",
  "Текст не создан": "Տեքստը չի ստեղծվել",
  "Тестовый режим без списания": "Փորձնական ռեժիմ առանց գանձման",
  "Тон описания": "Նկարագրության տոն",
  "Улучшить промпт": "Բարելավել պրոմպտը",
  "Уход": "Խնամք",
  "Что добавить в описание": "Ինչ ավելացնել նկարագրության մեջ",
  "Экспертный": "Մասնագիտական",
  "Язык": "Լեզու",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Ավելացրեք լուսանկար բացված գործիքում։",
  "Не удалось открыть фото.": "Չհաջողվեց բացել լուսանկարը։",
  "Текст для видео": "Տեքստ տեսանյութի համար",
  "Цена этого выбора пока не подтверждена": "Այս ընտրության գինը դեռ հաստատված չէ",
  "C за фото": "C մեկ լուսանկարի համար",
  "C за секунду": "C մեկ վայրկյանի համար",
  "Обычный": "Սովորական",
  "Кто повторил": "Ով կրկնեց",
  "Человек с фото": "Լուսանկարի մարդը",
  "Сменить фон": "Փոխել ֆոնը",
  "Убрать лишнее": "Հեռացնել ավելորդը",
  "Добавить очки": "Ավելացնել ակնոց",
  "Причёска": "Սանրվածք",
  "Улыбка": "Ժպիտ",
  "Деловой образ": "Գործնական կերպար",
  "Летний фон": "Ամառային ֆոն",
  "Машет рукой": "Ձեռքով է անում",
  "Ветер": "Քամի",
  "Плавнее": "Ավելի սահուն",
  "Ярче": "Ավելի պայծառ",
  "День в ночь": "Ցերեկից գիշեր",
  "Снег": "Ձյուն",
  "Очки": "Ակնոց",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Ի՞նչ պետք է լինի լուսանկարում։ Օրինակ՝ անձրևանոցով աղջիկ թաց փողոցում, երեկո, ցուցափեղկերի լույսեր",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Ի՞նչ փոխել լուսանկարում։ Օրինակ՝ ֆոնը փոխիր գիշերային քաղաքով, ավելացրու ակնոց",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Ի՞նչ ավելացնել կամ փոխել։ Օրինակ՝ գործնական կոստյում, թեթև ժպիտ",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Ի՞նչ է կատարվում տեսանյութում։ Օրինակ՝ տեսախցիկը դանդաղ թռչում է գիշերային քաղաքի վրայով, լույսեր և թաց ասֆալտ",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Ինչպե՞ս շարժվել։ Օրինակ՝ ժպտում է և ձեռքով անում, քամին մազերում",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Ի՞նչ փոխել տեսանյութում։ Օրինակ՝ ֆոնը փոխիր գիշերային քաղաքով, ավելացրու ձյուն",
  "Что добавить? Например: движения плавнее, ярче": "Ի՞նչ ավելացնել։ Օրինակ՝ ավելի սահուն շարժումներ, ավելի պայծառ",
  "Сменить голос в записи": "Փոխել ձայնը ձայնագրության մեջ",
  "Загрузите запись": "Վերբեռնեք ձայնագրություն",
  "Ваша речь зазвучит выбранным голосом": "Ձեր խոսքը կհնչի ընտրված ձայնով",
  "Голосовое, интервью или заметку: уберём шум": "Ձայնային հաղորդագրություն, հարցազրույց կամ նշում․ կհեռացնենք աղմուկը",
  "Библиотека и ваши клоны": "Գրադարան և ձեր կլոնները",
  "Без переозвучки, выберите другой": "Առանց ձայնի փոխարկման, ընտրեք այլ ձայն",
  "· Мой голос": "· Իմ ձայնը",
  "· ещё {0}+ голосов": "· ևս {0}+ ձայն",
  "Убрать шум": "Հեռացնել աղմուկը",
  "Перед сменой голоса уберём фон и эхо": "Ձայնը փոխելուց առաջ կհեռացնենք ֆոնը և արձագանքը",
  "Оставим только голос, без фона и эха": "Կթողնենք միայն ձայնը՝ առանց ֆոնի և արձագանքի",
  "Голосовым или файлом: выберете, когда запись будет готова": "Ձայնային հաղորդագրությամբ կամ ֆայլով․ կընտրեք, երբ ձայնագրությունը պատրաստ լինի",
  "Сменить голос": "Փոխել ձայնը",
  "Сделать голосовым": "Դարձնել ձայնային հաղորդագրություն",
  "{0} · от {1} C": "{0} · {1} C-ից",
  "Сначала остановите запись": "Նախ դադարեցրեք ձայնագրումը",
  "Загрузите или запишите аудио": "Վերբեռնեք կամ ձայնագրեք աուդիո",
  "Читаем запись, секунду": "Կարդում ենք ձայնագրությունը, մի պահ",
  "Запись длиннее {0}, загрузите короче": "Ձայնագրությունը {0}-ից երկար է, վերբեռնեք ավելի կարճը",
  "Выберите голос, которым зазвучит запись": "Ընտրեք ձայնը, որով կհնչի ձայնագրությունը",
  "Этот голос не умеет переозвучку, выберите другой": "Այս ձայնը չի կարող փոխարկել ձայնագրությունները, ընտրեք այլ ձայն",
  "Пауза": "Դադար",
  "Длиннее {0}": "{0}-ից երկար",
  "Звучит запись": "Հնչում է ձայնագրությունը",
  "Прослушать запись": "Լսել ձայնագրությունը",
  "Загрузите запись короче": "Վերբեռնեք ավելի կարճ ձայնագրություն",
  "Запись с микрофона": "Միկրոֆոնի ձայնագրություն",
  "Без шума": "Առանց աղմուկի",
  "Как в записи": "Ինչպես ձայնագրության մեջ",
  "Слушать": "Լսել",
  "Отправить голосовым": "Ուղարկել ձայնային հաղորդագրությամբ",
  "Отправить файлом": "Ուղարկել ֆայլով",
  "Голосовое в чате": "Ձայնային հաղորդագրությունը չաթում է",
  "Файл в чате": "Ֆայլը չաթում է",
  "Голосовое в чате, в отдельной теме": "Ձայնային հաղորդագրությունը չաթում է, առանձին թեմայում",
  "Файл в чате, в отдельной теме": "Ֆայլը չաթում է, առանձին թեմայում",
  "Тут откроется тема чата, куда бот прислал голосовое": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է ձայնային հաղորդագրությունը",
  "Тут откроется тема чата, куда бот прислал запись": "Այստեղ կբացվի չաթի թեման, որտեղ բոտն ուղարկել է ձայնագրությունը",
  "Меняем голос": "Փոխում ենք ձայնը",
  "Собираем запись": "Հավաքում ենք ձայնագրությունը",
  "Шум убран": "Աղմուկը հեռացված է",
  "Запись готова": "Ձայնագրությունը պատրաստ է",
  "Голос изменён": "Ձայնը փոխված է",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ ձայնագրությունը պատրաստ լինի։",
  "Голос ваш, шума больше нет.": "Ձայնը ձերն է, աղմուկ այլևս չկա։",
  "Голос ваш, запись готова стать голосовым.": "Ձայնը ձերն է, ձայնագրությունը պատրաստ է դառնալու ձայնային հաղորդագրություն։",
  "Слова и интонация ваши, голос новый.": "Բառերն ու ինտոնացիան ձերն են, ձայնը՝ նոր։",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Կուղարկենք չաթ ձայնային հաղորդագրությամբ կամ ֆայլով, ինչպես հարմար է։",
  "Запись ещё собирается": "Ձայնագրությունը դեռ հավաքվում է",
  "Заставить говорить": "Ստիպել խոսել",
  "Заменить запись": "Փոխարինել ձայնագրությունը",
  "Загружаем запись": "Վերբեռնում ենք ձայնագրությունը",
  "Запись загружена": "Ձայնագրությունը վերբեռնված է",
  "Запись собрана": "Ձայնագրությունը հավաքված է",
  "Запись не прошла проверку": "Ձայնագրությունը չի անցել ստուգումը",
  "запись не собрана": "ձայնագրությունը չի հավաքվել",
  "голос не изменён": "ձայնը չի փոխվել",
  "Не получилось убрать шум": "Չհաջողվեց հեռացնել աղմուկը",
  "Не получилось собрать запись": "Չհաջողվեց հավաքել ձայնագրությունը",
  "Не получилось сменить голос": "Չհաջողվեց փոխել ձայնը",
  "Обновить форму": "Թարմացնել ձևը",
  "Запись {0}": "Ձայնագրություն {0}",
  "Проверяем доступность": "Ստուգում ենք հասանելիությունը",
  "Загрузите запись заново": "Կրկին վերբեռնեք ձայնագրությունը",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Չհաջողվեց ընտրել ձայնը։ Փորձեք կրկին։",
  "Запись здесь недоступна, загрузите файл": "Ձայնագրումն այստեղ հասանելի չէ, վերբեռնեք ֆայլ",
  "Не удалось прочитать запись, попробуйте ещё раз": "Չհաջողվեց կարդալ ձայնագրությունը, փորձեք կրկին",
  "Ваш голос": "Ձեր ձայնը",
  "в аудио": "աուդիոյում",
  "со скидкой, {0} водяной знак": "զեղչով, {0} ջրանիշ",
  "Запись ещё загружается": "Ձայնագրությունը դեռ բեռնվում է",
  "Проверяем отправку": "Ստուգում ենք ուղարկումը",
  "Этот способ отправки сейчас недоступен": "Ուղարկման այս եղանակը հիմա հասանելի չէ",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Ուղարկումը դեռ հաստատված չէ։ Սեղմեք կրկին, և մենք կստուգենք նույն հարցումը։",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Չհաջողվեց փոխանցել ձայնագրությունը։ Բացեք աշխատանքը «Պատմություն» բաժնում և փորձեք կրկին։",
  "Попробовать ещё раз": "Փորձել կրկին",
  "Проверить ещё раз": "Ստուգել կրկին",
  "К настройкам": "Վերադառնալ կարգավորումներին",
  "Заказ не создан": "Պատվերը չի ստեղծվել",
  "Заказ не подтверждён": "Պատվերը հաստատված չէ",
  "остаток": "մնացորդ",
  "Права на материалы": "Նյութերի իրավունքներ",
  "Только свои файлы или с согласия владельца": "Միայն ձեր ֆայլերը կամ սեփականատիրոջ համաձայնությամբ",
  "Загружаем файл": "Վերբեռնում ենք ֆայլը",
  "Создаём": "Ստեղծում ենք",
  "Файл больше {0} МБ, загрузите меньше": "Ֆայլը {0} ՄԲ-ից մեծ է, վերբեռնեք ավելի փոքրը",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "Լուսանկարը {0} × {1} պիքսելից փոքր է, վերբեռնեք ավելի մեծը",
  "Видео длиннее {0}, загрузите короче": "Տեսանյութը {0}-ից երկար է, վերբեռնեք ավելի կարճը",
  "Запись короче {0}, загрузите длиннее": "Ձայնագրությունը {0}-ից կարճ է, վերբեռնեք ավելի երկարը",
  "Видео короче {0}, загрузите длиннее": "Տեսանյութը {0}-ից կարճ է, վերբեռնեք ավելի երկարը",
  "Не удалось открыть фото. Загрузите его заново.": "Չհաջողվեց բացել լուսանկարը։ Վերբեռնեք այն կրկին։",
  "Не удалось открыть видео. Загрузите его заново.": "Չհաջողվեց բացել տեսանյութը։ Վերբեռնեք այն կրկին։",
  "Можно до {0} фото": "Մինչև {0} լուսանկար",
  "Этот человек не участвует": "Այս մարդը չի մասնակցում",
  "Добавьте фото": "Ավելացրեք լուսանկարներ",
  "Файл не читается, загрузите другой": "Ֆայլը չի կարդացվում, վերբեռնեք այլ ֆայլ",
  "Запись слишком короткая": "Ձայնագրությունը չափազանց կարճ է",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Չհաջողվեց բացել ձայնագրությունը լսելու համար։ Վերբեռնեք այն կրկին։",
  "Файл не прошёл проверку. Выберите другой файл.": "Ֆայլը չի անցել ստուգումը։ Ընտրեք այլ ֆայլ։",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Չափազանց շատ վերբեռնումներ անընդմեջ։ Սպասեք մեկ րոպե և կրկին ընտրեք ֆայլը։",
  "Файл не принят. Выберите его снова.": "Ֆայլը չի ընդունվել։ Ընտրեք այն կրկին։",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Ընտրված կերպարը, ձայնը կամ ձևանմուշը այլևս հասանելի չէ։ Ընտրեք այլ տարբերակ․ պատվերը չի ստեղծվել։",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Ստեղծումը հիմա հասանելի չէ։ Պատվերը չի ստեղծվել, Circle-ը չի գանձվել։",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Նախորդ աշխատանքը դեռ ստեղծվում է։ Երբ այն պատրաստ լինի, կրկին ուղարկեք պատվերը։",
  "Политику и запрещённые темы не пропускаем.": "Քաղաքականություն և արգելված թեմաներ չենք թույլատրում։",
  "{0} C списаны, {1}.": "{0} C գանձվել է, {1}։",
  "{0} C вернулись на баланс.": "{0} C-ն վերադարձվել է հաշվին։",
  ", на шаге «{0}»": ", «{0}» քայլում",
  "Сбой на нашей стороне": "Խափանում մեր կողմից",
  "{0} или {1}": "{0} կամ {1}",
  "до {0}": "մինչև {0}",
  "Записать": "Ձայնագրել",
  "Заменить": "Փոխարինել",
  "Нужна запись: MP3, WAV или M4A": "Անհրաժեշտ է ձայնագրություն՝ MP3, WAV կամ M4A",
  "Нужно фото: JPG или PNG": "Անհրաժեշտ է լուսանկար՝ JPG կամ PNG",
  "Нужно видео: MP4 или MOV": "Անհրաժեշտ է տեսանյութ՝ MP4 կամ MOV",
  "Нужен файл PDF, DOCX или TXT": "Անհրաժեշտ է PDF, DOCX կամ TXT ֆայլ",
  "Нужно фото или видео": "Անհրաժեշտ է լուսանկար կամ տեսանյութ",
  "Файл больше {0} МБ": "Ֆայլը {0} ՄԲ-ից մեծ է",
  "Остановить запись": "Դադարեցնել ձայնագրումը",
  "Запрашиваем микрофон": "Միկրոֆոնի թույլտվություն ենք խնդրում",
  "Отменить запись": "Չեղարկել ձայնագրումը",
  "{0} КБ": "{0} ԿԲ",
  "{0} МБ": "{0} ՄԲ",
  "Не хватает {0} C · Пополнить": "Պակասում է {0} C · Լիցքավորել",
  "Не хватает Circle": "Circle-ը չի բավարարում",
  "Не хватает {0} C": "Պակասում է {0} C",
  "На балансе {0} C, нужно {1} C": "Հաշվին {0} C է, անհրաժեշտ է {1} C",
  "Создать за {0} вместо {1} C": "Ստեղծել {0} արժեքով՝ {1} C-ի փոխարեն",
  "Создать за {0} C вместо {1} C": "Ստեղծել {0} C արժեքով՝ {1} C-ի փոխարեն",
  "Со скидкой всё равно не хватает {0}": "Զեղչով էլ պակասում է {0}",
  "Со скидкой всё равно не хватает {0} C": "Զեղչով էլ պակասում է {0} C",
  "Для этой работы скидки нет": "Այս աշխատանքի համար զեղչ չկա",
  "Сделать дешевле на {0}%, с водяным знаком": "Էժանացնել {0}%-ով, ջրանիշով",
  "Сделать дешевле на 10%, с водяным знаком": "Էժանացնել 10%-ով, ջրանիշով",
  "Назад в студию": "Վերադառնալ ստուդիա",
  "Работа ещё создаётся": "Աշխատանքը դեռ ստեղծվում է",
  "Ваше фото": "Ձեր լուսանկարը",
  "Ваши фото": "Ձեր լուսանկարները",
  "Ваш текст": "Ձեր տեքստը",
  "Ваша тема": "Ձեր թեման",
  "Тема поста": "Գրառման թեման",
  "Готовые кадры": "Պատրաստի կադրեր",
  "Готовый кружок": "Պատրաստի շրջանաձև տեսանյութ",
  "Готовый ролик": "Պատրաստի տեսահոլովակ",
  "Готовое фото": "Պատրաստի լուսանկար",
  "Готовая аватарка": "Պատրաստի ավատար",
  "Готовые слайды": "Պատրաստի սլայդներ",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Պատրաստի սյուժե ձեր մասնակցությամբ․ մոնտաժն ու երաժշտությունն արդեն կաղապարում են",
  "Пост в стиле шаблона, {0} на выбор": "Գրառում կաղապարի ոճով, ընտրության համար՝ {0}",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Ավատար սոցցանցերի և մեսենջերների համար, ընտրության համար՝ {0}",
  "Фотосессия из {0} кадра в стиле шаблона": "{0} կադրից բաղկացած ֆոտոսեսիա կաղապարի ոճով",
  "Фотосессия из {0} кадров в стиле шаблона": "{0} կադրից բաղկացած ֆոտոսեսիա կաղապարի ոճով",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Ձեր լուսանկարը կկենդանանա կարճ տեսահոլովակում, ընտրության համար՝ {0}",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Կերպարը կասի ձեր տեքստը Telegram-ի շրջանաձև տեսանյութում, ընտրության համար՝ {0}",
  "Карусель слайдов для поста, {0} на выбор": "Սլայդների կարուսել գրառման համար, ընտրության համար՝ {0}",
  "{0} стиль": "{0} ոճ",
  "{0} стиля": "{0} ոճ",
  "{0} стилей": "{0} ոճ",
  "{0}, выберете на следующем шаге": "{0}, կընտրեք հաջորդ քայլում",
  "Что скажет герой, до 250 знаков": "Ինչ կասի հերոսը, մինչև 250 նիշ",
  "1 фото": "1 լուսանկար",
  "Любое, где хорошо видно лицо": "Ցանկացածը, որտեղ դեմքը լավ երևում է",
  "Лицо крупно и при хорошем свете": "Դեմքը խոշոր պլանով և լավ լույսի ներքո",
  "Селфи, лицо крупно": "Սելֆի, դեմքը խոշոր պլանով",
  "Снимок оживёт в ролике": "Լուսանկարը կկենդանանա տեսահոլովակում",
  "Или фото, из которых сделаем слайды": "Կամ լուսանկարներ, որոնցից սլայդներ կպատրաստենք",
  "Стиль кружка": "Շրջանաձև տեսանյութի ոճը",
  "1 человек": "1 մարդ",
  "Вы, близкие или персонаж": "Դուք, հարազատները կամ կերպար",
  "Ваши дети, до {0}": "Ձեր երեխաները, մինչև {0}",
  "Ребёнок, одно фото": "Երեխա, մեկ լուսանկար",
  "Питомец, одно фото": "Ընտանի կենդանի, մեկ լուսանկար",
  "Вы или близкие, одно фото": "Դուք կամ հարազատները, մեկ լուսանկար",
  "По желанию: вы, близкие или персонаж": "Ըստ ցանկության՝ դուք, հարազատները կամ կերպար",
  "По желанию: ваши дети, до {0}": "Ըստ ցանկության՝ ձեր երեխաները, մինչև {0}",
  "По желанию: ребёнок, одно фото": "Ըստ ցանկության՝ երեխա, մեկ լուսանկար",
  "По желанию: питомец, одно фото": "Ըստ ցանկության՝ ընտանի կենդանի, մեկ լուսանկար",
  "По желанию: вы или близкие, одно фото": "Ըստ ցանկության՝ դուք կամ հարազատները, մեկ լուսանկար",
  "Reels": "Reels",
  "Аватар": "Ավատար",
  "{0} кадр": "{0} կադր",
  "{0} кадра": "{0} կադր",
  "{0} кадров": "{0} կադր",
  "Выбрать, кто играет: {0}": "Ընտրել՝ ով է խաղում․ {0}",
  "Сравнить: {0} и {1}": "Համեմատել՝ {0} և {1}",
  "Поровну": "Կիսով չափ",
  "Пример результата пока не опубликован": "Արդյունքի օրինակը դեռ հրապարակված չէ",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Արդյունքը պահպանված է «Պատմություն» բաժնում։ Չատ չենք ուղարկում՝ այդպես է ընտրված կարգավորումներում։",
  "Результат сохранён в «Истории».": "Արդյունքը պահպանված է «Պատմություն» բաժնում։",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Արդյունքի ֆայլը դեռ հասանելի չէ։ Ստուգեք աշխատանքը «Պատմություն» բաժնում։",
  ", голос для: {0}": ", ձայն՝ {0}-ի համար",
  ", играет: {0}": ", խաղում է՝ {0}",
  ": добавьте свои фото": "՝ ավելացրեք ձեր լուսանկարները",
  ": добавьте фото": "՝ ավելացրեք լուսանկարներ",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> / <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG կամ PNG, մինչև 10 ՄԲ",
  "JPG, PNG · до {0} снимков": "JPG, PNG · մինչև {0} լուսանկար",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV կամ M4A, մինչև 50 ՄԲ",
  "MP4 или MOV, до 200 МБ": "MP4 կամ MOV, մինչև 200 ՄԲ",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX կամ TXT, մինչև 20 ՄԲ",
  "{0} и {1}": "{0} և {1}",
  "{0} фото": "{0} լուսանկար",
  "{0} фото · как в жизни": "{0} լուսանկար · ինչպես իրականում",
  "{0}, персонаж": "{0}, կերպար",
  "Анфас, вполоборота, с улыбкой и без": "Դիմացից, կիսադարձ, ժպիտով և առանց ժպիտի",
  "Без модели": "Առանց մոդելի",
  "Без сильных теней и фильтров": "Առանց կոպիտ ստվերների և ֆիլտրերի",
  "Было": "Առաջ",
  "В близких": "Հարազատների մեջ",
  "В кадре {0}": "Կադրում՝ {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Կադրում արդեն {0}՝ {1}-ից․ հանեք որևէ մեկի նշումը",
  "В кадре: {0}": "Կադրում՝ {0}",
  "В роли «{0}» не больше {1}": "«{0}» դերում ոչ ավելի, քան {1}",
  "В роль «{0}» персонажи не входят": "«{0}» դերում կերպարներ չեն մտնում",
  "В роль «{0}» подходят {1}": "«{0}» դերին համապատասխանում են՝ {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Տարբերակները ստեղծվում են ձեր լուսանկարներից «Սեփական ավատար» բաժնում։ Ընտրվածը հայտնվում է «Ով է կադրում» բոլոր էկրաններին։",
  "Ваш питомец из близких": "Ձեր ընտանի կենդանին հարազատներից",
  "Ваш ребёнок из близких": "Ձեր երեխան հարազատներից",
  "Ваши фото: один раз для всех инструментов": "Ձեր լուսանկարները՝ մեկ անգամ բոլոր գործիքների համար",
  "Вкл": "Միաց.",
  "Впишите имя": "Մուտքագրեք անունը",
  "Все <span class=\"mono\">{0}</span>": "Բոլորը <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Բոլոր տարբերակները տեսանելի են",
  "Все персонажи": "Բոլոր կերպարները",
  "Вы и персонажи": "Դուք և կերպարներ",
  "Вы или персонаж": "Դուք կամ կերպար",
  "Вы, близкие и персонажи": "Դուք, հարազատներ և կերպարներ",
  "Вы, свои фото": "Դուք, ձեր լուսանկարները",
  "Вы: добавьте свои фото": "Դուք՝ ավելացրեք ձեր լուսանկարները",
  "Выберите вариант": "Ընտրեք տարբերակ",
  "Выберите вариант для поля «{0}»": "Ընտրեք տարբերակ «{0}» դաշտի համար",
  "Выберите ниже": "Ընտրեք ստորև",
  "Выберите одного": "Ընտրեք մեկին",
  "Выберите, кто играет: {0}": "Ընտրեք, թե ով է խաղում՝ {0}",
  "Выберите, кто это для вас": "Ընտրեք, թե ով է նա ձեզ համար",
  "Выбирать во всех инструментах без загрузки": "Ընտրել բոլոր գործիքներում առանց վերբեռնելու",
  "Выбор встанет во все инструменты": "Ընտրությունը կկիրառվի բոլոր գործիքներում",
  "Выбрать «{0}»": "Ընտրել «{0}»",
  "Выбрать вариант": "Ընտրել տարբերակ",
  "Выбрать: {0}": "Ընտրել՝ {0}",
  "Выкл": "Անջատ.",
  "Выключится, когда выберете вариант": "Կանջատվի, երբ տարբերակ ընտրեք",
  "Группы": "Խմբեր",
  "Добавить": "Ավելացնել",
  "Добавить в кадр": "Ավելացնել կադրում",
  "Добавьте свои фото": "Ավելացրեք ձեր լուսանկարները",
  "Добавьте свои фото или вариант": "Ավելացրեք ձեր լուսանկարները կամ տարբերակ",
  "Добавьте фото: {0}": "Ավելացրեք լուսանկարներ՝ {0}",
  "Другой голос": "Այլ ձայն",
  "Ещё {0}: {1}": "Եվս {0}՝ {1}",
  "Заготовки": "Նախապատրաստվածներ",
  "Загрузите файл": "Վերբեռնեք ֆայլ",
  "Загрузить ещё": "Վերբեռնել ևս",
  "Закрыть камеру": "Փակել տեսախցիկը",
  "Запись недоступна. Загрузите видео.": "Ձայնագրումը հասանելի չէ։ Վերբեռնեք տեսանյութ։",
  "Здесь подходят {0}": "Այստեղ համապատասխանում են՝ {0}",
  "Здесь только персонажи своей подборки": "Այստեղ միայն իր հավաքածուի կերպարները",
  "Играет: {0}": "Խաղում է՝ {0}",
  "Из ваших фото": "Ձեր լուսանկարներից",
  "Из каталога": "Կատալոգից",
  "Изменить ваши фото": "Փոփոխել ձեր լուսանկարները",
  "Изменить свои фото": "Փոփոխել ձեր լուսանկարները",
  "Изменить: {0}": "Փոփոխել՝ {0}",
  "Иллюстрация": "Նկարազարդում",
  "Имя": "Անուն",
  "Имя и фото · роли выбираются в ряду": "Անուն և լուսանկարներ · դերերն ընտրվում են շարքում",
  "Искать стиль": "Որոնել ոճ",
  "Каким вы будете": "Ինչպիսին կլինեք",
  "Камера · лицо в кадр": "Տեսախցիկ · դեմքը կադրում",
  "Камера · селфи в кадр": "Տեսախցիկ · սելֆի կադրում",
  "Камера недоступна · имитация": "Տեսախցիկը հասանելի չէ · նմանակում",
  "Камера недоступна. Загрузите файл.": "Տեսախցիկը հասանելի չէ։ Վերբեռնեք ֆայլ։",
  "Каталог 2 400+ голосов, подборки": "2 400+ ձայնի կատալոգ, հավաքածուներ",
  "Ко всем стилям": "Բոլոր ոճերին",
  "Кто будет моделью на фото": "Ով կլինի մոդելը լուսանկարում",
  "Кто играет: <b>{0}</b>": "Ով է խաղում՝ <b>{0}</b>",
  "Кто играет: {0}": "Ով է խաղում՝ {0}",
  "Кто это для вас": "Ով է նա ձեզ համար",
  "Лицо в круг, смотрите в камеру": "Դեմքը շրջանակում, նայեք տեսախցիկին",
  "Люди": "Մարդիկ",
  "Можно близких или персонажа": "Կարելի է հարազատներին կամ կերպար",
  "Можно ваших близких": "Կարելի է ձեր հարազատներին",
  "Можно до {0} видео": "Կարելի է մինչև {0} տեսանյութ",
  "Можно до {0} записей": "Կարելի է մինչև {0} ձայնագրություն",
  "Можно до {0} записи": "Կարելի է մինչև {0} ձայնագրություն",
  "Можно до {0} запись": "Կարելի է մինչև {0} ձայնագրություն",
  "Можно до {0} файл": "Կարելի է մինչև {0} ֆայլ",
  "Можно до {0} файла": "Կարելի է մինչև {0} ֆայլ",
  "Можно до {0} файлов": "Կարելի է մինչև {0} ֆայլ",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Կարելի է նաև այսպես, բայց 3 կամ ավելի լուսանկարը նմանությունն ավելի ճշգրիտ կդարձնի",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Կարելի է նաև այսպես, բայց 3 կամ ավելի լուսանկարը նմանությունն ավելի ճշգրիտ կդարձնի",
  "Можно себя или близких": "Կարելի է ինքներդ ձեզ կամ հարազատներին",
  "Можно себя, близких или персонажа": "Կարելի է ինքներդ ձեզ, հարազատներին կամ կերպար",
  "На этом экране вы в кадре всегда": "Այս էկրանին դուք միշտ կադրում եք",
  "Навсегда, вместе с фото": "Ընդմիշտ՝ լուսանկարների հետ միասին",
  "Нажмите, чтобы выбрать": "Սեղմեք՝ ընտրելու համար",
  "Найти": "Գտնել",
  "Напишите пару слов, и мы предложим варианты": "Գրեք մի քանի բառ, և մենք կառաջարկենք տարբերակներ",
  "Например: Барсик": "Օրինակ՝ Մաքս",
  "Например: Лёша": "Օրինակ՝ Արամ",
  "Нашли": "Գտնվել է",
  "Не получилось подготовить файл": "Չհաջողվեց պատրաստել ֆայլը",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Չհաջողվեց բարելավել։ Փորձեք ավելացնել մի քանի բառ",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Չի տեղավորվում<span class=\"nfx\">՝ մինչև {0} նիշ</span>",
  "Необязательно: всё уже настроено": "Ոչ պարտադիր՝ ամեն ինչ արդեն կարգավորված է",
  "Ничего не нашлось": "Ոչինչ չգտնվեց",
  "Нужно выбрать": "Պետք է ընտրել",
  "Объём": "Ծավալ",
  "Один раз для всех инструментов": "Մեկ անգամ բոլոր գործիքների համար",
  "Отменить свой вариант": "Չեղարկել ձեր տարբերակը",
  "Отметьте, кто будет в кадре · {0}": "Նշեք, թե ով կլինի կադրում · {0}",
  "Персонажи": "Կերպարներ",
  "Подберём сами": "Մենք կընտրենք",
  "Подбираем варианты": "Ընտրում ենք տարբերակներ",
  "Пожилой": "Տարեց",
  "Поиск стилей": "Ոճերի որոնում",
  "Пока нечего сохранять": "Դեռ պահպանելու բան չկա",
  "Попробуйте другое слово": "Փորձեք այլ բառ",
  "Порядок здесь один": "Այստեղ դասավորությունը մեկն է",
  "Примеры": "Օրինակներ",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Կհեռացվի {0} լուսանկարների հետ միասին։ Վերադարձնել հնարավոր չի լինի։",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Կհեռացվի հարազատներից լուսանկարների հետ միասին։ Վերադարձնել հնարավոր չի լինի։",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Կհեռացվի հարազատներից և {0} լուսանկարների հետ միասին։ Վերադարձնել հնարավոր չի լինի։",
  "Профиль близкого": "Հարազատի պրոֆիլ",
  "Разные ракурсы и выражения": "Տարբեր դիրքեր և արտահայտություններ",
  "Реалистичный": "Իրատեսական",
  "Реалистичный, иллюстрация или 3D": "Իրատեսական, նկարազարդում կամ 3D",
  "Роли": "Դերեր",
  "Роль «{0}»": "«{0}» դեր",
  "Роль «{0}» для женского персонажа": "«{0}» դերը կին կերպարի համար է",
  "Роль «{0}» для мужского персонажа": "«{0}» դերը տղամարդ կերպարի համար է",
  "Роль «{0}» для персонажей своей подборки": "«{0}» դերը իր հավաքածուի կերպարների համար է",
  "Свой вариант": "Ձեր տարբերակը",
  "Скачать здесь не получится": "Այստեղ ներբեռնել հնարավոր չէ",
  "Создайте новый вариант": "Ստեղծեք նոր տարբերակ",
  "Сортировка": "Տեսակավորել",
  "Сохранится в близких": "Կպահպանվի հարազատներում",
  "Сохранить в близких": "Պահպանել հարազատներում",
  "Стало": "Հետո",
  "Только для этой фотосессии": "Միայն այս ֆոտոշարքի համար",
  "Удаление": "Հեռացում",
  "Удалить «{0}» {1}?": "Հեռացնե՞լ «{0}»-ը {1}։",
  "Удалить «{0}» из близких?": "Հեռացնե՞լ «{0}»-ը հարազատներից։",
  "Удалить из близких": "Հեռացնել հարազատներից",
  "Удалить из фотосессии": "Հեռացնել ֆոտոշարքից",
  "Удерживайте, чтобы посмотреть примеры": "Պահեք՝ օրինակները տեսնելու համար",
  "Управление": "Կառավարում",
  "Файл готов. Нажмите ещё раз": "Ֆայլը պատրաստ է։ Սեղմեք ևս մեկ անգամ",
  "Фото до 10 МБ, видео до 200 МБ": "Լուսանկար՝ մինչև 10 ՄԲ, տեսանյութ՝ մինչև 200 ՄԲ",
  "Фрагмент": "Հատված",
  "Что делает? Например: поправляет шарф": "Ի՞նչ է անում։ Օրինակ՝ ուղղում է շարֆը",
  "Что делают в кадре": "Ինչ են անում կադրում",
  "Эта настройка здесь закреплена": "Այս կարգավորումն այստեղ ամրագրված է",
  "Этот голос не умеет переозвучку записи": "Այս ձայնը չի կարող վերահնչյունավորել ձայնագրությունը",
  "вариант «{0}»": "«{0}» տարբերակ",
  "взрослая": "մեծահասակ",
  "взрослый": "մեծահասակ",
  "всё видео умещается": "ամբողջ տեսանյութը տեղավորվում է",
  "выберите": "ընտրեք",
  "до <span class=\"mono\">{0}</span>": "մինչև <span class=\"mono\">{0}</span>",
  "до {0} человек": "մինչև {0} մարդ",
  "до {0} человека": "մինչև {0} մարդ",
  "ещё {0} из {1}": "ևս {0}՝ {1}-ից",
  "женская роль": "կանացի դեր",
  "из фотосессии": "ֆոտոշարքից",
  "из этой фотосессии": "այս ֆոտոշարքից",
  "камера": "տեսախցիկ",
  "максимум {0} секунд": "առավելագույնը {0} վայրկյան",
  "максимум {0} секунда": "առավելագույնը {0} վայրկյան",
  "максимум {0} секунды": "առավելագույնը {0} վայրկյան",
  "можно до <span class=\"mono\">{0}</span>": "կարելի է մինչև <span class=\"mono\">{0}</span>",
  "мужская роль": "տղամարդու դեր",
  "не из подборки этой роли": "այս դերի հավաքածուից չէ",
  "не подходит по возрасту": "տարիքով չի համապատասխանում",
  "не участвует в этой фотосессии": "չի մասնակցում այս ֆոտոշարքին",
  "необязательно": "ոչ պարտադիր",
  "нет фото": "լուսանկար չկա",
  "нужно выбрать": "պետք է ընտրել",
  "нужно: Вы": "պետք է՝ Դուք",
  "персонажи в эту роль не входят": "կերպարներն այս դերում չեն մտնում",
  "питомец": "ընտանի կենդանի",
  "по желанию": "ըստ ցանկության",
  "пожилая": "տարեց",
  "пожилой": "տարեց",
  "ребёнок": "երեխա",
  "роль для взрослого": "դեր մեծահասակի համար",
  "роль для женщины": "դեր կնոջ համար",
  "роль для мужчины": "դեր տղամարդու համար",
  "роль для питомца": "դեր ընտանի կենդանու համար",
  "роль для ребёнка": "դեր երեխայի համար",
  "роль для человека": "դեր մարդու համար",
  "Попробуйте другое слово или сбросьте тему": "Փորձեք այլ բառ կամ մաքրեք թեման",
  "Искать среди {n}+ голосов": "Որոնել {n}+ ձայներում",
  "Голосов: {n}": "Ձայներ՝ {n}",
  "Персонажей: {n}": "Կերպարներ՝ {n}",
  "Голосов: {0}": "Ձայներ՝ {0}",
  "Прослушать {n}": "Լսել {n}",
  "Загружаем ещё {n}": "Բեռնում ենք ևս {n}",
  "{a} из {b}": "{a}՝ {b}-ից",
  "Подборка": "Հավաքածու",
  "Закрыть подборку": "Փակել հավաքածուն",
  "По имени": "Ըստ անվան",
  "Загружаем подборки…": "Բեռնում ենք հավաքածուները…",
  "Не удалось загрузить голоса": "Չհաջողվեց բեռնել ձայները",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Չհաջողվեց նվագարկել նմուշը։ Փորձեք կրկին։",
  "Мой голос": "Իմը",
  "Мои": "Իմը",
  "Своих голосов пока нет": "Ձեր ձայները դեռ չկան",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Կլոնավորեք ձեր ձայնը, և այն կհայտնվի այստեղ։",
  "Клонировать голос": "Կլոնավորել ձայնը",
  "Открыть персонажа {0}": "Բացել {0}",
  "От": "Սկսած",
  "Тренды недели": "Շաբաթվա թրենդները",
  "Голоса, которые быстрее всего набирают заказы": "Ամենաարագ պատվերներ հավաքող ձայները",
  "Мужские": "Արական",
  "Все мужские голоса библиотеки": "Գրադարանի բոլոր արական ձայները",
  "Женские": "Իգական",
  "Все женские голоса библиотеки": "Գրադարանի բոլոր իգական ձայները",
  "Детские": "Մանկական",
  "Детские и мультяшные голоса": "Մանկական և մուլտֆիլմային ձայներ",
  "меню: Озвучка": "Ձայներ",
  "Системная": "Համակարգային",
  "Для аватарки и ленты": "Ավատարի և լրահոսի համար",
  "Как снимок с телефона": "Ինչպես հեռախոսով արված նկար",
  "Для ленты": "Լրահոսի համար",
  "На весь экран телефона": "Հեռախոսի ամբողջ էկրանով",
  "Для обложки и экрана": "Շապիկի և էկրանի համար",
  "Станет голосом по умолчанию для озвучки.": "Կդառնա հնչյունավորման լռելյայն ձայնը։",
  "Когда генерация закончится": "Երբ գեներացիան ավարտվի",
  "Награды и серия": "Պարգևներ և շարք",
  "Напомним о награде за день": "Կհիշեցնենք օրվա պարգևի մասին",
  "Новые шаблоны и стили": "Նոր ձևանմուշներ և ոճեր",
  "Не чаще раза в неделю": "Շաբաթը մեկ անգամից ոչ ավելի",
  "Новости STEOS": "STEOS-ի նորություններ",
  "Только крупные обновления": "Միայն խոշոր թարմացումներ",
  "Тут откроется документ в браузере": "Փաստաթուղթը կբացվի դիտարկիչում",
  "Язык и валюта": "Լեզու և արժույթ",
  "Интерфейс и цены картой": "Ինտերֆեյս և քարտով գներ",
  "новое|новых|новых": "նոր",
  "работа|работы|работ": "աշխատանք",
  "заказ|заказа|заказов": "պատվեր",
  "Счётчики недоступны": "Հաշվիչներն անհասանելի են",
  "История пуста": "Պատմությունը դատարկ է",
  "Не задан": "Նշված չէ",
  "Недоступны": "Անհասանելի են",
  "Срок истёк": "Ժամկետն անցել է",
  "Не удалась": "Չհաջողվեց",
  "Готовится": "Պատրաստվում է",
  "Запрошено": "Պահանջված է",
  "Запрошено {0}": "Պահանջված է {0}",
  "Недоступно": "Անհասանելի է",
  "Пусто": "Դատարկ",
  "Данные Mini App удалены": "Mini App-ի տվյալները ջնջված են",
  "Удаление данных не удалось": "Չհաջողվեց ջնջել տվյալները",
  "Данные удалены частично": "Տվյալները մասամբ ջնջված են",
  "Удаление требует проверки": "Ջնջումը ստուգում է պահանջում",
  "Запрос удаления принят": "Ջնջման հարցումն ընդունված է",
  "Удаляем данные Mini App": "Ջնջում ենք Mini App-ի տվյալները",
  "Удаление данных в очереди": "Ջնջումը հերթում է",
  "STEOS ID сохранён": "STEOS ID-ն պահպանված է",
  "Финансовые квитанции сохранены": "Ֆինանսական անդորրագրերը պահպանված են",
  "Статус удаления не подтверждён": "Ջնջման կարգավիճակը հաստատված չէ",
  "Удаление аккаунта": "Հաշվի ջնջում",
  "Удалить данные Mini App?": "Ջնջե՞լ Mini App-ի տվյալները",
  "Удалить аккаунт?": "Ջնջե՞լ հաշիվը",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Mini App-ի աշխատանքները, ձայները և «Դուք»-ի տարբերակները կջնջվեն։ STEOS ID-ն ու ֆինանսական անդորրագրերը կպահպանվեն։",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Աշխատանքները, ձայները, «Դուք»-ի տարբերակները և Circle-ը կջնջվեն։ Վերականգնել հնարավոր չի լինի։",
  "Удалить данные Mini App": "Ջնջել Mini App-ի տվյալները",
  "Удалить аккаунт": "Ջնջել հաշիվը",
  "Данные Mini App. STEOS ID сохранится": "Mini App-ի տվյալները։ STEOS ID-ն կմնա",
  "Все данные удалятся навсегда": "Բոլոր տվյալները կջնջվեն ընդմիշտ",
  "В прототипе аккаунт не удаляется": "Նախատիպում հաշիվը չի ջնջվում",
  "Автовоспроизведение": "Ինքնանվագարկում",
  "Пример при выборе голоса": "Նմուշ ձայն ընտրելիս",
  "Присылать в чат": "Ուղարկել զրույց",
  "Готовые работы от бота": "Պատրաստ աշխատանքներ բոտից",
  "Уведомления и отклик": "Ծանուցումներ և թրթռոց",
  "Данные": "Տվյալներ",
  "Выгрузить данные": "Արտահանել տվյալները",
  "Настройки создания сейчас только для чтения": "Ստեղծման կարգավորումները հիմա միայն ընթերցման են",
  "Формат по умолчанию": "Լռելյայն ձևաչափ",
  "Для новых фото и видео": "Նոր լուսանկարների և տեսանյութերի համար",
  "На экране создания их можно поменять для одной работы.": "Ստեղծման էկրանին այն կարող եք փոխել մեկ աշխատանքի համար։",
  "Сообщения приходят в чат с ботом": "Հաղորդագրությունները գալիս են բոտի հետ զրույցում",
  "Бот напишет только в ответ на действия": "Բոտը կգրի միայն ի պատասխան գործողությունների",
  "Уведомления пока недоступны": "Ծանուցումները դեռ հասանելի չեն",
  "Вибрация": "Թրթռոց",
  "Лёгкий отклик на нажатия": "Թեթև արձագանք հպումներին",
  "Выгрузка данных": "Տվյալների արտահանում",
  "Выгрузка запрошена": "Արտահանումը պահանջված է",
  "Пришлём архив в чат в течение суток": "Արխիվը կուղարկենք զրույց 24 ժամվա ընթացքում",
  "Настройки и доступные текстовые данные аккаунта": "Կարգավորումներ և հաշվի հասանելի տեքստային տվյալներ",
  "Ссылка на архив придёт в чат с ботом": "Արխիվի հղումը կգա բոտի հետ զրույցում",
  "Готовые работы и заказы": "Պատրաստ աշխատանքներ և պատվերներ",
  "Клоны и записи образцов": "Կլոններ և նմուշների ձայնագրություններ",
  "Ваши фото и варианты себя": "Ձեր լուսանկարները և ձեր տարբերակները",
  "Люди и питомцы из фотосессий": "Լուսանկարահանումների մարդիկ և ընտանի կենդանիներ",
  "Запросить выгрузку": "Պահանջել արտահանում",
  "Готовим архив": "Պատրաստում ենք արխիվը",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Կտևի մի քանի րոպե։ Կարող եք փակել, արտահանումը կշարունակվի",
  "Срок хранения архива истёк": "Արխիվի պահպանման ժամկետն անցել է",
  "Запросите новую выгрузку данных": "Պահանջեք տվյալների նոր արտահանում",
  "Архив не собрался": "Արխիվը չհավաքվեց",
  "Запросите выгрузку ещё раз": "Կրկին պահանջեք արտահանումը",
  "Не вошли: {0}": "Չեն ներառվել՝ {0}",
  "Вошли частично: {0}": "Մասամբ ներառված՝ {0}",
  "Не входят в выгрузку: {0}": "Արտահանման մեջ չեն մտնում՝ {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Տվյալների մի մասն անհասանելի է։ Ճշգրիտ կազմը նշված է արխիվի manifest.json-ում",
  "Архив готов, но не полностью": "Արխիվը պատրաստ է, բայց ոչ ամբողջությամբ",
  "Архив готов": "Արխիվը պատրաստ է",
  "Скачать можно до {0}": "Կարելի է ներբեռնել մինչև {0}",
  "Архив в формате ZIP": "ZIP արխիվ",
  "Скачать архив": "Ներբեռնել արխիվը",
  "Счётчики истории не загрузились": "Պատմության հաշվիչները չբեռնվեցին",
  "Загружаем историю": "Բեռնում ենք պատմությունը",
  "Проверьте связь и повторите загрузку": "Ստուգեք կապը և կրկնեք",
  "История очищена": "Պատմությունը մաքրված է",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Ձայները, «Դուք»-ի տարբերակները, մտերիմները և Circle-ը տեղում են",
  "Здесь появятся работы, когда вы что-то создадите": "Աշխատանքները կհայտնվեն այստեղ, երբ ինչ-որ բան ստեղծեք",
  "Раздел «История»": "«Պատմություն» բաժին",
  "Работы": "Աշխատանքներ",
  "Фото, видео, кружки и озвучки": "Լուսանկարներ, տեսանյութեր, շրջանակներ և հնչյունավորումներ",
  "Заказы": "Պատվերներ",
  "Параметры и статусы генераций": "Գեներացիաների պարամետրեր և կարգավիճակներ",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Ձայները, «Դուք»-ի տարբերակները, մտերիմները և Circle-ը կմնան։",
  "Удалить работы и заказы": "Ջնջել աշխատանքները և պատվերները",
  "Без возможности восстановления": "Առանց վերականգնման հնարավորության",
  "Подтверждение удаления": "Ջնջման հաստատում",
  "Попробовать: {0}": "Փորձել՝ {0}",
  "Обновление": "Թարմացում",
  "Загружаем «Что нового»": "Բեռնում ենք «Ինչ նոր կա»",
  "Новых обновлений пока нет": "Նոր թարմացումներ դեռ չկան",
  "Уведомления сейчас не сохранить": "Ծանուցումները հիմա չեն պահպանվում",
  "Настройки сейчас только для чтения": "Կարգավորումները հիմա միայն ընթերցման են",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Արտահանումը չպահանջվեց։ Փորձեք կրկին",
  "Удалить всю историю?": "Ջնջե՞լ ամբողջ պատմությունը",
  "{0}. Вернуть не получится.": "{0}։ Վերականգնել հնարավոր չի լինի։",
  "История не очистилась. Попробуйте ещё раз": "Պատմությունը չմաքրվեց։ Փորձեք կրկին",
  "Удаление не началось. Попробуйте ещё раз": "Ջնջումը չսկսվեց։ Փորձեք կրկին",
  "Не удалось загрузить настройки": "Չհաջողվեց բեռնել կարգավորումները",
  "«Что нового» не загрузилось": "«Ինչ նոր կա»-ն չբեռնվեց",
  "Сохранение настроек сейчас недоступно": "Կարգավորումների պահպանումը հիմա հասանելի չէ",
  "Настройки уже изменились, показываем актуальные": "Կարգավորումներն արդեն փոխվել են, ցույց ենք տալիս ընթացիկները",
  "Не удалось сохранить. Попробуйте ещё раз": "Չհաջողվեց պահպանել։ Փորձեք կրկին",
  "Настройки, ресурсы и история": "Կարգավորումներ, ռեսուրսներ և պատմություն",
  "Данные Mini App": "Mini App-ի տվյալներ",
  "Учётная запись и финансовые данные STEOS ID": "STEOS ID հաշիվ և ֆինանսական տվյալներ",
  "Переписка с ботом": "Նամակագրություն բոտի հետ",
  "Фото, аудио, видео и модели": "Լուսանկարներ, աուդիո, տեսանյութեր և մոդելներ",
  "Данные других продуктов STEOS": "Այլ STEOS արտադրանքների տվյալներ",
  "Рубли": "Ռուբլի",
  "Драмы": "Դրամ",
  "Евро": "Եվրո",
  "Доллары": "Դոլար",
  "Другие языки": "Այլ լեզուներ",
  "Интерфейс и сообщения бота": "Ինտերֆեյս և բոտի հաղորդագրություններ",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Քարտով գները կցուցադրենք այս արժույթով։ Telegram Stars-ը ամենուր նույնն է։",
  "сегодня, {0}": "այսօր, {0}",
  "вчера, {0}": "երեկ, {0}",
  "Старт": "Start",
  "Плюс": "Plus",
  "Про": "Pro",
  "Картой или СБП": "Քարտ կամ SBP",
  "СБП только для РФ": "SBP-ն միայն ՌԴ-ի համար է",
  "1 месяц": "1 ամիս",
  "3 месяца": "3 ամիս",
  "6 месяцев": "6 ամիս",
  "Год": "Տարի",
  "год": "մեկ տարի",
  "С днём рождения": "Ծնունդդ շնորհավոր",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Ծնունդդ շնորհավոր։ Թող ամեն մտահղացում ստացվի առաջին անգամից",
  "Просто так": "Հենց այնպես",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Հենց այնպես։ Թող ավելի շատ շրջանակներ և զվարճալի ձայներ լինեն",
  "Спасибо": "Շնորհակալություն",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Շնորհակալ եմ, որ կողքիս ես։ Սա փոքրիկ նվեր է ինձնից",
  "С праздником": "Շնորհավոր տոնդ",
  "С праздником. Твори, снимай и удивляй": "Շնորհավոր տոնդ։ Ստեղծիր, նկարիր և զարմացրու",
  "Для блога": "Բլոգի համար",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Քո բլոգի համար՝ թող տեսանյութերն ավելի հաճախ ու հեշտ ստացվեն",
  "Удачи": "Հաջողություն",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Հաջողություն նոր նախագծում։ Թող ձայնն ու պատկերը լինեն ճիշտ այնպես, ինչպես մտածել ես",
  "картой": "քարտով",
  "оплата картой каждый месяц": "վճարում քարտով ամեն ամիս",
  "оплата картой за {0}": "վճարում քարտով {0}-ի համար",
  "{0} в месяц": "{0} ամսական",
  "{0} за {1}": "{0}՝ {1}-ի համար",
  "кружок|кружка|кружков": "տեսահաղորդագրություն",
  "рилс|рилса|рилсов": "ռիլս",
  "свой голос|своих голоса|своих голосов": "սեփական ձայն",
  "своего голоса|своих голосов|своих голосов": "սեփական ձայն",
  "день|дня|дней": "օր",
  "звезда|звезды|звёзд": "աստղ",
  "Подписаться на {0}": "Բաժանորդագրվել {0}",
  "Продлевается каждый месяц, отмена в любой момент": "Երկարաձգվում է ամեն ամիս, կարող եք չեղարկել ցանկացած պահի",
  "Без автопродления, Circle приходят каждый месяц": "Առանց ինքնաերկարաձգման, Circle-ը գալիս է ամեն ամիս",
  "Перейти на {0}": "Անցնել {0}-ին",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C կգա անմիջապես, իսկ {1}-ը այլևս չի երկարաձգվի",
  "Сразу придут {0} C": "{0} C կգա անմիջապես",
  "Перейти на {0} с {1}": "Անցնել {0}-ին {1}-ից",
  "До {0} остаётся {1}, потом {2}": "Մինչև {0} մնում է {1}-ը, հետո {2}",
  "Продлить на {0}": "Երկարաձգել {0}",
  "Ещё {0} после {1}, без автопродления": "Եվս {0} {1}-ից հետո, առանց ինքնաերկարաձգման",
  "Следующее списание {0}, {1}": "Հաջորդ գանձումը՝ {0}, {1}",
  "Способ оплаты": "Վճարման եղանակ",
  "Звёздами": "Աստղերով",
  "Тестовая оплата": "Փորձնական վճարում",
  "Звёзды и деньги не списываются": "Աստղեր և գումար չեն գանձվում",
  "Оплата картой скоро": "Քարտով վճարումը շուտով",
  "Ваш тариф": "Ձեր սակագինը",
  "выгоднее на {0}%": "{0}%-ով շահավետ",
  "{0} C в месяц": "{0} C ամսական",
  "или": "կամ",
  "Что сотворим в этом месяце?": "Ի՞նչ կստեղծենք այս ամիս",
  "Готовы творить без пауз?": "Պատրա՞ստ եք ստեղծել առանց դադարի",
  "Ваш тариф {0}": "Ձեր սակագինը՝ {0}",
  "{0} C каждый месяц": "{0} C ամեն ամիս",
  "До {0} {1}": "Մինչև {0} {1}",
  "Пакеты Circle, если не хватит": "Circle փաթեթներ, եթե չբավականացնի",
  "{0} включает": "{0}-ը ներառում է",
  "Сравнить": "Համեմատել",
  "Помесячно": "Ամսական",
  "Выгода {0}": "Խնայում՝ {0}",
  "Одним платежом": "Մեկ վճարումով",
  "{0} с {1}": "{0}՝ {1}-ից",
  "Оставить {0}": "Պահել {0}-ը",
  "Продлить {0}": "Երկարաձգել {0}-ը",
  "Продлить": "Երկարաձգել",
  "Включить продление": "Միացնել երկարաձգումը",
  "Возобновить {0}": "Վերսկսել {0}-ը",
  "Возобновить": "Վերսկսել",
  "Оплата пока не подключена": "Վճարումը դեռ միացված չէ",
  "Сейчас недоступно": "Հիմա հասանելի չէ",
  "Переход на {0} на {1}": "Անցում {0}-ին {1}",
  "Переход на {0}": "Անցում {0}-ին",
  "Продление {0} на {1}": "{0}-ի երկարաձգում {1}",
  "Подписка {0} на {1}": "{0} բաժանորդագրություն {1}",
  "Как удобнее оплатить": "Ինչպե՞ս վճարել",
  "Подарок друга": "Ընկերոջ նվեր",
  "{0} на первый пакет {1} после подписки": "{0} առաջին փաթեթի վրա {1} բաժանորդագրվելուց հետո",
  "Не загрузилось": "Չբեռնվեց",
  "Прошлую операцию не проверить": "Նախորդ գործողությունը հնարավոր չէ ստուգել",
  "разрешите хранение данных и откройте раздел снова": "թույլատրեք տվյալների պահպանումը և նորից բացեք բաժինը",
  "Оплата требует проверки": "Վճարումը ստուգում է պահանջում",
  "Исход подтверждения оплаты ещё неизвестен": "Վճարման հաստատման արդյունքը դեռ անհայտ է",
  "Исход отмены счёта неизвестен": "Հաշվի չեղարկման արդյունքն անհայտ է",
  "Ждём подтверждения оплаты": "Սպասում ենք վճարման հաստատմանը",
  "Исход прошлой операции неизвестен": "Նախորդ գործողության արդյունքն անհայտ է",
  "проверьте его перед новой покупкой": "ստուգեք այն նոր գնումից առաջ",
  "Проверить": "Ստուգել",
  "Открыть оплату": "Բացել վճարումը",
  "Отменить счёт": "Չեղարկել հաշիվը",
  "Продление отменено": "Երկարաձգումը չեղարկված է",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Կարող է գալ հին հաշվով հաղորդագրություն։ Այն չի հաստատում նոր բաժանորդագրությունը",
  "Продление требует проверки": "Երկարաձգումը ստուգում է պահանջում",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Հաշիվը հաստատված չէ։ Թարմացրեք տվյալները կամ դիմեք աջակցությանը",
  "Не удалось подготовить счёт": "Չհաջողվեց պատրաստել հաշիվը",
  "Сервер повторит проверку. Текущие права не меняются": "Սերվերը կկրկնի ստուգումը։ Ընթացիկ իրավունքները չեն փոխվում",
  "Счёт отправлен": "Հաշիվն ուղարկված է",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Բոտը հաշիվ է ուղարկել։ Բաժանորդագրությունը կսկսվի հաստատված վճարումից հետո",
  "Счёт подготовлен": "Հաշիվը պատրաստված է",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Փոխանցված է բոտին։ Առաքումը և վճարումը դեռ հաստատված չեն",
  "Срок счёта истёк": "Հաշվի ժամկետն անցել է",
  "Продление не оплачено. Выберите тариф ещё раз": "Երկարաձգումը վճարված չէ։ Կրկին ընտրեք սակագինը",
  "Запланированное продление отменено": "Պլանավորված երկարաձգումը չեղարկված է",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Ընթացիկ սակագինը չի փոխվում։ Նոր բաժանորդագրության համար կպահանջվի առանձին վճարում",
  "Продление запланировано": "Երկարաձգումը պլանավորված է",
  "Счёт на свою подписку придёт в конце подарочного месяца": "Ձեր բաժանորդագրության հաշիվը կգա նվերի ամսվա վերջում",
  "Подарок ещё действует": "Նվերը դեռ գործում է",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "Ամսական բաժանորդագրությունը հասանելի կլինի դրա ավարտից հետո։ Հիմա կարող եք երկարաձգել 3 կամ 12 ամսով",
  "выберите другой тариф или срок": "ընտրեք այլ սակագին կամ ժամկետ",
  "−{0}% на первый пакет · ещё {1}": "−{0}% առաջին փաթեթի վրա · ևս {1}",
  "Circle из пакетов не сгорают": "Փաթեթների Circle-ը չի այրվում",
  "Подарить другу": "Նվիրել ընկերոջը",
  "С открыткой, без продления": "Բացիկով, առանց երկարաձգման",
  "Промокод {0}": "Պրոմոկոդ {0}",
  "{0} C, сгорят {1}": "{0} C, կայրվեն {1}",
  "Промокод применён": "Պրոմոկոդը կիրառված է",
  "{0} C и {1} на первый пакет": "{0} C և {1} առաջին փաթեթի վրա",
  "после подписки": "բաժանորդագրվելուց հետո",
  "Вы пришли по ссылке партнёра": "Դուք եկել եք գործընկերոջ հղումով",
  "привязка уже действует": "կապն արդեն գործում է",
  "Есть промокод?": "Պրոմոկոդ ունե՞ք",
  "Загружаем тарифы": "Բեռնում ենք սակագները",
  "Счёт придёт {0}": "Հաշիվը կգա {0}",
  "Счёт придёт в конце текущего срока": "Հաշիվը կգա ընթացիկ ժամկետի վերջում",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Նոր սակագինը կսկսվի վճարումից հետո։ Հիմա ոչինչ չի գանձվում։",
  "Оплата подтверждена": "Վճարումը հաստատված է",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "Վճարված ժամանակահատվածն արդեն ավարտվել է։ Անցած ժամանակի համար Circle չի հաշվարկվում։",
  "Баланс пополнен": "Մնացորդը համալրված է",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Այժմ մնացորդում {0} C է։ Փաթեթների Circle-ը չի այրվում",
  "следующие {0} C придут {1}": "հաջորդ {0} C-ն կգա {1}",
  "До этой даты действует {0}": "Մինչ այդ ամսաթիվը գործում է {0}-ը",
  "{0} продлён до {1}": "{0}-ը երկարաձգված է մինչև {1}",
  "Circle приходят каждый месяц, {0}": "Circle-ը գալիս է ամեն ամիս, {0}",
  "Тариф {0} подключён": "{0} սակագինը միացված է",
  "Подписка {0} оформлена": "{0} բաժանորդագրությունը ձևակերպված է",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "Վճարված է մինչև {0}։ Circle-ը գալիս է ամեն ամիս, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Փորձնական բաժանորդագրությունը գործում է մինչև {0}։ Ոչինչ չի գանձվում",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle-ը գործում է մինչև {0}, նույն օրը հաջորդ գանձումը՝ {1}",
  "Circle действуют до {0}, продление выключено": "Circle-ը գործում է մինչև {0}, երկարաձգումն անջատված է",
  "В месяц": "Ամսական",
  "Кружки или фото": "Շրջանակներ կամ լուսանկարներ",
  "Видео говорит": "Տեսանյութը խոսում է",
  "Рилсы": "Ռիլսեր",
  "Сравнение тарифов": "Սակագների համեմատություն",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Ցանկացած սակագնում՝ {0} {1} {2}-ի փոխարեն, ստուդիայի բոլոր գործիքները և Circle փաթեթներ",
  "Следующее списание": "Հաջորդ գանձումը",
  "Сумма": "Գումար",
  "Тестовая, без списаний": "Փորձնական, առանց գանձումների",
  "Картой": "Քարտով",
  "Оплачено до": "Վճարված է մինչև",
  "Действует до": "Գործում է մինչև",
  "Потом": "Հետո",
  "Продление": "Երկարաձգում",
  "Счёт на {0} запланирован": "{0}-ի հաշիվը պլանավորված է",
  "подписку": "բաժանորդագրություն",
  "Придёт {0}. Новый тариф начнётся после оплаты": "Կգա {0}։ Նոր սակագինը կսկսվի վճարումից հետո",
  "Отменить": "Չեղարկել",
  "Отменить подписку": "Չեղարկել բաժանորդագրությունը",
  "Тариф останется до {0}": "Սակագինը կմնա մինչև {0}",
  "Потом тариф {0}": "Հետո {0} սակագինը",
  "Подарок на месяц": "Մեկամսյա նվեր",
  "Оплачено вперёд": "Վճարված է նախապես",
  "Подписка {0}": "{0} բաժանորդագրություն",
  "Условия тарифа уточняются": "Սակագնի պայմանները ճշտվում են",
  "Сменить тариф": "Փոխել սակագինը",
  "Отмена подписки": "Բաժանորդագրության չեղարկում",
  "Этот переход сейчас недоступен": "Այս անցումը հիմա հասանելի չէ",
  "Переход уже назначен": "Անցումն արդեն նշանակված է",
  "Выберите другой тариф": "Ընտրեք այլ սակագին",
  "С {0} начнётся этот тариф": "Այս սակագինը կսկսվի {0}",
  "Это ваш тариф": "Սա ձեր սակագինն է",
  "К подписке": "Վերադառնալ բաժանորդագրությանը",
  "Сейчас {0}, {1}": "Հիմա՝ {0}, {1}",
  "Латиница, цифры и «_»": "Լատինատառ, թվեր և «_»",
  "Ник начинается с буквы": "Անունը սկսվում է տառով",
  "Не короче 5 знаков": "Առնվազն 5 նիշ",
  "Не длиннее 32 знаков": "Առավելագույնը 32 նիշ",
  "Ник не кончается на _": "Անունը չի ավարտվում _-ով",
  "Это ваш ник": "Սա ձեր անունն է",
  "Сначала проверьте прежнюю операцию": "Նախ ստուգեք նախորդ գործողությունը",
  "Подарок сейчас недоступен": "Նվերը հիմա հասանելի չէ",
  "Укажите ник друга в Telegram": "Նշեք ընկերոջ Telegram-ի անունը",
  "Проверьте ник": "Ստուգեք անունը",
  "Друг увидит: {0}": "Ընկերը կտեսնի՝ {0}",
  "Подарок придёт без имени": "Նվերը կգա առանց անվան",
  "{0} дарит вам": "{0}-ը նվիրում է ձեզ",
  "вам подарили": "ձեզ նվիրել են",
  "Вам подарили": "Ձեզ նվիրել են",
  "{0} подписку STEOS {1} на месяц.": "{0} STEOS {1} բաժանորդագրություն մեկ ամսով։",
  "Забрать подарок": "Ստանալ նվերը",
  "От друга": "Ընկերոջից",
  "{0} C и {1} {2}": "{0} C և {1} {2}",
  "Подарить {0}": "Նվիրել {0}",
  "Тестовый подарок: звёзды и деньги не списываются": "Փորձնական նվեր․ ոչինչ չի գանձվում",
  "На месяц, без продления": "Մեկ ամսով, առանց երկարաձգման",
  "Тариф подарка": "Նվերի սակագին",
  "Кому": "Ում",
  "ник друга в Telegram": "ընկերոջ Telegram անունը",
  "Ник друга в Telegram": "Ընկերոջ Telegram անունը",
  "Пожелание": "Մաղթանք",
  "Пара тёплых слов, по желанию": "Մի քանի ջերմ խոսք, ըստ ցանկության",
  "Подписать от меня": "Ստորագրել իմ անունից",
  "Так увидит друг": "Այսպես կտեսնի ընկերը",
  "Подарок оформлен для {0}": "Նվերը ձևակերպված է {0}-ի համար",
  "Подарок отправлен {0}": "Նվերն ուղարկված է {0}-ին",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Բոտն ուղարկել է բացիկ՝ «Ստանալ նվերը» հղումով։",
  "Месяц {0} начнётся, когда друг заберёт подарок": "{0}-ի ամիսը կսկսվի, երբ ընկերը ստանա նվերը",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Ընկերը դեռ չի՞ բացել STEOS-ը։ Ինքներդ ուղարկեք բացիկը",
  "Переслать": "Փոխանցել",
  "Загружаем подарок": "Բեռնում ենք նվերը",
  "Вам подарок": "Նվեր ձեզ",
  "Подписка STEOS на месяц": "STEOS բաժանորդագրություն մեկ ամսով",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Այս նվերը նախատեսված է {0}-ի համար։ Ուղարկեք նրան հղումով բացիկը։",
  "Подарок уже получен": "Նվերն արդեն ստացված է",
  "Подарок добавлен": "Նվերն ավելացված է",
  "Подписка {0} подключена": "{0} բաժանորդագրությունը միացված է",
  "Circle подарка сгорят {0}": "Նվերի Circle-ը կայրվի {0}",
  "Месяц без продления, Circle действуют до {0}": "Մեկ ամիս առանց երկարաձգման, Circle-ը գործում է մինչև {0}",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Դուք արդեն ունեք {0}․ նվերը կավելացնի {1} C, որը կայրվի մեկ ամսից",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "Կգա {0} C և {1} {2}։ Բաժանորդագրությունը ինքնուրույն չի երկարաձգվի",
  "За последние 7 дней": "Վերջին 7 օրը",
  "Потрачено": "Ծախսված",
  "Начислено": "Հաշվեգրված",
  "Пакеты пока недоступны": "Փաթեթները դեռ հասանելի չեն",
  "Пакет": "Փաթեթ",
  "Оплата пакетов пока не подключена": "Փաթեթների վճարումը դեռ միացված չէ",
  "Введите промокод": "Մուտքագրեք պրոմոկոդը",
  "Применить": "Կիրառել",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Գործընկերոջ պրոմոկոդը գործում է մինչև առաջին գնումը, STEOS-ինը կարելի է կիրառել մեկ անգամ",
  "От партнёра или от STEOS": "Գործընկերոջից կամ STEOS-ից",
  "Например, ANNA24": "Օրինակ՝ ANNA24",
  "Не удалось загрузить операции": "Չհաջողվեց բեռնել գործարքները",
  "Начисление": "Հաշվեգրում",
  "Списание": "Գանձում",
  "Загружаем операции": "Բեռնում ենք գործարքները",
  "Журнал STEOS ID": "STEOS ID մատյան",
  "Операций пока нет": "Գործարքներ դեռ չկան",
  "Применение не подтверждено. Проверьте прежний запрос": "Կիրառումը հաստատված չէ։ Ստուգեք նախորդ հարցումը",
  "Отменить подписку?": "Չեղարկե՞լ բաժանորդագրությունը",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} սակագինը կմնա մինչև {1}, հետո չի երկարաձգվի։",
  "Оставить": "Թողնել",
  "Не удалось подготовить открытку": "Չհաջողվեց պատրաստել բացիկը",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Բացեք Mini App-ը Telegram-ում՝ բացիկը փոխանցելու համար",
  "Отправка отменена": "Ուղարկումը չեղարկված է",
  "Ссылка на подарок скопирована": "Նվերի հղումը պատճենված է",
  "Не получилось. Попробуйте ещё раз": "Չստացվեց։ Փորձեք կրկին",
  "Счёт отменён": "Հաշիվը չեղարկված է",
  "Оплата не завершена": "Վճարումն ավարտված չէ",
  "Подтверждение оплаты": "Վճարման հաստատում",
  "Проверяем подтверждение оплаты": "Ստուգում ենք վճարման հաստատումը",
  "Проверяем отмену счёта": "Ստուգում ենք հաշվի չեղարկումը",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram-ը սկսել է հաշվի հաստատումը։ Արդյունքը դեռ անհայտ է։ Մի վճարեք կրկին․ ստուգեք այս հաշիվը կամ դիմեք աջակցությանը։",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Նվերը կձևակերպվի սերվերի հաստատումից հետո։ Ամիսը կսկսվի, երբ ընկերը ստանա նվերը։ Վճարման պատուհանից վերադառնալը դեռ չի նշանակում, որ վճարումն ավարտված է։",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle-ը կմուտքագրվի սերվերի հաստատումից հետո։ Վճարման պատուհանից վերադառնալը դեռ չի նշանակում, որ վճարումն ավարտված է։",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle-ը և բաժանորդագրությունը կհայտնվեն սերվերի հաստատումից հետո։ Վճարման պատուհանից վերադառնալը դեռ չի նշանակում, որ վճարումն ավարտված է։",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Չհաջողվեց բացել վճարումը։ Ստուգեք նախորդ հարցումը",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Բացեք Mini App-ը Telegram-ում՝ աստղերով վճարելու համար",
  "Оплата ещё не подтверждена сервером": "Սերվերը դեռ չի հաստատել վճարումը",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "Բացիկը պատրաստ է։ Բացեք Mini App-ը Telegram-ում՝ այն փոխանցելու համար",
  "Отменить счёт?": "Չեղարկե՞լ հաշիվը",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Կչեղարկվի միայն այս չվճարված հաշիվը։ Ընթացիկ բաժանորդագրությունը կմնա։ Եթե վճարումն արդեն հաստատվում է, սերվերը չի թույլատրի չեղարկում։",
  "Вернуться к оплате": "Վերադառնալ վճարմանը",
  "{0} на первый пакет после подписки": "{0} առաջին փաթեթի վրա բաժանորդագրվելուց հետո",
  "{0} на первый пакет, ещё {1}": "{0} առաջին փաթեթի վրա, ևս {1}",
  "{0} на первый пакет": "{0} առաջին փաթեթի վրա",
  "Промокод {0} применён": "{0} պրոմոկոդը կիրառված է",
  "Circle сгорят {0}": "Circle-ը կայրվի {0}",
  "Circle начислены": "Circle-ը հաշվեգրված է",
  "Привязка к партнёру подтверждена": "Գործընկերոջ հետ կապը հաստատված է",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Զեղչ՝ {0}։ Բոնուսային Circle-ը կայրվի {1}",
  "Привязка к партнёру действует": "Գործընկերոջ հետ կապը գործում է",
  "{0} C и {1}": "{0} C և {1}",
  "Открытка передана боту для доставки.": "Բացիկը փոխանցված է բոտին առաքման համար։",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Բոտը պատրաստում է բացիկի առաքումը։ Կարող եք այն ինքներդ փոխանցել։",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Բացիկի առաքումը հաստատված չէ։ Կարող եք այն ինքներդ փոխանցել։",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Նախ ծախսվում է ժամկետով Circle-ը՝ բոնուսային և բաժանորդագրության, հետո մնացածը, իսկ դուրս բերվողը՝ վերջում։",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Ստացողը չի գտնվել STEOS-ի օգտատերերի մեջ։ Ստուգեք անունը կամ խնդրեք ընկերոջը գործարկել բոտը։",
  "Условия оплаты изменились. Обновите данные.": "Վճարման պայմանները փոխվել են։ Թարմացրեք տվյալները։",
  "Эту открытку может переслать только отправитель подарка.": "Այս բացիկը կարող է փոխանցել միայն նվերն ուղարկողը։",
  "Откройте чат с ботом и попробуйте ещё раз.": "Բացեք զրույցը բոտի հետ և փորձեք կրկին։",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Ստացողին առաքումը հաստատված չէ։ Ինքներդ փոխանցեք բացիկը։",
  "Предложение не найдено. Обновите данные.": "Առաջարկը չի գտնվել։ Թարմացրեք տվյալները։",
  "Такого промокода нет": "Այդպիսի պրոմոկոդ չկա",
  "Срок действия промокода закончился": "Պրոմոկոդի ժամկետն ավարտվել է",
  "Этот промокод пока не действует": "Այս պրոմոկոդը դեռ չի գործում",
  "Вы уже активировали этот промокод": "Դուք արդեն ակտիվացրել եք այս պրոմոկոդը",
  "Промокод больше не действует": "Պրոմոկոդն այլևս չի գործում",
  "Это ваш промокод": "Սա ձեր պրոմոկոդն է",
  "Партнёрские промокоды работают только до первой покупки": "Գործընկերային պրոմոկոդները գործում են միայն մինչև առաջին գնումը",
  "Промокод партнёра временно недоступен": "Գործընկերոջ պրոմոկոդը ժամանակավորապես հասանելի չէ",
  "Вы уже привязаны к партнёру": "Դուք արդեն կապված եք գործընկերոջ հետ",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Ստացողը փոխվել է։ Չեղարկեք նախորդ չվճարված հաշիվը և ստուգեք անունը նոր գնումից առաջ։",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Մաղթանքը պետք է լինի մինչև 200 նիշ, առանց կառավարման նիշերի։",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Ստուգեք անունը․ ստացողը պետք է գործարկած լինի STEOS-ը, իսկ ինքներդ ձեզ նվիրել չի կարելի",
  "Получатель сейчас занят. Повторите позже": "Ստացողը հիմա զբաղված է։ Կրկնեք ավելի ուշ",
  "Подарок не найден": "Նվերը չի գտնվել",
  "Этот подарок предназначен другому пользователю": "Այս նվերը նախատեսված է այլ օգտատիրոջ",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Չհաջողվեց հաստատել երկարաձգման պայմանները։ Թարմացրեք սակագները։",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Բաժանորդագրությունը փոխվել է։ Թարմացրեք տվյալները նոր երկարաձգումից առաջ։",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Երկարաձգումն արդեն պլանավորված է։ Այն կարելի է չեղարկել բաժանորդագրության կառավարումում։",
  "Запланированное продление отменено. Обновите данные.": "Պլանավորված երկարաձգումը չեղարկված է։ Թարմացրեք տվյալները։",
  "Счёт будет доступен в конце текущего срока.": "Հաշիվը հասանելի կլինի ընթացիկ ժամկետի վերջում։",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "Ամսական բաժանորդագրությունը հասանելի կլինի նվերի ավարտից հետո։ Հիմա կարող եք երկարաձգել 3 կամ 12 ամսով։",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "Բաժանորդագրության նախորդ փոփոխությունը դեռ ստուգվում է։ Կրկնեք ստուգումը։",
  "Изменение подписки ещё не подтверждено Telegram.": "Telegram-ը դեռ չի հաստատել բաժանորդագրության փոփոխությունը։",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Բաժանորդագրությունը փոխվել է։ Թարմացրեք տվյալները և կրկնեք ստուգումը։",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "Զեղչն արդեն ամրագրված է նախորդ հաշվին։ Ստուգեք դրա վճարումը։",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "Հաշիվն արդեն հաստատվում է կամ չի կարող չեղարկվել։ Ստուգեք վճարման արդյունքը։",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Վճարումը ստուգում է պահանջում։ Սերվերը պահպանել է վճարումը, բայց իրավունքները դեռ հաստատված չեն։ Մի վճարեք կրկին՝ ստուգեք ավելի ուշ կամ դիմեք աջակցությանը։",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Հաշիվը չեղարկված է։ Դրա համար բաժանորդագրություն և Circle չեն հաշվարկվել։ Կարող եք ընտրել նոր վճարում։",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Վճարումն ավարտված չէ։ Գումարը և Circle-ը հաստատված չեն․ կարող եք սկսել նոր վճարում։",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "Բացիկը պատրաստվում է։ Սեղմեք «Ստուգել»՝ նախորդ հարցման արդյունքը ստանալու համար։",
  "Подарить подписку": "Նվիրել բաժանորդագրություն",
  "Оплата подписки": "Բաժանորդագրության վճարում",
  "Итог оплаты": "Վճարման արդյունք",
  "Подарок": "Նվեր",
  "Пакет Circle": "Circle փաթեթ",
  "лента: Хит": "Հիթ",
  "настройки: Очистить историю": "Մաքրել",
  "Разделы, которых нет в меню": "Մենյուում չեղած բաժիններ",
  "Базовый": "Հիմնական",
  "Продвинутый": "Առաջադեմ",
  "Амбассадор": "Դեսպան",
  "задание ждёт|задания ждут|заданий ждут": "առաջադրանք է սպասում",
  ", до +{0} C": ", մինչև +{0} C",
  "Серия {0}, задания на сегодня": "{0} շարք, այսօրվա առաջադրանքներ",
  "Задания на каждый день": "Ամենօրյա առաջադրանքներ",
  "Всё созданное в одном месте": "Ստեղծածը մեկ տեղում",
  "Пока пусто: всё созданное будет здесь": "Առայժմ դատարկ է․ ստեղծածն այստեղ կլինի",
  "{0}, последняя {1}": "{0}, վերջինը՝ {1}",
  "тариф {0}": "{0} սակագին",
  "без подписки": "առանց բաժանորդագրության",
  "{0}, {1}% с покупок": "{0}, գնումների {1}%",
  "{0} уровень, {1}% с покупок": "{0} մակարդակ, գնումների {1}%",
  "До {0}% с покупок друзей": "Մինչև {0}% ընկերների գնումներից",
  "ИИ-агент ответит сразу": "ԱԲ գործակալը կպատասխանի անմիջապես",
  "Черновики ролей и реплик": "Դերերի և ռեպլիկների սևագրեր",
  "Тема, язык и валюта": "Թեմա, լեզու և արժույթ",
  "{0} ждут": "{0} սպասում են",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Այստեղ Telegram-ը կբացի զրույցի ընտրությունը․ բոտը կավելացվի խումբ և կաշխատի այնտեղ",
  "голос {0}": "ձայն՝ {0}",
  "Искать в {0} {1}": "Որոնել {0} {1}",
  "работе|работах|работах": "աշխատանքում",
  "Не прошло модерацию": "Չանցավ մոդերացիա",
  "Бесплатно": "Անվճար",
  "Цена недоступна": "Գինը հասանելի չէ",
  "Не удалось загрузить историю": "Չհաջողվեց բեռնել պատմությունը",
  "Проверьте написание или поищите по номеру заказа": "Ստուգեք ուղղագրությունը կամ որոնեք պատվերի համարով",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Ստուգեք ուղղագրությունը կամ որոնեք անունով, ձայնով կամ կերպարով",
  "Сбросить поиск": "Մաքրել որոնումը",
  "В этой вкладке пока пусто": "Այս ներդիրում դեռ ոչինչ չկա",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Նշեք աշխատանքները սրտիկով, որպեսզի արագ գտնեք դրանք այստեղ",
  "Новые работы этого вида появятся здесь сами": "Այս տեսակի նոր աշխատանքներն ինքնաբերաբար կհայտնվեն այստեղ",
  "Показать все": "Ցույց տալ բոլորը",
  "Поиск по истории": "Որոնում պատմության մեջ",
  "Что показать": "Ինչ ցույց տալ",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Ձեր ստեղծած շրջանիկները, լուսանկարները, տեսանյութերը, հնչյունավորումներն ու տեքստերը",
  "Открыть студию": "Բացել Ստուդիան",
  "{0}: шаг {1} из {2}. Открыть": "{0}՝ քայլ {1}/{2}։ Բացել",
  "Шаг {0} из {1}": "Քայլ {0}՝ {1}-ից",
  "{0}: {1}. Открыть": "{0}՝ {1}։ Բացել",
  "Раскладка": "Դասավորություն",
  "Широкий": "Լայն",
  "Инструмент": "Գործիք",
  "голос|голоса|голосов": "ձայն",
  "Как в оригинале": "Ինչպես բնօրինակում",
  "фото|фото|фото": "լուսանկար",
  "слайд|слайда|слайдов": "սլայդ",
  "снимок|снимка|снимков": "լուսանկար",
  "кадр|кадра|кадров": "կադր",
  "Длительность записи": "Ձայնագրության տևողություն",
  "Цена": "Գին",
  "Списание не подтверждено": "Գանձումը հաստատված չէ",
  "Кадры": "Կադրեր",
  "знак|знака|знаков": "նիշ",
  "пункт|пункта|пунктов": "կետ",
  "фраза|фразы|фраз": "արտահայտություն",
  "человек|человека|человек": "մարդ",
  "Смотреть видео": "Դիտել տեսանյութը",
  "символ|символа|символов": "նիշ",
  "Дорожка": "Ձայնագրություն",
  "фрагмент 1:00": "1:00 հատված",
  "вся песня": "ամբողջ երգը",
  "образец|образца|образцов": "նմուշ",
  "Свой голос": "Սեփական ձայն",
  "{0} C списаны": "{0} C դուրս է գրվել",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Աշխատանքը դեռ ստեղծվում է։ Արդյունքը կհայտնվի այստեղ և կգա չաթ",
  "Проверяем результат. Обычно это занимает пару минут": "Ստուգում ենք արդյունքը։ Սովորաբար դա տևում է մի քանի րոպե",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Չանցավ մոդերացիա։ Քաղաքականություն և արգելված թեմաներ չենք ընդունում։ {0}",
  "Не прошло модерацию. {0}": "Չանցավ մոդերացիա։ {0}",
  "Не получилось. {0}": "Չստացվեց։ {0}",
  "Не получилось. {0} C вернулись на баланс": "Չստացվեց։ {0} C-ն վերադարձվեց հաշվեկշռին",
  "Удалится только запись о заказе": "Կջնջվի միայն պատվերի գրառումը",
  "Удаление из истории": "Ջնջում պատմությունից",
  "Смотреть: {0}": "Դիտել՝ {0}",
  "В этой работе нет файлов для просмотра": "Այս աշխատանքում դիտելու ֆայլեր չկան",
  "Вернуть запись в историю не получится.": "Գրառումը պատմություն վերադարձնել հնարավոր չի լինի։",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Ֆայլը կմնա չաթում։ Աշխատանքը պատմություն վերադարձնել հնարավոր չի լինի։",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Ուղարկումը դեռ չի հաստատվել։ Սեղմեք ևս մեկ անգամ",
  "Принято": "Ընդունված է",
  "Бот пришлёт результат в чат": "Բոտը արդյունքը կուղարկի չաթ",
  "Возврат обрабатывается": "Վերադարձը մշակվում է",
  "Не списано": "Չի գանձվել",
  "Circle не списаны": "Circle-ը չի գանձվել",
  "Circle вернулись на баланс": "Circle-ը վերադարձվեց հաշվեկշռին",
  "Списание пока не подтверждено": "Գանձումը դեռ հաստատված չէ",
  "Возврат не подтверждён": "Վերադարձը հաստատված չէ",
  "Ожидаем подтверждения оплаты": "Սպասում ենք վճարմանը",
  "история: Повторить": "Կրկնել",
  "история: Кружки": "Տեսահաղորդագրություններ",
  "Фотосессия из селфи": "Ֆոտոսեսիա սելֆիից",
  "Рилс с вами": "Ռիլս ձեզ հետ",
  "Фото говорит": "Լուսանկարը խոսում է",
  "Слайды с преимуществами": "Առավելությունների սլայդներ",
  "Карусель для поста": "Կարուսել գրառման համար",
  "Коллаж из фото": "Լուսանկարների կոլաժ",
  "Карточка для маркетплейса": "Քարտ մարքեթփլեյսի համար",
  "шаг|шага|шагов": "քայլ",
  "вопрос|вопроса|вопросов": "հարց",
  "Открыть": "Բացել",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "Այս հարցի պատասխանը չհաստատվեց։ Եթե այն կարևոր է, գրեք աջակցությանը՝ {0}։",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "Այս հարցի պատասխանը չհաստատվեց։ Եթե այն կարևոր է, գրեք աջակցությանը։",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Պատասխանը դեռ չի եկել։ Կստուգենք նույն հարցը, այն երկրորդ անգամ չի ուղարկվի։",
  "Открыть профиль": "Բացել պրոֆիլը",
  "Войти через STEOS ID": "Մուտք գործել STEOS ID-ով",
  "Тут Telegram откроет выбор чата": "Այստեղ Telegram-ը կբացի զրույցի ընտրությունը",
  "Разделы поддержки": "Աջակցության բաժիններ",
  "Ответит сразу": "Կպատասխանի անմիջապես",
  "Отвечает сразу": "Պատասխանում է անմիջապես",
  "Поддержка в Telegram, {0}": "Աջակցություն Telegram-ում, {0}",
  "Поддержка в Telegram": "Աջակցություն Telegram-ում",
  "Видео медленнее обычного": "Տեսանյութը սովորականից դանդաղ է",
  "Видео работает медленнее обычного": "Տեսանյութն աշխատում է սովորականից դանդաղ",
  "Спросить ИИ‑агента поддержки": "Հարցնել աջակցության AI գործակալին",
  "Отвечает сразу и знает всё о STEOS": "Պատասխանում է անմիջապես և ամեն ինչ գիտի STEOS-ի մասին",
  "Поиск по вопросам и инструкциям": "Որոնել հարցերում և հրահանգներում",
  "Шесть коротких сторис о главном": "Վեց կարճ սթորիս գլխավորի մասին",
  "Попробуйте другие слова или спросите ИИ-агента": "Փորձեք այլ բառեր կամ հարցրեք AI գործակալին",
  "Проверено в {0}": "Ստուգվել է՝ {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Պատվերները չեն կորչում․ արդյունքը կգա զրույց, իսկ եթե ինչ-որ բան ձախողվի, Circle-ները կվերադառնան հաշվեկշիռ։",
  "Сервисы": "Ծառայություններ",
  "Загружаем статус сервисов": "Բեռնում ենք ծառայությունների կարգավիճակը",
  "Загружаем справку": "Բեռնում ենք օգնությունը",
  "Статус не загрузился": "Կարգավիճակը չբեռնվեց",
  "Статус сервисов пока не отслеживается": "Ծառայությունների կարգավիճակը դեռ չի հետևվում",
  "Если что-то не работает, напишите в поддержку": "Եթե ինչ-որ բան չի աշխատում, գրեք աջակցությանը",
  "Часть сервисов работает с перебоями": "Որոշ ծառայություններ աշխատում են ընդհատումներով",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Ձեր աշխատանքների կարգավիճակները և հաստատված վերադարձները տեսեք «Պատմություն» բաժնում։",
  "Справка не загрузилась": "Օգնությունը չբեռնվեց",
  "Справка пока не опубликована": "Օգնությունը դեռ հրապարակված չէ",
  "Вопрос можно задать поддержке в Telegram": "Հարցը կարող եք տալ աջակցությանը Telegram-ում",
  "Инструкции появятся после публикации справки": "Հրահանգները կհայտնվեն օգնության հրապարակումից հետո",
  "Назад к ИИ-агенту": "Վերադառնալ AI գործակալին",
  "Инструкция · {0}": "Հրահանգ · {0}",
  "Вопрос · {0}": "Հարց · {0}",
  "Справка": "Օգնություն",
  "Вопрос из Справки": "Հարց Օգնությունից",
  "Подробнее из Справки": "Ավելին՝ Օգնությունում",
  "Назад по таблице": "Աղյուսակը հետ",
  "Вперёд по таблице": "Աղյուսակը առաջ",
  "Здравствуйте, {0}.": "Բարև Ձեզ, {0}։",
  "Здравствуйте.": "Բարև Ձեզ։",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Ես STEOS-ի աջակցության AI գործակալն եմ․ կօգնեմ սակագների և Circle-ի, գործիքների և ձևանմուշների, պրոմոկոդերի, STEOS ID-ի և գործընկերային ծրագրի հարցերում։ Հարցրեք Ձեր բառերով կամ ընտրեք հարց։",
  "ИИ-агент печатает": "AI գործակալը գրում է",
  "ИИ-агент ещё отвечает": "AI գործակալը դեռ պատասխանում է",
  "Напишите вопрос": "Գրեք հարց",
  "Диалог с ИИ-агентом": "Զրույց AI գործակալի հետ",
  "Распознаём…": "Ճանաչում ենք…",
  "Слушаю": "Լսում եմ",
  "Спросите о STEOS": "Հարցրեք STEOS-ի մասին",
  "Вопрос ИИ-агенту": "Հարց AI գործակալին",
  "Остановить диктовку": "Դադարեցնել թելադրումը",
  "Сказать голосом": "Ասել ձայնով",
  "Отправить": "Ուղարկել",
  "Не удалось начать новый чат": "Չհաջողվեց սկսել նոր զրույց",
  "Спасибо, учтём": "Շնորհակալություն, հաշվի կառնենք",
  "Спасибо, передадим команде": "Շնորհակալություն, կփոխանցենք թիմին",
  "Оценка не сохранилась": "Գնահատականը չպահպանվեց",
  "Чат ещё загружается": "Զրույցը դեռ բեռնվում է",
  "В чате уже {0} вопросов. Начните новый": "Զրույցում արդեն {0} հարց կա։ Սկսեք նորը",
  "Вопрос не сохранился. Попробуйте ещё раз": "Հարցը չպահպանվեց։ Փորձեք կրկին",
  "Некоторые сервисы работают медленнее обычного": "Որոշ ծառայություններ աշխատում են սովորականից դանդաղ",
  "{0} не работают": "{0} չեն աշխատում",
  "{0} не работает": "{0} չի աշխատում",
  "{0} медленнее обычного": "{0}՝ սովորականից դանդաղ",
  "{0} работают медленнее обычного": "{0} աշխատում են սովորականից դանդաղ",
  "{0} работает медленнее обычного": "{0} աշխատում է սովորականից դանդաղ",
  "Микрофон здесь недоступен": "Խոսափողն այստեղ հասանելի չէ",
  "Нет доступа к микрофону": "Խոսափողին հասանելիություն չկա",
  "Нужна запись от 1 до 30 секунд": "Անհրաժեշտ է 1-ից 30 վայրկյան ձայնագրություն",
  "Не удалось разобрать запись": "Չհաջողվեց հասկանալ ձայնագրությունը",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Թելադրումը չճանաչվեց։ Սեղմեք խոսափողը՝ կրկին ստուգելու համար",
  "Вопрос не подошёл. Сформулируйте иначе": "Հարցը չհամապատասխանեց։ Ձևակերպեք այլ կերպ",
  "Ответ не подтвердился. Напишите в поддержку": "Պատասխանը չհաստատվեց։ Գրեք աջակցությանը",
  "Ответ не пришёл. Проверьте ещё раз": "Պատասխանը չեկավ։ Ստուգեք կրկին",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Խոսող շրջանաձև տեսանյութ, Տեսանյութը խոսում է, Լուսանկարը խոսում է, Կրկնիր շարժումները, սեփական ավատար",
  "Оживить фото, видео по описанию, рилсы и сцены": "Կենդանացնել լուսանկարը, տեսանյութ ըստ նկարագրության, ռիլսեր և տեսարաններ",
  "Фото, фотосессии, товары, карусели": "Լուսանկարներ, ֆոտոսեսիաներ, ապրանքներ, կարուսելներ",
  "Голоса, клон, озвучка проектов, кавер": "Ձայներ, կլոն, նախագծերի հնչյունավորում, քավեր",
  "Звёзды Telegram и карты": "Telegram Stars և քարտեր",
  "Не работает": "Չի աշխատում",
  "Как сделать по шагам": "Քայլ առ քայլ",
  "Полезный ответ": "Օգտակար պատասխան",
  "Ответ не помог": "Պատասխանը չօգնեց",
  "Проверьте связь и попробуйте ещё раз": "Ստուգեք կապը և փորձեք կրկին",
  "Не удалось проверить владельца чата": "Չհաջողվեց ստուգել զրույցի սեփականատիրոջը",
  "Не удалось восстановить чат. Начните новый": "Չհաջողվեց վերականգնել զրույցը։ Սկսեք նորը",
  "Клоны для озвучки": "Կլոններ ձայնագրման համար",
  "Создайте первый голос": "Ստեղծեք առաջին ձայնը",
  "Люди и питомцы для фото": "Մարդիկ և ընտանի կենդանիներ լուսանկարների համար",
  "Добавьте близких для фото": "Ավելացրեք մտերիմներին լուսանկարների համար",
  "Сохранённые работы": "Պահված աշխատանքներ",
  "Отмечайте работы сердцем": "Նշեք աշխատանքները սրտիկով",
  "Ежедневная серия и бонусы": "Օրական շարք և բոնուսներ",
  "Частые вопросы и связь с нами": "ՀՏՀ և կապ մեզ հետ",
  "Обучается": "Ուսուցանվում է",
  "Аккаунт недоступен": "Հաշիվը հասանելի չէ",
  "Эта неделя · {0}": "Այս շաբաթ · {0}",
  "Неделя с {0} · {1}": "{0}-ից սկսվող շաբաթ · {1}",
  "ID скопирован": "ID-ն պատճենվեց",
  "Скопировать ID": "Պատճենել ID-ն",
  "Баланс временно недоступен": "Հաշվեկշիռը ժամանակավորապես հասանելի չէ",
  "Разбивка остатка временно недоступна": "Մնացորդի բաշխումը ժամանակավորապես հասանելի չէ",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Դրանցից {0} C-ն կայրվի {1}",
  "Ближайшие {0} C сгорят {1}": "Մոտակա {0} C-ն կայրվի {1}",
  "Circle каждый месяц от {0}": "Circle ամեն ամիս՝ {0}-ից",
  "Circle каждый месяц с подпиской": "Circle ամեն ամիս՝ բաժանորդագրությամբ",
  "Тариф временно недоступен": "Սակագինը ժամանակավորապես հասանելի չէ",
  "Аккаунт, подписка и баланс": "Հաշիվ, բաժանորդագրություն և հաշվեկշիռ",
  "Статистика и моё": "Վիճակագրություն և Իմը",
  "{0} к прошлой неделе": "{0} նախորդ շաբաթի համեմատ",
  "Работы по неделям: на этой неделе {0}": "Աշխատանքներն ըստ շաբաթների՝ այս շաբաթ {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Աշխատանքներն ըստ շաբաթների՝ այս շաբաթ {0}, նախորդ շաբաթ {1}",
  "Статистика пока недоступна": "Վիճակագրությունը դեռ հասանելի չէ",
  "Дата регистрации недоступна": "Գրանցման ամսաթիվը հասանելի չէ",
  "С {0}": "{0}-ից",
  "Создано": "Ստեղծված",
  "Серия": "Շարք",
  "день подряд|дня подряд|дней подряд": "օր անընդմեջ",
  "Общий аккаунт STEOS": "Ընդհանուր STEOS հաշիվ",
  "Для вывода Circle": "Circle դուրս բերելու համար",
  "До {0}% с их покупок": "Նրանց գնումներից մինչև {0}%",
  "Обновлено {0}": "Թարմացվել է՝ {0}",
  "Действия": "Գործողություններ",
  "Сохранить имя": "Պահել անունը",
  "Новое имя": "Նոր անուն",
  "Больше голосов с подпиской": "Ավելի շատ ձայներ՝ բաժանորդագրությամբ",
  "Создание голосов пока недоступно": "Ձայներ ստեղծելը դեռ հասանելի չէ",
  "Свободных мест нет": "Ազատ տեղ չկա",
  "с подпиской до {0}": "բաժանորդագրությամբ՝ մինչև {0}",
  "Пауза «{0}»": "Դադար «{0}»",
  "Прослушать «{0}»": "Լսել «{0}»",
  "Переименовать": "Վերանվանել",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "Ձայնագրեք 2 վայրկյան խոսք կամ վերբեռնեք ֆայլեր, և ձայնը կհնչի ձեզ նման",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Ազատ տեղ չկա։ Ջնջեք ձայներից մեկը՝ նորը ձայնագրելու համար",
  "Выбрать за «Вы»": "Ընտրել որպես «Դուք»",
  "голос по умолчанию": "լռելյայն ձայն",
  "Сделать кружок с вариантом «{0}»": "Ստեղծել շրջանաձև տեսանյութ «{0}» տարբերակով",
  "Выбраны": "Ընտրված են",
  "{0} фото|{0} фото|{0} фото": "{0} լուսանկար",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} լուսանկար · բոլոր գործիքների համար",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} տարբերակ · շրջանաձև տեսանյութեր, լուսանկարներ, տեսանյութեր",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} տարբերակ",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "{0} ձայնը ջնջվել է, {1} տարբերակն այժմ լռելյայն ձայնով է։",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Ձայները ջնջվել են, {0} տարբերակներն այժմ լռելյայն ձայնով են։",
  "Другой голос можно выбрать у каждого кружка": "Այլ ձայն կարելի է ընտրել յուրաքանչյուր շրջանաձև տեսանյութի համար",
  "Вариантов пока нет": "Տարբերակներ դեռ չկան",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Վերբեռնեք ձեր լուսանկարները, և ձեր տարբերակը կխոսի ձեր ձայնով շրջանաձև տեսանյութերում, լուսանկարներում և տեսանյութերում",
  "Вы: свои фото и варианты": "Դուք՝ ձեր լուսանկարներն ու տարբերակները",
  "добавьте фото": "ավելացրեք լուսանկարներ",
  "Изменить «{0}»": "Փոխել «{0}»",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} մտերիմ · լուսանկարների և տեսանյութերի համար",
  "Люди и питомцы для фото и видео": "Մարդիկ և կենդանիներ լուսանկարների և տեսանյութերի համար",
  "Близких пока нет": "Մտերիմներ դեռ չկան",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Ավելացրեք մարդկանց և կենդանիներին լուսանկարներով, և նրանք կհայտնվեն կադրում ձեր կողքին",
  "Открыть в «Истории»": "Բացել «Պատմության» մեջ",
  "Вернуть в избранное": "Վերադարձնել ընտրյալներ",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "Սրտիկով {0} աշխատանք",
  "Отмеченные сердцем работы": "Սրտիկով նշված աշխատանքներ",
  "Открыть «Историю»": "Բացել «Պատմությունը»",
  "Не удалось загрузить избранное": "Չհաջողվեց բեռնել ընտրյալները",
  "Закройте лист и откройте его ещё раз": "Փակեք պատուհանը և նորից բացեք",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "Նշեք աշխատանքները սրտիկով «Պատմության» մեջ, և դրանք կհավաքվեն այստեղ",
  "Не удалось обновить. Попробуйте позже": "Չհաջողվեց թարմացնել։ Փորձեք ավելի ուշ",
  "Удалить голос «{0}»?": "Ջնջե՞լ «{0}» ձայնը",
  "Голос пропадёт из списка. Вернуть его не получится.": "Ձայնը կանհետանա ցանկից։ Այն վերականգնել հնարավոր չի լինի։",
  "Удалить вариант «{0}»?": "Ջնջե՞լ «{0}» տարբերակը",
  "За «Вы» снова встанут ваши фото.": "«Դուք»-ի փոխարեն կրկին կլինեն ձեր լուսանկարները։",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Դրանով պատրաստված շրջանաձև տեսանյութերն ու լուսանկարները կմնան «Պատմության» մեջ։ Տարբերակը վերականգնել հնարավոր չի լինի։",
  "Не удалось удалить голос": "Չհաջողվեց ջնջել ձայնը",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Չհաջողվեց ջնջել տարբերակը։ Փորձեք կրկին",
  "«{0}»": "«{0}»",
  "подписка: до {0}": "մինչև {0}",
  "варианты «Вы»: Новый вариант": "Նոր տարբերակ",
  "в очереди": "հերթում է",
  "идёт": "ընթացքում է",
  "завершено": "ավարտված է",
  "не удалось": "ձախողվեց",
  "слово подтверждения: УДАЛИТЬ": "ՋՆՋԵԼ",
  "Выгрузка: {0}": "Արտահանում՝ {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Ջնջում՝ {0}։ STEOS ID-ն և ֆինանսական անդորրագրերը պահպանվում են։",
  "Введите {0}": "Մուտքագրեք {0}",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Փոխանցումը դեռ հաստատված չէ։ Ստուգումը կշարունակվի, բացեք պատուհանն ավելի ուշ",
  "Этот STEOS ID уже связан с другим Telegram": "Այս STEOS ID-ն արդեն կապված է այլ Telegram-ի հետ",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Երկու հաշիվներն էլ ունեն բաժանորդագրություն։ Միավորելու համար գրեք աջակցությանը",
  "Слишком много попыток. Попробуйте позже": "Չափազանց շատ փորձեր։ Փորձեք ավելի ուշ",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "STEOS ID-ի միացումը հիմա հասանելի չէ։ Փորձեք ավելի ուշ",
  "Не удалось создать аккаунт. Попробуйте позже": "Չհաջողվեց ստեղծել հաշիվ։ Փորձեք ավելի ուշ",
  "Не удалось отправить письмо": "Չհաջողվեց ուղարկել նամակը",
  "Фото не подошло. Выберите другое": "Լուսանկարը չհամապատասխանեց։ Ընտրեք մեկ ուրիշը",
  "Загрузите фото заново": "Վերբեռնեք լուսանկարը նորից",
  "Данные изменились. Откройте заново": "Տվյալները փոխվել են։ Բացեք կրկին",
  "подряд": "անընդմեջ",
  "Начните {0}": "Սկսեք {0}",
  "серию": "շարքը",
  "Завтра +{0} C": "Վաղը +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Մտեք ամեն օր․ պարգևն աճում է, յոթերորդ օրը՝ {0} C։ Բաց թողնված օրը շարքը սկսում է նորից։",
  "Забрать {0} C": "Ստանալ {0} C",
  "Прогресс": "Առաջընթաց",
  "Заданий здесь пока нет": "Այստեղ դեռ առաջադրանքներ չկան",
  "Время обновления недоступно": "Թարմացման ժամը հասանելի չէ",
  "Новые через {0}": "Նորերը՝ {0} հետո",
  "Выполнено {0} из {1}": "Կատարված է {0}՝ {1}-ից",
  "друг|друга|друзей": "ընկեր",
  "{0} с вами": "{0} ձեզ հետ",
  "Прогресс друзей недоступен": "Ընկերների առաջընթացը հասանելի չէ",
  "Пригласить": "Հրավիրել",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Հաշվվում են ընկերները, ովքեր եկել են ձեր հղումով կամ պրոմոկոդով և ստեղծել առաջին աշխատանքը",
  "Ещё {0} {1} до награды {2}": "Եվս {0} {1} մինչև {2} պարգևը",
  "Все ступени пройдены": "Բոլոր աստիճաններն անցված են",
  "Получено {0} из {1}": "Ստացված է {0}՝ {1}-ից",
  "Задания": "Առաջադրանքներ",
  "покупатель|покупателя|покупателей": "գնորդ",
  "Партнёрская программа": "Գործընկերային ծրագիր",
  "Партнёрам": "Գործընկերներին",
  "До {0}% {1}": "Մինչև {0}% {1}",
  "с покупок друзей": "ընկերների գնումներից",
  "Заработано {0} с покупок {1} {2}": "Վաստակվել է {0}՝ {1} {2} գնումներից",
  "друга|друзей|друзей": "ընկերոջ",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Ընտրեք ինքներդ՝ ավելի շատ հնարավորություններ STEOS-ում կամ եկամուտ առաջարկներից։",
  "Ещё {0} до уровня {1}": "Եվս {0} մինչև {1} մակարդակը",
  "Максимальный уровень: вывод через STEOS ID": "Առավելագույն մակարդակ․ դուրսբերում STEOS ID-ով",
  "Статистика, материалы и вывод": "Վիճակագրություն, նյութեր և դուրսբերում",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Պետք է ստուգել նախորդ պարգևի հարցման արդյունքը։ Նոր հաշվեգրումները առայժմ արգելափակված են",
  "Загружаем награды": "Պարգևները բեռնվում են",
  "Награды не загрузились": "Պարգևները չբեռնվեցին",
  "Создайте 3 работы": "Ստեղծեք 3 աշխատանք",
  "Сделайте кружок": "Ստեղծեք շրջանաձև տեսանյութ",
  "Персонаж или вы сами": "Կերպար կամ դուք ինքներդ",
  "Озвучьте текст": "Հնչյունավորեք տեքստ",
  "Голосом героя или клона": "Կերպարի կամ կլոնի ձայնով",
  "Улучшите описание": "Բարելավեք նկարագրությունը",
  "Бот допишет детали": "Բոտը կավելացնի մանրամասները",
  "Отправьте работу": "Ուղարկեք աշխատանք",
  "Из «Истории» в любой чат": "«Պատմությունից» ցանկացած չաթ",
  "Неделя кружков": "Շրջանաձև տեսանյութերի շաբաթ",
  "Создайте 10 кружков за неделю": "Ստեղծեք 10 շրջանաձև տեսանյութ մեկ շաբաթում",
  "Исследователь": "Հետազոտող",
  "Попробуйте 5 разных инструментов студии": "Փորձեք Ստուդիայի 5 տարբեր գործիք",
  "Первый кружок": "Առաջին շրջանաձև տեսանյութը",
  "Видеокружок для Telegram": "Շրջանաձև տեսանյութ Telegram-ի համար",
  "Клон голоса": "Ձայնի կլոն",
  "Всего 2 секунды речи": "Ընդամենը 2 վայրկյան խոսք",
  "Первое фото": "Առաջին լուսանկարը",
  "Портрет в любом стиле": "Դիմանկար ցանկացած ոճով",
  "Первый рилс с вами": "Առաջին ռիլսը ձեզ հետ",
  "Шаблон одной кнопкой": "Կաղապար մեկ սեղմումով",
  "Первый кавер": "Առաջին քավերը",
  "Песня другим голосом": "Երգ այլ ձայնով",
  "Кружки и видео с вами": "Շրջանաձև և սովորական տեսանյութեր ձեզ հետ",
  "С вашей ссылкой": "Ձեր հղումով",
  "Бот в чате": "Բոտը չաթում",
  "Добавьте бота в группу": "Ավելացրեք բոտը խմբում",
  "Вход в STEOS ID": "Մուտք STEOS ID-ով",
  "Один аккаунт с сайтом": "Մեկ հաշիվ կայքի հետ",
  "Первый друг": "Առաջին ընկերը",
  "3 друга": "3 ընկեր",
  "10 друзей": "10 ընկեր",
  "25 друзей": "25 ընկեր",
  "Первый покупатель": "Առաջին գնորդը",
  "Первая оплата друга": "Ընկերոջ առաջին վճարումը",
  "{0} мин": "{0} րոպե",
  "{0} ч": "{0} ժ",
  "Последний день": "Վերջին օրը",
  "Ещё {0} {1}": "Մնաց {0} {1}",
  "Это задание выполняется вне мини-приложения": "Այս առաջադրանքը կատարվում է Mini App-ից դուրս",
  "Задание пока недоступно": "Առաջադրանքը դեռ հասանելի չէ",
  "Прогресс временно недоступен": "Առաջընթացը ժամանակավորապես հասանելի չէ",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Չհաջողվեց վերականգնել նախորդ պարգևի հարցումը։ Ստուգեք մնացորդը և գրեք աջակցման ծառայությանը",
  "Награды временно недоступны. Попробуйте обновить данные": "Պարգևները ժամանակավորապես հասանելի չեն։ Փորձեք թարմացնել տվյալները",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Պարգևը հաստատված է։ Թարմացրեք տվյալները․ կրկին ստանալ պետք չէ",
  "Задание ещё не выполнено. Обновите прогресс": "Առաջադրանքը դեռ կատարված չէ։ Թարմացրեք առաջընթացը",
  "Награда уже получена. Обновите данные": "Պարգևն արդեն ստացված է։ Թարմացրեք տվյալները",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Հաշվեգրումը հաստատված չէ։ Ստուգեք նախորդ հարցումը․ նոր պարգևն առայժմ արգելափակված է",
  "Сначала обновите данные наград": "Նախ թարմացրեք պարգևների տվյալները",
  "Сначала проверьте прежний запрос награды": "Նախ ստուգեք նախորդ պարգևի հարցումը",
  "Рассказчик": "Պատմող",
  "Встреча на тракте": "Հանդիպում ճանապարհին",
  "Геральт": "Գերալտ",
  "Цири": "Ցիրի",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Անձրևը երրորդ օրն էր տեղում, և ամրոց տանող ճանապարհը գրեթե անհետացել էր ցեխի տակ։",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Դու նորից առանց ինձ առաջ գնացիր։ Չէ՞ որ խնդրել էի սպասել կամրջի մոտ։",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Ես սպասեցի։ Մի ամբողջ ժամ։ Հետո որոշեցի, որ դու մոլորվել ես։",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Վհուկները չեն մոլորվում։ Մենք երբեմն ընտրում ենք երկար ճանապարհը։",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Ուրեմն հաջորդ անգամ ավելի արագ ընտրիր։ Ես մրսեցի։",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Նա լուռ հանեց թիկնոցը և գցեց նրա ուսերին։ Առջևում արդեն երևում էին ամրոցի լույսերը։",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Գնանք։ Վեսեմիրը հավանաբար արդեն ապուրը կրակին է դրել։",
  "Опять ты?": "Նորի՞ց դու",
  "Мне нужна помощь": "Ինձ օգնություն է պետք",
  "Вставьте сценарий или начните с нуля": "Տեղադրեք սցենար կամ սկսեք զրոյից",
  "Напишите хотя бы одну реплику": "Գրեք առնվազն մեկ խոսք",
  "Сократите реплику: до {0} знаков": "Կրճատեք խոսքը՝ մինչև {0} նիշ",
  "Сократите проект: до {0} знаков": "Կրճատեք նախագիծը՝ մինչև {0} նիշ",
  "Озвучка проектов временно недоступна": "Նախագծերի հնչյունավորումը ժամանակավորապես հասանելի չէ",
  "Выберите голос для каждой роли": "Ընտրեք ձայն յուրաքանչյուր դերի համար",
  "Озвучить · {0} C": "Հնչյունավորել · {0} C",
  "Без названия": "Անանուն",
  "Роль": "Դեր",
  "вчера": "երեկ",
  "Проекты": "Նախագծեր",
  "роль|роли|ролей": "դեր",
  "реплика|реплики|реплик": "խոսք",
  "Нет реплик": "Խոսքեր չկան",
  "{0} знаков": "{0} նիշ",
  "Строки «Имя: реплика» сами станут ролями и голосами": "«Անուն․ խոսք» տողերն ինքնին կդառնան դերեր և ձայներ",
  "Начать с нуля": "Սկսել զրոյից",
  "Роли и реплики добавите сами": "Դերերն ու խոսքերը կավելացնեք ինքներդ",
  "Открыть пример": "Բացել օրինակը",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Նախագծերը պահպանվում են ինքնաբերաբար․ կարող եք վերադառնալ դրանց ցանկացած պահի",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Կերպարի անունով դերն ինքնին կստանա նրա ձայնը՝ Գերալտ, Ցիրի, Յենիֆեր",
  "Переименовать проект": "Վերանվանել նախագիծը",
  "Загрузить свежую": "Բեռնել թարմը",
  "{0}: голос {1}. Сменить голос": "{0}․ ձայն՝ {1}։ Փոխել ձայնը",
  "Действия с ролью": "Դերի գործողություններ",
  "Озвучиваем": "Հնչյունավորում ենք",
  "Действия с репликой": "Խոսքի գործողություններ",
  "Реплика: {0}": "Խոսք՝ {0}",
  "Реплик пока нет": "Խոսքեր դեռ չկան",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Սեղմեք ներքևի «Խոսք» կոճակը կամ տեղադրեք պատրաստի սցենար",
  "Реплика": "Խոսք",
  "за проект": "նախագծի համար",
  "Цена — по числу знаков": "Գինը՝ ըստ նիշերի քանակի",
  "Добавить реплику": "Ավելացնել խոսք",
  "проект|проекта|проектов": "նախագիծ",
  "{0} {1} · сохраняются сами": "{0} {1} · պահպանվում են ինքնաբերաբար",
  "Пока ни одного": "Դեռ ոչ մեկը",
  "Новый проект": "Նոր նախագիծ",
  "Вставить сценарий или начать с нуля": "Տեղադրել սցենար կամ սկսել զրոյից",
  "Удаление проекта": "Նախագծի հեռացում",
  "Новая роль": "Նոր դեր",
  "Это первая реплика": "Սա առաջին խոսքն է",
  "Это последняя реплика": "Սա վերջին խոսքն է",
  "Удалить роль": "Հեռացնել դերը",
  "Вместе с её репликами": "Իր խոսքերի հետ միասին",
  "В проекте нужна хотя бы одна роль": "Նախագծում պետք է լինի առնվազն մեկ դեր",
  "Удалить роль «{0}»?": "Հեռացնե՞լ «{0}» դերը",
  "Вместе с ней уйдут {0} {1}.": "Դրա հետ կհեռացվի՝ {0} {1}։",
  "Удалить проект?": "Հեռացնե՞լ նախագիծը",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}։ Դերերն ու խոսքերը կհեռացվեն, նախագիծը հնարավոր չի լինի վերականգնել։",
  "Выбор голоса откроется в приложении": "Ձայնի ընտրությունը կբացվի հավելվածում",
  "Не удалось удалить проект: {0}": "Չհաջողվեց հեռացնել նախագիծը․ {0}",
  "Не получилось открыть аудио": "Չհաջողվեց բացել աուդիոն",
  "Не получилось включить звук": "Չհաջողվեց միացնել ձայնը",
  "Сначала напишите текст реплики": "Նախ գրեք խոսքի տեքստը",
  "Аудио реплики пока недоступно": "Խոսքի աուդիոն դեռ հասանելի չէ",
  "Готовим роли": "Պատրաստում ենք դերերը",
  "Роли готовы": "Դերերը պատրաստ են",
  "Озвучиваем реплики": "Հնչյունավորում ենք խոսքերը",
  "Реплики озвучены": "Խոսքերը հնչյունավորված են",
  "Собираем дорожку": "Հավաքում ենք ձայնագրությունը",
  "Дорожка собрана": "Ձայնագրությունը պատրաստ է",
  "дубль {0}": "տարբերակ {0}",
  "Время реплики пока недоступно": "Խոսքի ժամանակը դեռ հասանելի չէ",
  "Общий файл · {0}": "Ընդհանուր ֆայլ · {0}",
  "Аудио пока недоступно": "Աուդիոն դեռ հասանելի չէ",
  "Слушать дорожку": "Լսել ձայնագրությունը",
  "реплика {0} из {1}": "խոսք {0}՝ {1}-ից",
  "Проект не озвучен": "Նախագիծը չհնչյունավորվեց",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Կարող եք լքել էկրանը․ հնչյունավորումը կշարունակվի, ձայնագրությունը կհայտնվի այստեղ և «Պատմությունում»։",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Կարող եք լքել էկրանը․ բոտը կգրի, երբ ձայնագրությունը պատրաստ լինի։",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Ուղարկեք ընդհանուր ֆայլը չաթ կամ ներբեռնեք այն։ Ցանկացած խոսք կարելի է առանձին վերահնչյունավորել։",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Բոտն արդեն ուղարկել է ընդհանուր ֆայլը չաթ՝ առանձին թեմայում։ Ցանկացած խոսք կարելի է առանձին վերահնչյունավորել։",
  "Сценарий не прошёл проверку": "Սցենարը չանցավ ստուգումը",
  "проект не озвучен": "նախագիծը չհնչյունավորվեց",
  "Не получилось собрать дорожку": "Չհաջողվեց հավաքել ձայնագրությունը",
  "К сценарию": "Վերադառնալ սցենարին",
  "Звук дорожки не загрузился: скачайте файл": "Ձայնագրությունը չբեռնվեց․ ներբեռնեք ֆայլը",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Յուրաքանչյուր խոսք՝ նոր տողից․ անուն, երկու կետ, տեքստ։ Առանց անվան տողը պատկանում է նախորդ դերին",
  "голос персонажа": "կերպարի ձայն",
  "Заменить сценарий": "Փոխարինել սցենարը",
  "Сейчас {0} {1}, они уйдут": "Հիմա՝ {0} {1}, դրանք կհեռացվեն",
  "реплику|реплики|реплик": "խոսք",
  "Заменить на {0} {1}": "Փոխարինել {0} {1}-ով",
  "Добавить {0} {1}": "Ավելացնել {0} {1}",
  "Заменить реплики": "Փոխարինել խոսքերը",
  "Добавить реплики": "Ավելացնել խոսքեր",
  "Не нашли реплик: имя, двоеточие, текст": "Խոսքեր չգտնվեցին․ անուն, երկու կետ, տեքստ",
  "Вставьте сценарий в поле": "Տեղադրեք սցենարը դաշտում",
  "Роли и голоса появятся сами": "Դերերն ու ձայներն ինքնին կհայտնվեն",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Գերալտ․ Նորից դու։ Այս անգամ ի՞նչ է։\nՑիրի․ Ինձ քո օգնությունն է պետք։",
  "Сейчас нельзя": "Հիմա հնարավոր չէ",
  "Вставьте текст в поле": "Տեղադրեք տեքստը դաշտում",
  "Загружаем проекты": "Նախագծերը բեռնվում են",
  "Проекты не загрузились": "Նախագծերը չբեռնվեցին",
  "Не хватает Circle: пополните баланс": "Circle-ը չի բավարարում․ լիցքավորեք հաշիվը",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Գինը՝ {0} C։ Սեղմեք ևս մեկ անգամ՝ հնչյունավորելու համար",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Չհաջողվեց հաշվել գինը։ Փորձեք կրկին",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Սցենարը չանցավ ստուգումը։ Փոխեք տեքստը և փորձեք կրկին։",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Չհաջողվեց հավաքել ձայնագրությունը։ Եթե Circle-ը գանձվել է, այն կվերադառնա հաշվին։",
  "Запуск не подтверждён": "Մեկնարկը չի հաստատվել",
  "Не получилось собрать дорожку.": "Չհաջողվեց հավաքել ձայնագրությունը։",
  "Повторная проверка не спишет Circle дважды.": "Կրկնակի ստուգումը Circle-ը երկու անգամ չի գանձի։",
  "Отправили в чат": "Ուղարկվեց չաթ",
  "Отправка принята: бот пришлёт дорожку в чат": "Ուղարկումն ընդունված է․ բոտը ձայնագրությունը կուղարկի չաթ",
  "Прослушивание реплики пока недоступно": "Խոսքի լսումը դեռ հասանելի չէ",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Լսել խոսքը՝ {0} C։ Սեղմեք ևս մեկ անգամ",
  "Переозвучка реплики пока недоступна": "Խոսքի վերահնչյունավորումը դեռ հասանելի չէ",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Վերահնչյունավորել խոսքը՝ {0} C։ Սեղմեք ևս մեկ անգամ",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Նախագծերի պահպանումն այժմ հասանելի չէ։ Թարմացրեք տվյալները։",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Նախագծերի փոփոխումն այժմ հասանելի չէ։ Թարմացրեք տվյալները։",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Նախագիծը դեռ պահպանվում է։ Փորձեք մեկ վայրկյանից։",
  "Результат больше недоступен.": "Արդյունքն այլևս հասանելի չէ։",
  "Не удалось проверить владельца проекта.": "Չհաջողվեց ստուգել նախագծի սեփականատիրոջը։",
  "Операция не найдена. Проверьте историю.": "Գործողությունը չի գտնվել։ Ստուգեք պատմությունը։",
  "Проект ещё не сохранён.": "Նախագիծը դեռ պահպանված չէ։",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Նախագծերի հնչյունավորումն այժմ հասանելի չէ։ Թարմացրեք տվյալները։",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Խոսքի լսումն այժմ հասանելի չէ։ Թարմացրեք տվյալները։",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Խոսքի վերահնչյունավորումն այժմ հասանելի չէ։ Թարմացրեք տվյալները։",
  "Дорожка ещё не готова.": "Ձայնագրությունը դեռ պատրաստ չէ։",
  "Аккаунт сменился. Обновите страницу.": "Հաշիվը փոխվել է։ Թարմացրեք էջը։",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Ուղարկումը դեռ հաստատված չէ։ Սեղմեք ևս մեկ անգամ՝ նախորդ հարցումը ստուգելու համար։",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Նախագծի արդյունքը դեռ հասանելի չէ։ Կրկին ստուգեք կարգավիճակը։",
  "Не удалось открыть аудио проекта.": "Չհաջողվեց բացել նախագծի աուդիոն։",
  "месяц|месяца|месяцев": "ամիս",
  "покупателя|покупателей|покупателей": "գնորդ",
  "рабочий день|рабочих дня|рабочих дней": "աշխատանքային օր",
  "друг купит|друга купят|друзей купят": "ընկեր",
  "покупателем|покупателями|покупателями": "գնորդ",
  "Баннеры": "Բաններներ",
  "Постер": "Պաստառ",
  "Голос героя": "Հերոսի ձայնը",
  "Персонаж говорит": "Կերպարը խոսում է",
  "Было и стало": "Առաջ և հետո",
  "Подарок другу": "Նվեր ընկերոջը",
  "Кружок, который говорит": "Խոսող շրջանաձև տեսանյութ",
  "Персонаж читает ваш текст": "Կերպարը կարդում է ձեր տեքստը",
  "Рилс с вами одной кнопкой": "Ռիլս ձեզ հետ մեկ կոճակով",
  "Сюжет, монтаж и музыка в шаблоне": "Սյուժեն, մոնտաժը և երաժշտությունը՝ ձևանմուշում",
  "Герой говорит": "Հերոսը խոսում է",
  "Герой говорит вашим текстом": "Հերոսը խոսում է ձեր տեքստով",
  "Голос и губы в такт": "Ձայնն ու շուրթերը համաչափ",
  "Старое фото как новое": "Հին լուսանկարը՝ նորի պես",
  "Цвет и резкость за минуту": "Գույն և հստակություն մեկ րոպեում",
  "Кавер любым голосом": "Քավեր ցանկացած ձայնով",
  "Рок, джаз или lo-fi": "Ռոք, ջազ կամ lo-fi",
  "Фотосессия в любом образе": "Ֆոտոսեսիա ցանկացած կերպարով",
  "По паре своих фото": "Ձեր մի քանի լուսանկարից",
  "Друзьям": "Ընկերներին",
  "Личное сообщение": "Անձնական հաղորդագրություն",
  "Подписчикам": "Բաժանորդներին",
  "Пост в канал": "Գրառում ալիքում",
  "Семье": "Ընտանիքին",
  "Сообщение родным": "Հաղորդագրություն հարազատներին",
  "Геймерам": "Գեյմերներին",
  "Чат по интересам": "Հետաքրքրությունների չաթ",
  "Для работы": "Աշխատանքի համար",
  "Коллегам и в рабочий чат": "Գործընկերներին և աշխատանքային չաթում",
  "Авторам": "Հեղինակներին",
  "Блогерам и создателям роликов": "Բլոգերներին և տեսանյութ ստեղծողներին",
  "Подарок по моему промокоду": "Նվեր իմ պրոմոկոդով",
  "Кружки, фото и голос с ИИ прямо в Telegram": "ԱԲ-ով շրջանաձև տեսանյութեր, լուսանկարներ և ձայն հենց Telegram-ում",
  "Кружки с персонажами": "Շրջանաձև տեսանյութեր կերպարներով",
  "Пишете текст, персонаж его говорит": "Գրում եք, կերպարը խոսում է",
  "Озвучка любым голосом": "Հնչյունավորում ցանկացած ձայնով",
  "Из библиотеки или своим клоном": "Գրադարանից կամ ձեր կլոնով",
  "Фотосессия без студии": "Ֆոտոսեսիա առանց ստուդիայի",
  "Пара своих фото, любой образ": "Մի քանի լուսանկար, ցանկացած կերպար",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "{0}՝ ձեր հղումով գրանցվելուց կամ պրոմոկոդով առաջին գնումից։ Այդ ամբողջ ընթացքում տոկոս եք ստանում ընկերոջ բոլոր վճարումներից։ Պրոմոկոդը գործում է միայն մինչև ընկերոջ առաջին գնումը, իսկ եթե ընկերը եկել է հղումով, պրոմոկոդն այլևս չի փոխում կապը։",
  "Что получает друг?": "Ի՞նչ է ստանում ընկերը",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C միանգամից՝ դրանք դուրս չեն բերվում և այրվում են {1} հետո։",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "Circle-ի առաջին փաթեթի {0}% զեղչը գործում է բաժանորդագրվելուց հետո {1}, քանի որ Circle-ի փաթեթները վաճառվում են միայն բաժանորդագրությամբ։ Մեկ նվեր մեկ հաշվի համար՝ հղումով կամ պրոմոկոդով։",
  "Что считается оплатой?": "Ի՞նչն է համարվում վճարում",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Աստղերով կամ քարտով վճարված բաժանորդագրություններ և Circle-ի փաթեթներ։ Տոկոսը հաշվվում է ընկերոջ վճարած գումարից՝ զեղչով։ Բոնուսային մետաղադրամները, առաջադրանքների պարգևները և վերադարձները չեն հաշվվում։",
  "Какие бывают промокоды?": "Ինչպիսի՞ պրոմոկոդեր կան",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Ձեր գործընկերային պրոմոկոդը ընկերոջը նվեր է տալիս և կապում նրան ձեզ, գործում է միայն մինչև նրա առաջին գնումը։ STEOS-ի պրոմոկոդերը թիմը հրապարակում է STEOS-ի ալիքում և համայնքում՝ դրանք տալիս են Circle իրենց ժամկետով և գործում են բոլորի համար՝ մեկ անգամ մեկ հաշվի համար։",
  "Когда приходят Circle?": "Ե՞րբ են գալիս Circle-ները",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Ընկերոջ վճարումից անմիջապես հետո՝ ուղիղ մնացորդին։ {0} մակարդակում դրանք կարելի է դուրս բերել։",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Ընկերոջ վճարումից անմիջապես հետո՝ ուղիղ մնացորդին։ {0} մակարդակներում դրանք գործում են STEOS-ի ներսում, {1} մակարդակում կարելի է դուրս բերել։",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Ընկերոջ վճարումից անմիջապես հետո՝ ուղիղ մնացորդին։ {0} մակարդակում դրանք գործում են STEOS-ի ներսում, {1} մակարդակում կարելի է դուրս բերել։",
  "Считаются ли друзья с истёкшей привязкой?": "Հաշվվո՞ւմ են ավարտված կապով ընկերները",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Այո։ Նրանց վճարումներից տոկոս այլևս չի գալիս, բայց մակարդակի հաշվում նրանք մնում են՝ մակարդակը հաշվվում է բոլոր ժամանակների գնորդներով։",
  "Кто может выводить?": "Ո՞վ կարող է դուրս բերել",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "{0} մակարդակի գործընկերները (առնվազն {1})՝ ԱՁ-ի, ինքնազբաղվածի կամ օտարերկրյա համարժեքի կարգավիճակով, STEOS ID-ով մուտք գործելուց հետո։ Դուրսբերումը միայն գումարով՝ հաշվին՝ այստեղ կամ {2}-ում։",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Դեսպանները (առնվազն {0})՝ ԱՁ-ի, ինքնազբաղվածի կամ օտարերկրյա համարժեքի կարգավիճակով, STEOS ID-ով մուտք գործելուց հետո։ Դուրսբերումը միայն գումարով՝ հաշվին՝ այստեղ կամ {1}-ում։",
  "Можно ли вывести монеты, заработанные до входа?": "Կարելի՞ է դուրս բերել մուտքից առաջ վաստակած մետաղադրամները",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Այո։ {0} մակարդակում մինչև STEOS ID-ով մուտքը վաստակած Circle-ները սպասում են մնացորդում և մուտքից հետո հասանելի կդառնան դուրսբերման համար։",
  "Какие монеты тратятся первыми?": "Ո՞ր մետաղադրամներն են ծախսվում առաջինը",
  "Можно пригласить самого себя?": "Կարո՞ղ եմ ինքս ինձ հրավիրել",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Ոչ։ Ձեր հաշվից և կրկնակի հաշիվներից կատարված գնումները չեն հաշվվում։",
  "Международный": "Միջազգային",
  "Self-employed, sole trader или компания вне РФ": "Self-employed, sole trader կամ ընկերություն ՌԴ-ից դուրս",
  "Самозанятый в РФ": "Ինքնազբաղված ՌԴ-ում",
  "Налог на профессиональный доход": "Մասնագիտական եկամտի հարկ",
  "ИП в РФ": "ԱՁ ՌԴ-ում",
  "Индивидуальный предприниматель": "Անհատ ձեռնարկատեր",
  "Имя или компания": "Անուն կամ ընկերություն",
  "Как в документах": "Ինչպես փաստաթղթերում",
  "TIN или номер в вашей стране": "TIN կամ ձեր երկրի համարը",
  "ФИО": "Ազգանուն, անուն, հայրանուն",
  "Как в паспорте": "Ինչպես անձնագրում",
  "ИНН": "INN",
  "12 цифр": "12 թվանշան",
  "Название ИП": "ԱՁ-ի անվանումը",
  "Как в выписке": "Ինչպես քաղվածքում",
  "ИНН или ОГРНИП": "INN կամ OGRNIP",
  "От 10 до 15 цифр": "10-ից 15 թվանշան",
  "НДС": "ԱԱՀ",
  "Плательщик НДС": "ԱԱՀ վճարող",
  "Адрес": "Հասցե",
  "КПП": "KPP",
  "ОГРН": "OGRN",
  "Основной офис STEOS": "STEOS-ի գլխավոր գրասենյակ",
  "Платёжный агент STEOS в России": "STEOS-ի վճարային գործակալը Ռուսաստանում",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Այստեղ կբացվի Telegram-ի չաթի ընտրությունը այս տեքստով, հղումով և պրոմոկոդով",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Այստեղ կբացվի Telegram-ի չաթի ընտրությունը՝ բանները կգնա մակագրությամբ և «Բացել STEOS» կոճակով",
  "Ещё <b>{0} {1}</b> до уровня {2}": "Եվս <b>{0} {1}</b>՝ մինչև {2}",
  "Максимальный уровень": "Առավելագույն մակարդակ",
  "До следующего уровня": "Մինչև հաջորդ մակարդակը",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "Ստացեք մինչև&nbsp;{0}% <span>ընկերների գնումներից</span>",
  "Период": "Ժամանակահատված",
  "Кого показать": "Ում ցույց տալ",
  "Перешли": "Անցումներ",
  "Зарегистрировались": "Գրանցումներ",
  "Купили": "Գնել են",
  "Пока нет данных": "Տվյալներ դեռ չկան",
  "{0} к прошлому периоду": "{0}՝ նախորդի համեմատ",
  "за {0} {1}": "{0} {1} ընթացքում",
  "Пока не считаем": "Դեռ չենք հաշվում",
  "нет начислений": "հաշվեգրումներ չկան",
  "Пик <b>{0} C</b>": "Գագաթ <b>{0} C</b>",
  "Начисления по месяцам": "Հաշվեգրումներ ըստ ամիսների",
  "Начисления по дням": "Հաշվեգրումներ ըստ օրերի",
  "Здесь появятся начисления": "Հաշվեգրումներն այստեղ կհայտնվեն",
  "Подписка Про": "Pro բաժանորդագրություն",
  "Купила Circle": "Գնել է Circle",
  "Купил Circle": "Գնել է Circle",
  "Покупатель": "Գնորդ",
  "по промокоду": "պրոմոկոդով",
  "привязка истекла": "կապն ավարտվել է",
  "Это весь список · {0}": "Սա ամբողջ ցանկն է · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "Ընկերը կապված է ձեզ {0}՝ հղումով գրանցվելուց կամ պրոմոկոդով առաջին գնումից։ Պրոմոկոդը գործում է միայն մինչև ընկերոջ առաջին գնումը։",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Ավարտված կապով գնորդները մնում են մակարդակի հաշվում։",
  "Пока никого": "Դեռ ոչ ոք",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Կիսվեք հղումով կամ պրոմոկոդով, առաջին ընկերներն այստեղ կհայտնվեն",
  "Картинка": "Նկար",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Հղումն ու պրոմոկոդն արդեն նկարում են։ Սեղմեք ձևանմուշին՝ մակագրությունը խմբագրելու և հրապարակելու համար։",
  "{0}, открыть и опубликовать": "{0}, բացել և հրապարակել",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Reels-ի, Shorts-ի, TikTok-ի և VK Clips-ի համար։ Պրոմոկոդն ու հղումն արդեն կադրում են, բոտը տեսանյութը կուղարկի չաթ։",
  "{0}, открыть": "{0}, բացել",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Հղումն ու պրոմոկոդն արդեն տեքստում են։ Պատճենեք այն կամ ուղարկեք չաթ։",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "Նկարը կգնա չաթ մակագրությամբ և «Բացել STEOS» կոճակով։ Հարմար է խմբերի, ալիքների և անձնական հաղորդագրությունների համար։",
  "Баннер «{0}» с вашим промокодом": "«{0}» բաններ՝ ձեր պրոմոկոդով",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR պաստառ՝ կոդը տանում է ձեր հղմանը, պրոմոկոդ {0}",
  "Кружки, фото и голос с ИИ": "ԱԲ-ով շրջանաձև տեսանյութեր, լուսանկարներ և ձայն",
  "+{0}&nbsp;C на старт по промокоду": "+{0}&nbsp;C սկզբի համար՝ պրոմոկոդով",
  "Начните по ссылке или промокоду": "Սկսեք հղումով կամ պրոմոկոդով",
  "Наведите камеру телефона": "Ուղղեք հեռախոսի տեսախցիկը",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "A4՝ տպելու համար՝ կանգնակներ, ցուցափեղկեր, այցեքարտեր։ Կոդը տանում է ձեր հղմանը, իսկ դրա տակի պրոմոկոդը կարելի է մուտքագրել առանց տեսախցիկի։",
  "Цвет постера": "Պաստառի գույնը",
  "Прислать PDF в чат": "Ուղարկել PDF չաթ",
  "Вывести": "Դուրս բերել",
  "Заявка на {0} C не подтверждена": "{0} C հայտը հաստատված չէ",
  "Вывод сейчас недоступен": "Դուրսբերումը հիմա հասանելի չէ",
  "Вывод недоступен": "Հասանելի չէ",
  "Деньгами на ваш счёт за {0}": "Գումարը ձեր հաշվին՝ {0}ում",
  "Вывод от {0} C": "Դուրսբերում՝ {0} C-ից",
  "Вывод заработает после входа через STEOS ID": "Դուրսբերումը կաշխատի STEOS ID-ով մուտքից հետո",
  "Войдите через STEOS ID": "Մուտք գործեք STEOS ID-ով",
  "Вывод доступен на уровне {0}, от {1}": "Դուրսբերումը հասանելի է {0} մակարդակում՝ առնվազն {1}",
  "Нужен уровень {0}": "Անհրաժեշտ է {0} մակարդակ",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Դուրսբերումը կբացվի {0} մակարդակում՝ առնվազն {1}։ Առայժմ Circle-ները գործում են STEOS-ի ներսում",
  "Не подключён": "Միացված չէ",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Մուտքը կկապի բոտի հաշիվը STEOS-ի ընդհանուր հաշվի հետ՝ մնացորդը կդառնա ընդհանուր, իսկ դուրսբերումը կաշխատի այստեղ և STEOS ID կայքում։",
  "Выплачено": "Վճարված է",
  "В обработке": "Մշակվում է",
  "Отклонено": "Մերժված է",
  "Не удалось загрузить историю выводов": "Չհաջողվեց բեռնել դուրսբերումների պատմությունը",
  "Выводов пока не было": "Դուրսբերումներ դեռ չեն եղել",
  "за всё время": "ամբողջ ժամանակում",
  "Можно вывести": "Կարելի է դուրս բերել",
  "Тестовая программа: настоящих выплат нет": "Փորձնական ծրագիր՝ իրական վճարումներ չկան",
  "Баланс и выводы есть и на {0}.": "Մնացորդն ու դուրսբերումները կան նաև {0}-ում։",
  "Вопрос о выводе?": "Հարց ունե՞ք դուրսբերման մասին",
  "Напишите в поддержку": "Գրեք աջակցությանը",
  "Поделитесь ссылкой или промокодом": "Կիսվեք հղումով կամ պրոմոկոդով",
  "Друг привязывается к вам на {0}": "Ընկերը կապվում է ձեզ {0}ով",
  "Друг получает подарок": "Ընկերը նվեր է ստանում",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "+{0} C միանգամից և −{1}% Circle-ի առաջին փաթեթի համար՝ բաժանորդագրվելուց հետո",
  "Друг платит в STEOS": "Ընկերը վճարում է STEOS-ում",
  "Подписка и пакеты Circle звёздами или картой": "Բաժանորդագրություն և Circle-ի փաթեթներ՝ աստղերով կամ քարտով",
  "Вам приходит процент": "Դուք տոկոս եք ստանում",
  "{0}% с каждой оплаты, сразу на баланс": "Յուրաքանչյուր վճարումից {0}%՝ անմիջապես մնացորդին",
  "Шаг {0}": "Քայլ {0}",
  "От {0}": "Առնվազն {0}",
  "С первого дня": "Առաջին օրվանից",
  "Если {0} {1} {2}": "Եթե {0} {1} գնի {2}",
  "{0} C за {1}": "{0} C {1}ում",
  "Хватит на {0} в месяц": "Բավական է ամսական {0}ի համար",
  "Кружок стоит {0} C": "Շրջանաձև տեսանյութն արժե {0} C",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "Հաշվում ենք {0} բաժանորդագրությամբ՝ ամսական {1}, այսինքն՝ {2}&nbsp;C։ Տոկոսը գալիս է ընկերոջ յուրաքանչյուր վճարումից կապի {3} ընթացքում։",
  "Уровень считается вместе с вашими {0}.": "Մակարդակը հաշվվում է նաև ձեր առկա գնորդներով՝ {0}։",
  "Калькулятор дохода": "Եկամտի հաշվիչ",
  "Тариф друзей": "Ընկերների սակագինը",
  "Сколько друзей купят подписку": "Քանի ընկեր կգնի բաժանորդագրություն",
  "Вы получите": "Դուք կստանաք",
  "C в месяц": "C ամսական",
  "Проценты, сроки и ограничения": "Տոկոսներ, ժամկետներ և սահմանափակումներ",
  "Circle можно вывести": "Circle-ները կարելի է դուրս բերել",
  "Circle работают внутри STEOS": "Circle-ները գործում են STEOS-ի ներսում",
  "Привязка на {0}": "Կապ՝ {0}ով",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Տոկոսը գալիս է ընկերոջ բոլոր վճարումներից՝ հղումով գրանցվելուց կամ պրոմոկոդով առաջին գնումից",
  "Ссылка главнее промокода": "Հղումը գերակա է պրոմոկոդից",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Եթե ընկերը եկել է հղումով, պրոմոկոդն այլևս չի փոխում կապը",
  "Промокод только до первой покупки": "Պրոմոկոդը՝ միայն մինչև առաջին գնումը",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Ընկերոջ առաջին վճարումից հետո ձեր գործընկերային պրոմոկոդը նրա համար չի գործում",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "{0} C միանգամից, կայրվեն {1} հետո։ {2} Circle-ի առաջին փաթեթի համար՝ բաժանորդագրվելուց հետո {3}",
  "Только уровень {0}": "Միայն {0} մակարդակ",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Առնվազն {0} {1}՝ STEOS ID-ով մուտքից հետո։ ԱՁ-ների, ինքնազբաղվածների և այլ երկրներում նրանց համարժեքների համար",
  "Счёт на компанию STEOS": "Հաշիվ STEOS ընկերությանը",
  "Плательщик появится, когда вывод откроется": "Վճարողը կհայտնվի, երբ դուրսբերումը բացվի",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "ՌԴ-ում՝ {0}, ռուբլով։ Միջազգային կարգավիճակ՝ {1}, եվրոյով",
  "Выплата за {0}": "Վճարում՝ {0}ում",
  "После проверки счёта, от {0} C": "Հաշիվը ստուգելուց հետո՝ առնվազն {0} C",
  "Коротко о главном": "Կարճ՝ գլխավորի մասին",
  "Здесь краткое изложение. Полный текст условий на {0}": "Սա համառոտ շարադրանք է։ Պայմանների ամբողջական տեքստը՝ {0}-ում",
  "Понятно": "Հասկանալի է",
  "У вас {0}.": "Դուք ունեք {0}։",
  "Покупателей пока нет.": "Գնորդներ դեռ չկան։",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Մակարդակը հաշվվում է բոլոր ժամանակների գնորդներով, այդ թվում՝ ավարտված կապով։",
  "Введите сумму": "Մուտքագրեք գումարը",
  "Можно вывести не больше {0} C": "Կարելի է դուրս բերել առավելագույնը {0} C",
  "Заполните реквизиты": "Լրացրեք վավերապայմանները",
  "Загрузите счёт на оплату": "Վերբեռնեք վճարման հաշիվը",
  "Счёт ещё проверяется": "Հաշիվը դեռ ստուգվում է",
  "Выплата в {0} · 1 C = {1} {0}": "Վճարում {0}-ով · 1 C = {1} {0}",
  "Вывести {0} C": "Դուրս բերել {0} C",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Հաշիվը դուրս գրեք {0}-ով։ Կստուգենք, և գումարը կգա {1}ում։",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Հաշիվը դուրս գրեք եվրոյով։ Կստուգենք, և գումարը կգա {0}ում։ Վավերապայմանները կպահպանվեն STEOS ID-ում։",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Հաշիվը դուրս գրեք ռուբլով։ Կստուգենք, և գումարը կգա {0}ում։ Վավերապայմանները կպահպանվեն STEOS ID-ում։",
  "Скопировать {0}": "Պատճենել {0}",
  "юридический адрес": "իրավաբանական հասցեն",
  "Скопировать название компании": "Պատճենել ընկերության անվանումը",
  "Скопировать все реквизиты": "Պատճենել բոլոր վավերապայմանները",
  "Реквизиты для счёта": "Հաշվի վավերապայմաններ",
  "Проверяем счёт…": "Ստուգում ենք հաշիվը…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG կամ PNG, մինչև 10 ՄԲ",
  "Можно вывести {0} C": "Կարելի է դուրս բերել {0} C",
  "Сумма, C": "Գումար, C",
  "Сумма вывода, C": "Դուրսբերման գումար, C",
  "Всё": "Ամբողջը",
  "Придёт на счёт": "Կգա հաշվին",
  "Реквизиты": "Վավերապայմաններ",
  "Счёт на оплату": "Վճարման հաշիվ",
  "Заявка на вывод принята": "Դուրսբերման հայտն ընդունված է",
  "{0} придут за {1} после проверки счёта": "{0}-ը կգա {1}ում՝ հաշիվը ստուգելուց հետո",
  "Ролик принят в обработку": "Տեսանյութն ընդունված է մշակման",
  "Ролик в чате с ботом": "Տեսանյութը բոտի չաթում է",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Բոտը կուղարկի այն պատրաստվելուց հետո։ Առաքումը դեռ հաստատված չէ։",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Պահպանեք այն և տեղադրեք Reels, Shorts, TikTok կամ VK Clips",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Պրոմոկոդն ու հղումն արդեն կադրում են։ Բոտը տեսանյութը կուղարկի չաթ, որտեղից կարող եք պահպանել և տեղադրել։",
  "Прислать в чат": "Ուղարկել չաթ",
  "Текст выделен: скопируйте его вручную": "Տեքստը նշված է․ պատճենեք այն ձեռքով",
  "Баннер готов: отправить его в чат можно из Telegram": "Բանները պատրաստ է՝ այն կարելի է ուղարկել չաթ Telegram-ից",
  "PDF принят в очередь": "PDF-ը հերթում է",
  "PDF в чате": "PDF-ը չաթում է",
  "Не удалось загрузить период. Попробуйте ещё раз": "Չհաջողվեց բեռնել ժամանակահատվածը։ Փորձեք կրկին",
  "Без начислений": "Առանց հաշվեգրումների",
  "Значение выделено: скопируйте его вручную": "Արժեքը նշված է՝ պատճենեք ձեռքով",
  "Реквизиты выделены: скопируйте их вручную": "Վավերապայմանները նշված են՝ պատճենեք ձեռքով",
  "Нужен файл PDF, JPG или PNG": "Անհրաժեշտ է PDF, JPG կամ PNG ֆայլ",
  "Файл {0}, можно до 10 МБ": "Ֆայլը {0} է, թույլատրվում է մինչև 10 ՄԲ",
  "Партнёрство не загрузилось": "Գործընկերությունը չբեռնվեց",
  "Загружаем партнёрскую программу": "Բեռնում ենք գործընկերային ծրագիրը",
  "за неделю": "շաբաթում",
  "за месяц": "ամսում",
  "Для вывода войдите через STEOS ID": "Դուրս բերելու համար մուտք գործեք STEOS ID-ով",
  "Вывод недоступен на текущем уровне": "Ընթացիկ մակարդակում դուրսբերումը հասանելի չէ",
  "Сумма больше доступной": "Գումարը գերազանցում է հասանելին",
  "Сумма меньше минимальной": "Գումարը նվազագույնից պակաս է",
  "Проверьте реквизиты и счёт": "Ստուգեք վավերապայմաններն ու հաշիվը",
  "Счёт ещё не проверен. Загрузите его заново": "Հաշիվը դեռ ստուգված չէ։ Վերբեռնեք այն նորից",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Պատասխան չստացվեց։ Ստուգեք նույն հայտը՝ դրա տվյալներն ու բանալին պահպանված են",
  "Не удалось загрузить список друзей": "Չհաջողվեց բեռնել ընկերների ցանկը",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Չհաջողվեց վերականգնել նախորդ հայտը։ Նորից առաջ գրեք աջակցությանը",
  "Партнёрская программа временно недоступна": "Գործընկերային ծրագիրը ժամանակավորապես հասանելի չէ",
  "Не удалось загрузить следующую страницу": "Չհաջողվեց բեռնել հաջորդ էջը",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Չհաջողվեց պատրաստել բանները։ Փորձեք կրկին",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Բոտը չի կարող պատրաստել նյութը՝ բացեք բոտի չաթը և փորձեք կրկին",
  "Материал сейчас недоступен": "Նյութը հիմա հասանելի չէ",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Ուղարկումը հաստատված չէ։ Սեղմեք կրկին՝ կրկնումը կստուգի նախորդ հարցումը",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Նախորդ ուղարկումը չվերականգնվեց։ Գրեք աջակցությանը",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Նախորդ ուղարկումը հաստատված է։ Սեղմեք կրկին",
  "Отправка не подтверждена": "Ուղարկումը հաստատված չէ",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Հաշիվը ստուգումը չանցավ։ Ընտրեք PDF, JPG կամ PNG՝ մինչև 10 ՄԲ",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Չհաջողվեց անվտանգ պահպանել հայտը։ Ուղարկումը չի կատարվել",
  "Тут откроется инструмент «{0}»": "Այստեղ կբացվի «{0}» գործիքը",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Գերալտը, Ցիրին ու ևս 2 400 ձայն կասեն այն, ինչ գրեք",
  "Снимите себя, и персонаж повторит ваши движения": "Նկարահանեք ինքներդ ձեզ, և կերպարը կկրկնի ձեր շարժումները",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Ընտրեք կերպարը, և մեկ րոպեում մեկ սելֆիից պատրաստ կլինի 3 կադր",
  "Сделать": "Ստեղծել",
  "2 400 голосов, 19 языков": "2 400 ձայն, 19 լեզու",
  "Текст в речь голосом персонажа или своим клоном": "Տեքստը՝ խոսքի, կերպարի ձայնով կամ ձեր կլոնով",
  "Ваш голос за две минуты": "Ձեր ձայնը երկու րոպեում",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Ձայնագրեք նմուշ, և կլոնը կհայտնվի հնչյունավորմամբ բոլոր գործիքներում",
  "Движения": "Շարժումներ",
  "бесплатно": "անվճար",
  "/сек": "/վրկ",
  "готов": "պատրաստ է",
  "Клон · готов": "Կլոն · պատրաստ է",
  "студия: Мой голос": "Իմ ձայնը",
  "Сейчас в тренде": "Հիմա թրենդում",
  "Популярное за неделю": "Շաբաթվա հանրաճանաչները",
  "Геральт скажет ваш текст": "Գերալտը կասի ձեր տեքստը",
  "Вы в знаменитых сценах": "Դուք հայտնի տեսարաններում",
  "3 кадра в любом образе": "3 կադր ցանկացած կերպարով",
  "Готовый сюжет с вами": "Պատրաստի սյուժե ձեզ հետ",
  "Вы повторите любой танец": "Կկրկնեք ցանկացած պար",
  "Ваш снимок в движении": "Ձեր լուսանկարը շարժման մեջ",
  "Фото скажет ваш текст": "Լուսանկարը կասի ձեր տեքստը",
  "Легенды замка": "Ամրոցի լեգենդներ",
  "Город инков": "Ինկերի քաղաք",
  "Неоновый дождь": "Նեոնային անձրև",
  "Утренний бег": "Առավոտյան վազք",
  "Танец теней": "Ստվերների պար",
  "Дорога домой": "Ճանապարհ դեպի տուն",
  "Ночной рейв": "Գիշերային ռեյվ",
  "Снежный пик": "Ձյունոտ գագաթ",
  "Тайны Хейвена": "Հեյվենի գաղտնիքները",
  "Магия рун": "Ռունաների մոգություն",
  "Странные дела": "Տարօրինակ գործեր",
  "Ночной рынок": "Գիշերային շուկա",
  "Ретро-кадр": "Ռետրո կադր",
  "Утро в горах": "Առավոտ լեռներում",
  "Золотой час": "Ոսկե ժամ",
  "Студийный свет": "Ստուդիական լույս",
  "Полароид": "Պոլարոիդ",
  "Киберпанк": "Կիբերպանկ",
  "Старый маяк": "Հին փարոսը",
  "Шторм в заливе": "Փոթորիկ ծոցում",
  "Кинотрейлер": "Կինոթրեյլեր",
  "Город в движении": "Քաղաքը շարժման մեջ",
  "Интервью": "Հարցազրույց",
  "Пустыня на закате": "Անապատը մայրամուտին",
  "Подводный мир": "Ստորջրյա աշխարհ",
  "Кружок «Привет»": "«Բարև» շրջանաձև տեսանյութ",
  "Спокойной ночи": "Բարի գիշեր",
  "Поздравляю": "Շնորհավորում եմ",
  "Скучаю": "Կարոտում եմ",
  "Новости дня": "Օրվա լուրերը",
  "Нос корабля": "Նավի քիթը",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Երկուսը նավի քթին՝ ձեռքերը տարածած քամուն ընդառաջ",
  "Героиня": "Հերոսուհի",
  "роль: Герой": "Հերոս",
  "Уклонение от пуль": "Գնդակներից խուսափում",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Ժամանակը կանգ է առնում, դուք թեքվում եք հետ, և գնդակներն անցնում են կողքով",
  "Танец в закусочной": "Պար ճաշարանում",
  "Пара танцует твист у стойки придорожной закусочной": "Զույգը թվիստ է պարում ճամփեզրի ճաշարանի վաճառասեղանի մոտ",
  "Танцор": "Պարող",
  "Танцовщица": "Պարուհի",
  "Свидание под дождём": "Ժամադրություն անձրևի տակ",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Տեղատարափ, հին տուն և հանդիպում, որին երկուսն էլ տարիներ սպասել են",
  "Он": "Տղա",
  "Она": "Աղջիկ",
  "Речь перед битвой": "Ճառ ճակատամարտից առաջ",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Առաջնորդն անցնում է շարքերի երկայնքով, և զորքը պատասխանում է մռնչյունով",
  "Вождь": "Առաջնորդ",
  "Знаменосец": "Դրոշակակիր",
  "Погоня по крышам": "Հետապնդում տանիքներով",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Ցատկեր գիշերային քաղաքի տանիքների միջև, հետապնդումը հետ չի մնում",
  "Беглец": "Փախստական",
  "Преследователь": "Հետապնդող",
  "Ограбление казино": "Կազինոյի կողոպուտ",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Սմոքինգներով թիմն անցնում է սրահով, սեյֆն արդեն բաց է",
  "Главарь": "Պարագլուխ",
  "Напарник": "Գործընկեր",
  "Напарница": "Գործընկերուհի",
  "Прощание на вокзале": "Հրաժեշտ կայարանում",
  "Поезд трогается, двое держатся за руки до последнего": "Գնացքը շարժվում է, երկուսը մինչև վերջ բռնել են իրար ձեռք",
  "Пассажир": "Ուղևոր",
  "Провожающий": "Ճանապարհողը",
  "Дуэль на закате": "Մենամարտ մայրամուտին",
  "Пустая улица, два стрелка и последние секунды тишины": "Դատարկ փողոց, երկու հրաձիգ և լռության վերջին վայրկյանները",
  "Шериф": "Շերիֆ",
  "Злодей": "Չարագործ",
  "Танец на лестнице": "Պար աստիճաններին",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Վառ կոստյումով չարագործը պարում է փողոցի երկար աստիճաններին",
  "Выход в открытый космос": "Ելք բաց տիեզերք",
  "Астронавт парит над Землёй, трос уходит к станции": "Աստղագնացը սավառնում է Երկրի վրա, պարանը ձգվում է դեպի կայան",
  "Астронавт": "Աստղագնաց",
  "Рассвет над саванной": "Արշալույս սավաննայում",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Ընտանի կենդանուն բարձրացնում են ժայռի վրա, և ամբողջ սավաննան նայում է նրան",
  "Главная роль": "Գլխավոր դեր",
  "Хранитель": "Պահապան",
  "Полёт под луной": "Թռիչք լուսնի տակ",
  "Велосипед отрывается от земли и летит на фоне луны": "Հեծանիվը պոկվում է գետնից և թռչում լուսնի ֆոնին",
  "Финальная поддержка": "Եզրափակիչ վերհանում",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Թափ, ցատկ և վերհանում գլխավերևում՝ դահլիճի ծափերի ներքո",
  "Партнёрша": "Զուգընկերուհի",
  "Партнёр": "Գործընկեր",
  "Песня на холме": "Երգ բլրի վրա",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Ալպյան մարգագետին ու քամի․ դուք պտտվում եք երգելով, իսկ երեխաները վազում են ձեզ ընդառաջ",
  "Бледная кожа": "Գունատ մաշկ",
  "Хвойный лес": "Փշատերև անտառ",
  "Первый взгляд": "Առաջին հայացք",
  "Туман над рекой": "Մառախուղ գետի վրա",
  "Полночь в школе": "Կեսգիշեր դպրոցում",
  "Двое на поляне": "Երկուսը բացատում",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Ճառագայթը ճեղքում է փշերը, և երկուսը քարանում են անտառի բացատի մեջտեղում",
  "Глаза цвета янтаря": "Սաթագույն աչքեր",
  "Бал выпускников": "Շրջանավարտների պարահանդես",
  "Клятва": "Երդում",
  "Игра в грозу": "Խաղ ամպրոպի տակ",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Որոտ անտառի բացատում, և մահակի ամեն հարված հնչում է որոտի պես",
  "Отбивающий": "Հարվածող",
  "Подающая": "Նետողուհի",
  "Ловец": "Բռնող",
  "К вершине сосны": "Դեպի սոճու գագաթը",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Նա նրան մեջքին տանում է սոճու գագաթ, ներքևում մառախուղ է ու ամբողջ անտառը",
  "Примерка брони": "Զրահի փորձարկում",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "Զրահը մաս առ մաս ամրանում է ձեզ վրա, և սաղավարտը փակում է դեմքը",
  "Полёт над городом": "Թռիչք քաղաքի վրայով",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Արագացում գիշերային քաղաքի վրա, շրջադարձ աշտարակների միջև և վայրէջք տանիքին",
  "Пилот брони": "Զրահի օդաչու",
  "Ночь в мастерской": "Գիշեր արհեստանոցում",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Եռակցման կայծեր, գծագրեր օդում և առաջին հաջող գործարկումը",
  "Изобретатель": "Գյուտարար",
  "Последний заряд": "Վերջին լիցքը",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "Զրահի լիցքը վերջանում է, թիմը կանգնում է թիկունք թիկունքի, և ամեն ինչ որոշում է վերջին կրակոցը",
  "Герой в броне": "Զրահավոր հերոս",
  "Качели на паутине": "Ճոճանակ սարդոստայնով",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Ցատկ քիվից, սարդոստայնը ձգվում է, և փողոցը սլանում է ոտքերի տակով",
  "Герой в маске": "Դիմակավոր հերոս",
  "Поцелуй под дождём": "Համբույր անձրևի տակ",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Գիշերային նրբանցք ու տեղատարափ․ նա կախված է գլխիվայր, աղջիկը բարձրացնում է դիմակի եզրը",
  "Крыша на закате": "Տանիք մայրամուտին",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Երկուսը նստած են տանիքի եզրին, ներքևում քաղաքն է աղմկում, արևը մայր է մտնում աշտարակների հետևում",
  "Бой в поезде": "Կռիվ գնացքում",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Կռիվ սլացող գնացքի տանիքին, իսկ հետո հերոսը ձեռքերով կանգնեցնում է վագոնը",
  "Пассажирка": "Ուղևորուհի",
  "Для маркетплейса": "Մարքեթփլեյսի համար",
  "Праздники": "Տոներ",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Շնորհավորանքներ, շրջանաձև տեսանյութեր և գրառումներ տոների համար՝ ապրիլի 1, Զատիկ, մարտի 8",
  "1 апреля": "Ապրիլի 1",
  "Пасха": "Զատիկ",
  "8 марта": "Մարտի 8",
  "Мода": "Նորաձևություն",
  "Аватарки": "Ավատարներ",
  "Фильмы": "Ֆիլմեր",
  "Игры": "Խաղեր",
  "Путешествия": "Ճամփորդություններ",
  "Сумерки": "Մթնշաղ",
  "Железный человек": "Երկաթե մարդ",
  "Человек-паук": "Սարդ-մարդ",
  "Романтика": "Ռոմանտիկա",
  "Погони": "Հետապնդումներ",
  "Всей семьёй": "Ամբողջ ընտանիքով",
  "Особая подборка": "Հատուկ հավաքածու",
  "Особая подборка {0}, {1}": "Հատուկ հավաքածու {0}, {1}",
  "Подборка {0}, {1}": "Հավաքածու {0}, {1}",
  "{0} в подборке": "Հավաքածուում՝ {0}",
  "шаблон|шаблона|шаблонов": "ձևանմուշ",
  "шаблона|шаблонов|шаблонов": "ձևանմուշ",
  "сцена|сцены|сцен": "տեսարան",
  "инструмент|инструмента|инструментов": "գործիք",
  "инструмента|инструментов|инструментов": "գործիք",
  "стиль|стиля|стилей": "ոճ",
  "кадра|кадров|кадров": "կադր",
  "ребёнок|ребёнка|детей": "երեխա",
  "питомец|питомца|питомцев": "ընտանի կենդանի",
  "кружки": "շրջանաձև տեսանյութեր",
  "голос": "ձայն",
  "текст": "տեքստ",
  "для бизнеса": "բիզնեսի համար",
  "Кружок из видео": "Տեսահաղորդագրություն տեսանյութից",
  "Фото в новом стиле": "Լուսանկար նոր ոճով",
  "Фото по описанию": "Լուսանկար ըստ նկարագրության",
  "Семейный портрет": "Ընտանեկան դիմանկար",
  "Видео в новом стиле": "Տեսանյութ նոր ոճով",
  "Видео по описанию": "Տեսանյութ ըստ նկարագրության",
  "Видео другим голосом": "Տեսանյութ այլ ձայնով",
  "Объёмное фото": "Ծավալային լուսանկար",
  "Анимация из серии": "Անիմացիա շարքից",
  "Видео из поездки": "Տեսանյութ ճամփորդությունից",
  "Фильм из фотографий": "Ֆիլմ լուսանկարներից",
  "Изменить видео": "Փոխել տեսանյութը",
  "текст или запись": "տեքստ կամ ձայնագրություն",
  "видео до 1 минуты": "մինչև 1 րոպե տեսանյութ",
  "1 фото и текст": "1 լուսանկար և տեքստ",
  "запись или аудиофайл": "ձայնագրություն կամ աուդիոֆայլ",
  "5 фото лица": "5 դեմքի լուսանկար",
  "1 селфи": "1 սելֆի",
  "описание словами": "նկարագրություն բառերով",
  "фото или описание": "լուսանկար կամ նկարագրություն",
  "старое фото": "հին լուսանկար",
  "чёрно-белое фото": "սև-սպիտակ լուսանկար",
  "фото близких": "մտերիմների լուսանկարներ",
  "от 2 до 9 фото": "2-ից 9 լուսանկար",
  "тема поста": "գրառման թեմա",
  "1 фото или видео": "1 լուսանկար կամ տեսանյութ",
  "ваше фото": "ձեր լուսանկարը",
  "фото тех, кто сыграет": "խաղացողների լուսանկարները",
  "1 видео": "1 տեսանյութ",
  "видео и новый текст": "տեսանյութ և նոր տեքստ",
  "видео с речью": "խոսքով տեսանյութ",
  "текст поздравления": "շնորհավորանքի տեքստ",
  "от 3 фото": "3 և ավելի լուսանկար",
  "фото из поездки": "ճամփորդության լուսանկարներ",
  "семейные фото": "ընտանեկան լուսանկարներ",
  "сценарий": "սցենար",
  "запись голоса": "ձայնի ձայնագրություն",
  "песня": "երգ",
  "файл или ссылка": "ֆայլ կամ հղում",
  "название товара": "ապրանքի անվանում",
  "от 1 до 5 фото товара": "ապրանքի 1-ից 5 լուսանկար",
  "фото товара": "ապրանքի լուսանկարներ",
  "1 видео с вами": "1 տեսանյութ ձեզ հետ",
  "ваше видео": "ձեր տեսանյութը",
  "картинка": "նկար",
  "идея словами": "գաղափար բառերով",
  "ваш промпт": "ձեր պրոմպտը",
  "нужно: 1 фото": "1 լուսանկար",
  "нужно: Текст": "Տեքստ",
  "нужно: Тема": "Թեմա",
  "нужно: Запись": "Ձայնագրություն",
  "формат: Reels": "ռիլսեր",
  "формат: фото": "լուսանկարներ",
  "формат: видео": "տեսանյութեր",
  "формат: кружков": "շրջանաձև տեսանյութեր",
  "формат: шаблонов": "ձևանմուշներ",
  "любое, где хорошо видно лицо": "ցանկացածը, որտեղ դեմքը լավ երևում է",
  "лицо крупно и при хорошем свете": "դեմքը խոշոր և լավ լույսի ներքո",
  "селфи, лицо крупно": "սելֆի, դեմքը խոշոր",
  "снимок оживёт в ролике": "լուսանկարը կկենդանանա տեսահոլովակում",
  "что скажет герой": "ինչ կասի հերոսը",
  "или фото, из которых сделаем слайды": "կամ լուսանկարներ, որոնցից սլայդներ կանենք",
  "Сколько стоит одна генерация": "Որքա՞ն արժե մեկ գեներացիան",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Լուսանկարն արժե {0} C, ֆոտոսեսիան՝ {1} C 3 կադրի համար, տեսանյութը՝ {2} C 5 վայրկյանի համար։ Տեքստային օգնականները, օրինակ՝ ապրանքի նկարագրությունը, արժեն {3} C։ Գինը միշտ երևում է «Ստեղծել» կոճակի վրա մինչև գանձումը։",
  "Что такое C и как пополнить баланс": "Ի՞նչ է C-ն և ինչպես համալրել մնացորդը",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C-ն Circle մետաղադրամներն են, որոնցով վճարում են ստեղծման համար։ Փաթեթներն ու բաժանորդագրությունը գնվում են «Մնացորդ» ներդիրում, որտեղ երևում է նաև մնացորդը։",
  "Какие файлы можно загружать": "Ի՞նչ ֆայլեր կարելի է վերբեռնել",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "Տեսանյութ՝ մինչև 1 րոպե և 15 ՄԲ, լուսանկար՝ JPG կամ PNG, աուդիո՝ MP3, WAV կամ M4A։ Սահմանափակումները ցույց են տրվում հենց գործիքում։",
  "Как сделать дешевле": "Ինչպես անել ավելի էժան",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Եթե աշխատանքի համար Circle-ը չի բավարարում, էկրանի ներքևի կոճակը կբացի «Circle-ը չի բավարարում» էջը, որտեղ կա «Անել ավելի էժան» տարբերակը։ Զեղչը {0}% է, արդյունքի վրա կլինի ջրանիշ։",
  "Где найти готовые результаты": "Որտե՞ղ գտնել պատրաստի արդյունքները",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "«Ավելին» ընտրացանկի «Պատմություն» բաժնում։ Այնտեղ կարելի է ֆայլը կրկին ներբեռնել կամ ուղարկել զրուցարան։",
  "Можно ли использовать свой голос": "Կարո՞ղ եմ օգտագործել իմ ձայնը",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Այո։ Կլոնավորեք ձայնը «Կլոն» ներդիրում, և այն կհայտնվի ձայների ցանկում հնչյունավորմամբ բոլոր գործիքներում։",
  "Фотосессия из {0} в стиле шаблона": "Ֆոտոսեսիա {0}-ից ձևանմուշի ոճով",
  "По желанию: {0}": "Ըստ ցանկության՝ {0}",
  "Тут откроется шаблон «{0}»": "Այստեղ կբացվի «{0}» ձևանմուշը",
  "Только до": "Միայն առաջ",
  "Только после": "Միայն հետո",
  "До: {0} %": "Առաջ՝ {0} %",
  "подборка": "հավաքածու",
  "Все форматы": "Բոլոր ձևաչափերը",
  "Состав": "Կազմ",
  "Вкладки каталога": "Կատալոգի ներդիրներ",
  "Найти подборку": "Գտնել հավաքածու",
  "Найти шаблон": "Գտնել ձևանմուշ",
  "Поиск среди {0}": "Որոնում {0}-ի մեջ",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "«{0}» հարցմամբ հավաքածուներ չկան։ Փնտրեք բոլոր ձևանմուշներում",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "«{1}» հավաքածուում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևանմուշներում",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "«Ձեզ համար» բաժնում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևանմուշներում",
  "В подборке «{0}» нет сцен «{1}»": "«{0}» հավաքածուում «{1}» տեսարաններ չկան",
  "Посмотрите все сцены подборки": "Դիտեք հավաքածուի բոլոր տեսարանները",
  "В подборке «{0}» нет {1}": "«{0}» հավաքածուում {1} չկան",
  "Посмотрите во всех форматах": "Նայեք բոլոր ձևաչափերում",
  "В «Рекомендуем» нет {0}": "«Ձեզ համար» բաժնում {0} չկան",
  "Пока ничего нет": "Առայժմ ոչինչ չկա",
  "Шаблоны этого формата появятся совсем скоро": "Այս ձևաչափի ձևանմուշները շուտով կհայտնվեն",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "{1}-ի մեջ «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևաչափերում",
  "Искать во всех форматах": "Փնտրել բոլոր ձևաչափերում",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "«{0}» հարցմամբ ձևանմուշներ չկան։ Փորձեք այլ բառ",
  "Загружаем ещё": "Բեռնում ենք ևս",
  "Это все шаблоны": "Սրանք բոլոր ձևանմուշներն են",
  "Тренды": "Թրենդներ",
  "Вкладки страницы": "Էջի ներդիրներ",
  "Найти сцену": "Գտնել տեսարան",
  "Найти в подборке": "Գտնել հավաքածուում",
  "Искать во всех сценах": "Փնտրել բոլոր տեսարաններում",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "«{0}» հարցմամբ հավաքածուներ չկան։ Փնտրեք բոլոր տեսարաններում",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "«{1}» հավաքածուում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր տեսարաններում",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "«Թրենդներ» բաժնում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր տեսարաններում",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "«Ձեզ համար» բաժնում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր տեսարաններում",
  "В «Трендах» нет сцен «{0}»": "«Թրենդներ» բաժնում «{0}» տեսարաններ չկան",
  "В «Рекомендуем» нет сцен «{0}»": "«Ձեզ համար» բաժնում «{0}» տեսարաններ չկան",
  "Посмотрите все сцены этой вкладки": "Դիտեք այս ներդիրի բոլոր տեսարանները",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "«{0}» հավաքածուում «{1}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևանմուշներում",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Այս հավաքածուում դեռ նման ձևանմուշներ չկան։ Դիտեք այն ամբողջությամբ կամ ընտրեք այլ ներդիր",
  "Поиск в подборке «{0}»: {1}": "Որոնում «{0}» հավաքածուում՝ {1}",
  "Вкладки подборки": "Հավաքածուի ներդիրներ",
  "Нужно: {0}": "Անհրաժեշտ է՝ {0}",
  "Нужно": "Անհրաժեշտ է",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "«{0}» հարցմամբ ո՛չ գործիքներ կան, ո՛չ ձևանմուշներ։ Փորձեք այլ բառ կամ դիտեք բոլոր գործիքները",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "«{1}» բաժնում «{0}» հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր գործիքներում",
  "Искать во всех": "Փնտրել ամենուր",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "«{0}» հարցմամբ գործիքներ չկան։ Փորձեք այլ բառ",
  "Найти инструмент": "Գտնել գործիք",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Չհաջողվեց բացել գործիքը։ Թարմացրեք կատալոգը և նորից փորձեք։",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "Գործիքը 30 վայրկյանում չբացվեց։ Կրկնեք հարցումը կամ վերադարձեք։",
  "Карточка товара": "Ապրանքի քարտ",
  "Рилс готов": "Ռիլսը պատրաստ է",
  "Кавер не создан": "Քավերը չստեղծվեց",
  "Фотосессия не создана": "Ֆոտոսեսիան չստեղծվեց",
  "Рилс не создан": "Ռիլսը չստեղծվեց",
  "Карточка не создана": "Քարտը չստեղծվեց",
  "Слайды не созданы": "Սլայդները չստեղծվեցին",
  "Запись не обработана": "Ձայնագրությունը չմշակվեց",
  "Коллаж не создан": "Կոլաժը չստեղծվեց",
  "· остаток {0} C": "· մնացորդ՝ {0} C",
  "Вернули {0} C": "Վերադարձրինք {0} C",
  "Списано {0} C со скидкой, {1} водяной знак": "Գանձվեց {0} C զեղչով, {1} ջրանիշ",
  "Списано {0} C": "Գանձվեց {0} C",
  "Рисованному стилю камера не нужна": "Նկարված ոճին տեսախցիկ պետք չէ",
  "У этой камеры объектив встроенный": "Այս տեսախցիկի օբյեկտիվը ներկառուցված է",
  "У этой камеры резкость не настраивается": "Այս տեսախցիկի սրությունը չի կարգավորվում",
  "У этого объектива диафрагма постоянная": "Այս օբյեկտիվի դիֆրագմը հաստատուն է",
  "Встроенный": "Ներկառուցված",
  "Как у камеры": "Ինչպես տեսախցիկինը",
  "до {0} МБ": "մինչև {0} ՄԲ",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "{0} հարցմամբ ո՛չ գործիքներ կան, ո՛չ ձևանմուշներ։ Փորձեք այլ բառ կամ դիտեք բոլոր գործիքները",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "{1} բաժնում {0} հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր գործիքներում",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "{0} հարցմամբ գործիքներ չկան։ Փորձեք այլ բառ",
  "в «Трендах»": "«Թրենդներ» բաժնում",
  "в «Рекомендуем»": "«Ձեզ համար» բաժնում",
  "в подборке {0}": "{0} հավաքածուում",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "{1} {0} հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր տեսարաններում",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "{0} հավաքածուում {1} հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևանմուշներում",
  "сцен {0}": "{0} տեսարաններ",
  "В подборке {0} нет {1}": "{0} հավաքածուում {1} չկան",
  "В подборке {0} нет таких шаблонов": "{0} հավաքածուում նման ձևանմուշներ չկան",
  "Посмотрите её целиком или выберите другую вкладку": "Դիտեք այն ամբողջությամբ կամ ընտրեք այլ ներդիր",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Այս ձևաչափում {0} հարցմամբ ոչինչ չկա։ Փնտրեք բոլոր ձևաչափերում",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "{0} հարցմամբ ձևանմուշներ չկան։ Փորձեք այլ բառ",
  "Здесь нет шаблонов": "Այստեղ ձևանմուշներ չկան",
  "Заказ принят": "Պատվերն ընդունված է",
  "Бот пришлёт результат в чат, в отдельную тему.": "Բոտը արդյունքը կուղարկի զրուցարան՝ առանձին թեմայում։",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Փոխեք հարցումը և նորից փորձեք։ Ստուգված պատվերի Circle-ը չի վերադարձվում։",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Խափանում մեր կողմից։ Circle-ը վերադարձվել է մնացորդին։",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "Գործիքը դեռ միանում է․ պատվերը հերթում է և կսկսվի ինքնուրույն, բոտը արդյունքը կուղարկի զրուցարան։",
  "Сначала отметьте согласие ниже": "Նախ նշեք համաձայնությունը ներքևում",
  "Главное фото: {0}": "Գլխավոր լուսանկար՝ {0}",
  "Загружаем превью…": "Բեռնում ենք նախադիտումը…",
  "Фото не подошло": "Լուսանկարը չհամապատասխանեց",
  "Проверить загрузку": "Ստուգել վերբեռնումը",
  "Опишите, что хотите увидеть": "Նկարագրեք, թե ինչ եք ուզում տեսնել",
  "Не помещается: до {0} знаков": "Չի տեղավորվում՝ մինչև {0} նիշ",
  "{0} во весь экран": "{0} ամբողջ էկրանով",
  "Загрузить картинку": "Վերբեռնել նկար",
  "Ваша": "Ձերը",
  "Убрать картинку": "Հեռացնել նկարը",
  "Этот инструмент пока недоступен": "Այս գործիքը դեռ հասանելի չէ",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Ընտրեք այլ գործիք կամ վերադարձեք ձևանմուշներին։",
  "Вернуться": "Վերադառնալ",
  "Образ": "Կերպար",
  "Ваши селфи": "Ձեր սելֆիները",
  "Три разных кадра: лицо крупно, при хорошем свете": "Երեք տարբեր կադր՝ դեմքը խոշոր, լավ լույսի ներքո",
  "Подтверждаю согласие людей на фото": "Հաստատում եմ լուսանկարներում պատկերված մարդկանց համաձայնությունը",
  "От одного до пяти ракурсов, первый — главный": "Մեկից հինգ տեսանկյուն, առաջինը՝ գլխավորը",
  "Категория": "Կատեգորիա",
  "Набор сцен": "Տեսարանների հավաքածու",
  "Загрузите фото: нужно {0}": "Վերբեռնեք լուսանկարներ՝ անհրաժեշտ է {0}",
  "Выберите: {0}": "Ընտրեք՝ {0}",
  "Не удалось загрузить экран.": "Չհաջողվեց բեռնել էկրանը։",
  "Сцен: {0}": "Տեսարաններ՝ {0}",
  "Заказ создан, следите за ним в «Истории».": "Պատվերը ստեղծվեց, հետևեք դրան «Պատմություն» բաժնում։",
  "Старые": "Հները",
  "Длинные": "Երկարները",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Ոճն արդեն սահմանում է լույսն ու գույնը։ Ընտրեք այլ ոճ, եթե ուզում եք փոխել",
  "{0} открывается только до f/{1}": "{0}-ը բացվում է միայն մինչև f/{1}",
  "Объектив не задаёт светосилу": "Օբյեկտիվը չի սահմանում լուսաուժը",
  "Этот объектив открывается только до f/{0}": "Այս օբյեկտիվը բացվում է միայն մինչև f/{0}",
  "Назад к настройкам": "Վերադառնալ կարգավորումներին",
  "Группа": "Խումբ",
  "Нашли {0}": "Գտնվեց՝ {0}",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Ոչինչ չգտնվեց։ Փորձեք այլ բառ կամ զրոյացրեք խումբը։",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Ընտրությունն անմիջապես կվերադարձնի կարգավորումներին։ Գինը չի փոխվում",
  "Сравнить: было и стало": "Համեմատել՝ առաջ և հետո",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Վերցնում ենք ոճը՝ գույնը, լույսը, մշակումը։ Նկարն ինքնին և դեմքերը չենք տեղափոխում",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Վերցնում ենք տեսարանը՝ ֆոնը, լույսը և մատուցումը։ Նկարն ինքնին և դեմքերը չենք տեղափոխում",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Վերցնում ենք կերպարը՝ հագուստը, դիրքը, ֆոնը և լույսը։ Կադրում դուք կլինեք, նկարի դեմքերը չենք տեղափոխում",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Նկարը չհամապատասխանեց․ չի բացվում, փորձեք JPG կամ PNG",
  "Картинка не подошла: больше {0} МБ": "Նկարը չհամապատասխանեց․ {0} ՄԲ-ից մեծ է",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Նկարը չհամապատասխանեց․ շատ փոքր է, պետք է առնվազն {0} px",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Նկարը չհամապատասխանեց․ այն պարունակում է պաշտպանված կամ արգելված բովանդակություն",
  "Загрузить картинку-референс": "Վերբեռնել հղման նկար",
  "Озвучка текста": "Տեքստի հնչյունավորում",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "Ձայնագրեք 2 վայրկյան խոսք, և բոտը կխոսի ձեր ձայնով",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Պատրաստ ձայները «Ձայներ» բաժնի «Իմը» ներդիրում են",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Ձայնը ձեր ցանկում կլինի այս անունով։ Նկարագրությունը տեսնում եք միայն դուք",
  "Голос появится на вкладке «Мои»": "Ձայնը կհայտնվի «Իմը» ներդիրում",
  "Имя в списке голосов": "Անունը ձայների ցանկում",
  "Уже в «Озвучке»": "Արդեն «Ձայներ»-ում է",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "Ձայնը «Իմը» ներդիրում է՝ «Իմը» պիտակով",
  "Карточка голоса": "Ձայնի քարտ",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Սեղմեք ցանկի ձայնին՝ վերանվանելու կամ հեռացնելու համար",
  "Так голос выглядит в списке": "Ահա թե ինչպես է ձայնը երևում ցանկում",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "Ձայնն արդեն «Իմը» ներդիրում է։ Լսեք, թե ինչպես է այն հնչում",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Ընթանում է ստուգումն ու ուսուցումը, սովորաբար 1–3 րոպե։ Ձայնն ինքը կհայտնվի «Իմը» ներդիրում",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "Ձայնը կանհետանա «Իմը» ներդիրից։ Այն հնարավոր չի լինի վերադարձնել։",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Սովորաբար 1–3 րոպե։ Կարող եք փակել հավելվածը, ձայնը կհայտնվի ցանկում",
  "Можно закрыть приложение": "Կարող եք փակել հավելվածը",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Ձայնագրեք խոսք կամ վերբեռնեք ֆայլեր՝ ընդհանուր 0:02-ից 1:30։ MP3, WAV, M4A, OGG և WEBM, մինչև 10 ֆայլ՝ 20 ՄԲ-ական",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "Ստեղծված է {n} կլոն {n}-ից։ Հեռացրեք մեկը՝ նորն ավելացնելու համար",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Առանց բաժանորդագրության կարող եք ստեղծել {n} կլոն։ Բաժանորդագրությամբ՝ մինչև {0}",
  "До {0} клонов": "Մինչև {0} կլոն",
  "Три клона бесплатно": "Երեք կլոն անվճար",
  "Запишите ещё один, другим тоном или настроением": "Ձայնագրեք ևս մեկը՝ այլ տոնով կամ տրամադրությամբ",
  "С подпиской можно создать до {0}": "Բաժանորդագրությամբ կարող եք ստեղծել մինչև {0}",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Բարև։ Սա ձայնագրություն է իմ ձայնի համար։ Խոսում եմ հանգիստ ու սովորական տեմպով, ինչպես ընկերոջ հետ զրույցում։ Որքան բնական ստացվի հիմա, այնքան ճշգրիտ կհնչի կլոնը։",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Գիտե՞ք՝ որն է ամենատարօրինակը տեսանյութով ճաշ պատրաստելիս։ Նայում ես, թե ինչպես է մարդը մեկ րոպեում սոխ կտրատում, ու մտածում՝ հեշտ է։ Իսկ հետո սոխը չգիտես ինչու ամենուր է, բացի տապակից։",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Երեկ վերջապես դասավորեցի տեղափոխությունից մնացած տուփերը։ Գտա հին նվագարկիչ, արդեն չեղած հեռախոսների երեք լիցքավորիչ և ամառվա ծրագրերով տետր։ Նվագարկիչը դեռ աշխատում է։",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Եղանակն այսօր տարօրինակ է՝ առավոտյան արև էր, կեսօրին անձրև եկավ, իսկ երեկոյան ձյուն են խոստանում։ Ճիշտ ժամանակն է տաք բան եփելու և ոչ մի տեղ չշտապելու։",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Մեկ, երկու, երեք, ստուգում։ Ինձ լավ լսվո՞ւմ է։ Հիմա մի քանի արտահայտություն կկարդամ տարբեր տոնով՝ սկզբում հանգիստ, հետո մի քիչ բարձր, իսկ վերջում շատ կամաց, գրեթե շշուկով։",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Իմ կատուն կարծում է, որ ստեղնաշարը քնելու համար է, իսկ մոնիտորը՝ պոչով ծածկելու։ Այնպես որ, եթե ձայնագրության մեջ ինչ-որ բան խշշա, իմացեք՝ դա թիմային աշխատանք էր։",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Կա պարզ կանոն՝ եթե ինչ-որ բան երրորդ փորձից չի ստացվում, պետք է վեր կենալ, թեյ լցնել ու հինգ րոպեից վերադառնալ։ Սովորաբար դրանից հետո ամեն ինչ ինքն իրեն ստացվում է։",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Սո՛ւս, լսո՞ւմ եք։ Ինչ-որ տեղ մոտակայքում քայլեր են։ Հիմա զգուշորեն կնայենք անկյունից այն կողմ, և եթե այնտեղ ոչ ոք չկա, կվազենք դեպի դուռը։ Միայն թե մի՛ աղմկեք, խնդրում եմ, լուրջ եմ ասում։",
  "Проверено": "Ստուգված է",
  "Создание новых голосов пока недоступно": "Նոր ձայների ստեղծումը դեռ հասանելի չէ",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 վայրկյան խոսք՝ ձայնագրեք այստեղ կամ վերբեռնեք ֆայլեր",
  "Внутренняя ошибка, попробуйте позже": "Ներքին սխալ, փորձեք ավելի ուշ",
  "образцов: {n}": "նմուշ՝ {n}",
  "Образец короче 2 секунд": "Նմուշը 2 վայրկյանից կարճ է",
  "Образец длиннее 1,5 минуты": "Նմուշը 1,5 րոպեից երկար է",
  "Слишком шумная запись — попробуйте в тихом месте": "Ձայնագրությունը շատ աղմկոտ է, փորձեք հանգիստ տեղում",
  "В записи слышно несколько голосов": "Ձայնագրության մեջ մի քանի ձայն է լսվում",
  "Проверка не пройдена: голос не совпадает с образцами": "Ստուգումը չանցավ՝ ձայնը չի համընկնում նմուշներին",
  "Голос не прошёл правила площадки": "Ձայնը չի համապատասխանում հարթակի կանոններին",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Ստուգումը չանցավ՝ ձայնագրեք նմուշ առանց երաժշտության և այլ մարդկանց",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Անհրաժեշտ է ընդհանուր 2 վայրկյանից 1,5 րոպե խոսք",
  "Результат обработки уточняется, загляните чуть позже": "Մշակման արդյունքը ճշտվում է, նայեք մի փոքր ուշ",
  "Удалить голос «{n}»?": "Հեռացնե՞լ «{n}» ձայնը",
  "Навсегда, вместе с образцами": "Ընդմիշտ՝ նմուշների հետ միասին",
  "Например, спокойный, низкий": "Օրինակ՝ հանգիստ, ցածր",
  "Образец": "Նմուշ",
  "Запись или файлы, от 2 секунд": "Ձայնագրություն կամ ֆայլեր՝ 2 վրկ-ից",
  "Имя, описание и согласие": "Անուն, նկարագրություն և համաձայնություն",
  "Проверка и обучение": "Ստուգում և ուսուցում",
  "Модель STEOS · 1–3 минуты": "STEOS մոդել · 1–3 րոպե",
  "Тихое место без эха": "Հանգիստ տեղ՝ առանց արձագանքի",
  "Фоновый шум и музыка попадут в голос": "Ֆոնային աղմուկն ու երաժշտությունը կանցնեն ձայնի մեջ",
  "Хороший микрофон": "Լավ խոսափող",
  "Гарнитура или настольный микрофон лучше встроенного": "Ականջակալը կամ սեղանի խոսափողը ավելի լավն են, քան ներկառուցվածը",
  "То же оборудование": "Նույն սարքավորումը",
  "Не меняйте микрофон между записями": "Ձայնագրությունների միջև խոսափողը մի փոխեք",
  "Под ним голос стоит в списке выбора": "Այս անունով ձայնը կլինի ընտրության ցանկում",
  "Шумоподавление": "Աղմուկի նվազեցում",
  "Включайте, только если в записи слышен шум": "Միացրեք միայն, եթե ձայնագրության մեջ աղմուկ է լսվում",
  "Согласие обязательно": "Համաձայնությունը պարտադիր է",
  "Клонировать можно свой голос или с согласия владельца": "Կարելի է կլոնավորել ձեր ձայնը կամ տիրոջ համաձայնությամբ",
  "Проверка образца": "Նմուշի ստուգում",
  "Один говорящий, без музыки и шума": "Մեկ խոսող՝ առանց երաժշտության և աղմուկի",
  "Обучение": "Ուսուցում",
  "Модель STEOS, обычно 1–3 минуты": "STEOS մոդել, սովորաբար 1–3 րոպե",
  "Голос появится в списке сам": "Ձայնն ինքը կհայտնվի ցանկում",
  "Проверьте запись": "Ստուգեք ձայնագրությունը",
  "Один голос, без музыки и шума на фоне": "Մեկ ձայն՝ առանց երաժշտության և ֆոնային աղմուկի",
  "Длина образца": "Նմուշի տևողությունը",
  "Нужно не меньше 2 секунд чистой речи": "Անհրաժեշտ է առնվազն 2 վայրկյան մաքուր խոսք",
  "Образцы сохранены": "Նմուշները պահպանված են",
  "Можно попробовать снова с теми же файлами": "Կարող եք նորից փորձել նույն ֆայլերով",
  "Не получилось — попробуйте снова": "Չստացվեց, փորձեք նորից",
  "Шаг {a} из {b}": "Քայլ {a}՝ {b}-ից",
  "Персональный": "Անձնական",
  "Дальше": "Հաջորդը",
  "Продолжить": "Շարունակել",
  "К списку голосов": "Ձայների ցանկ",
  "Результат уточняется": "Ճշտվում է",
  "Попробовать снова": "Փորձել նորից",
  "Голос готов": "Ձայնը պատրաստ է",
  "Опишите голос": "Նկարագրեք ձայնը",
  "Например, Мой голос": "Օրինակ՝ Իմ ձայնը",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Սա իմ ձայնն է, կամ ունեմ դրա տիրոջ համաձայնությունը։ Կլոնը չեմ օգտագործի խաբեության, վիրավորանքի և արգելված բովանդակության համար",
  "Загружаем {a} из {b}": "Վերբեռնվում է {a}-ը {b}-ից",
  "Обрабатываем голос": "Մշակում ենք ձայնը",
  "Не получилось создать голос": "Չհաջողվեց ստեղծել ձայնը",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "Մշակման արդյունքը դեռ ճշտվում է։ Կրկնելը դեռ հասանելի չէ։",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Նմուշները պահպանված են, կարող եք նորից փորձել նույն ֆայլերով",
  "Загруженные файлы": "Վերբեռնված ֆայլեր",
  "Читаем аудио…": "Կարդում ենք աուդիոն…",
  "Записать ещё": "Ձայնագրել ևս",
  "Ждём разрешение…": "Սպասում ենք թույլտվության…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Թույլատրեք հասանելիությունը դիտարկչի կարգավորումներում կամ վերբեռնեք ֆայլ",
  "Другой текст": "Այլ տեքստ",
  "Прочитайте вслух": "Կարդացեք բարձրաձայն",
  "Микрофон по умолчанию": "Լռելյայն խոսափող",
  "Минимум": "Նվազագույն",
  "Хорошо": "Լավ",
  "Отлично": "Գերազանց",
  "Набрано {a} из {b}": "Հավաքված է {a}՝ {b}-ից",
  "из {t}": "{t}-ից",
  "всё готово": "պատրաստ է",
  "Файлов с ошибкой: {n}": "Սխալով ֆայլեր՝ {n}",
  "до «{n}» ещё {t}": "«{n}»-ին մնաց {t}",
  "Ещё {t} до минимума": "Նվազագույնին մնաց {t}",
  "Нужно не меньше 2 секунд": "Անհրաժեշտ է առնվազն 2 վայրկյան",
  "Загрузка образцов": "Նմուշների վերբեռնում",
  "Образцы приняты сервером": "Սերվերն ընդունել է նմուշները",
  "Проверка голоса": "Ձայնի ստուգում",
  "Пройдена": "Անցել է",
  "Не запрашивалась": "Չի պահանջվել",
  "Результат проверки пока недоступен": "Ստուգման արդյունքը դեռ հասանելի չէ",
  "Обработка голоса": "Ձայնի մշակում",
  "Не удалось обработать": "Չհաջողվեց մշակել",
  "Выполняется на сервере": "Կատարվում է սերվերում",
  "Очистка шума": "Աղմուկի մաքրում",
  "Пропущено": "Բաց է թողնված",
  "Модель STEOS · один говорящий, без музыки": "STEOS մոդել · մեկ խոսող, առանց երաժշտության",
  "Обучение голоса": "Ձայնի ուսուցում",
  "Файл больше 20 МБ": "Ֆայլը 20 ՄԲ-ից մեծ է",
  "Запись {n}": "Ձայնագրություն {n}",
  "Не удалось прочитать аудио": "Չհաջողվեց կարդալ աուդիոն",
  "Неподдерживаемый формат": "Չաջակցվող ձևաչափ",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Նախորդ ստեղծման արդյունքը դեռ ճշտվում է։ Վերադարձեք նախորդ հարցմանը, որպեսզի երկրորդ կլոն չստեղծեք։",
  "Проверить прошлое создание": "Ստուգել նախորդը",
  "Остановить": "Կանգնեցնել",
  "Ждём доступ": "Սպասում ենք",
  "Ещё раз": "Նորից",
  "Начать запись": "Սկսել ձայնագրումը",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Սեղմեք ցանկի ձայնին՝ քարտը բացելու համար․ լսել, վերանվանել կամ հեռացնել։",
  "Озвучек": "Հնչյունավորում",
  "Знаков": "Նիշ",
  "Образцов": "Նմուշ",
  "Доступна": "Հասանելի է",
  "Недоступна": "Հասանելի չէ",
  "После обучения": "Ուսուցումից հետո",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Ձայնը սովորել է ձեր ձայնագրություններով՝ {n} նմուշ, ընդհանուր {d}",
  "Происхождение: ваши записи. Подробнее": "Ծագումը՝ ձեր ձայնագրությունները։ Մանրամասն",
  "Происхождение": "Ծագում",
  "Ваши записи": "Ձեր ձայնագրությունները",
  "Проверка": "Ստուգում",
  "Не пройдена": "Չի անցել",
  "Идёт": "Ընթացքում է",
  "Переозвучка аудио": "Աուդիոյի կրկնակի հնչյունավորում",
  "Создан": "Ստեղծվել է",
  "Доступ": "Հասանելիություն",
  "Только вы": "Միայն դուք",
  "Голос пока недоступен для выбора. Обновите список.": "Ձայնը դեռ հնարավոր չէ ընտրել։ Թարմացրեք ցանկը։",
  "Голос ещё учится, обычно 1–3 минуты": "Ձայնը դեռ սովորում է, սովորաբար 1–3 րոպե",
  "Коротко о голосе": "Համառոտ ձայնի մասին",
  "О голосе": "Ձայնի մասին",
  "Голос не создан": "Ձայնը չի ստեղծվել",
  "Обработка дольше обычного": "Մշակումը սովորականից երկար է տևում",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Սերվերը դեռ մշակում է ձայնը։ Կարող եք փակել հավելվածը և վերադառնալ ավելի ուշ։",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "{n} ավատարը կմնա առանց ձայնի, շրջանակներում կհնչի լռելյայն ձայնը։",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "{n} ավատարները կմնան առանց ձայնի, շրջանակներում կհնչի լռելյայն ձայնը։",
  "Записать первый голос": "Ձայնագրել առաջին ձայնը",
  "клон|клона|клонов": "կլոն",
  "в месяц": "ամսական",
  "{n} C в месяц": "Ամսական {n} C",
  "{n} своих голосов": "{n} սեփական ձայն",
  "Оформить": "Բաժանորդագրվել",
  "Подписка активна": "Բաժանորդագրությունն ակտիվ է",
  "Подписка «{n}»": "«{n}» բաժանորդագրություն",
  "{n} голосов ваши": "{n} ձայնը ձերն է",
  "Доступно — своих голосов": "Սեփական ձայները հասանելի են",
  "{n} голосов мало?": "{n} ձայնը քի՞չ է",
  "Возьмите {n}": "Վերցրեք {n}",
  "Нужно больше голосов?": "Ավելի շատ ձայնե՞ր են պետք",
  "До {n} с подпиской": "Մինչև {n}՝ բաժանորդագրությամբ",
  "Посмотрите доступные подписки": "Դիտեք հասանելի բաժանորդագրությունները",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "Զբաղված է {a}-ը {b}-ից։ Ձայնագրեք ձայներ տարբեր նպատակների և տրամադրությունների համար",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Առանց բաժանորդագրության կարող եք ստեղծել {a} {w}։ Ցանկացած բաժանորդագրությամբ՝ մինչև {b}",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Առանց բաժանորդագրության՝ {n}։ Սահմանաչափը կախված է ընտրված բաժանորդագրությունից։",
  "Занято {a} из {b}": "Զբաղված է {a}-ը {b}-ից",
  "Без подписки · {n}": "Առանց բաժ. · {n}",
  "С подпиской · {n}": "Բաժ.-ով · {n}",
  "Смотреть все подписки": "Բոլոր բաժանորդագրությունները",
  "Повторить сохранение": "Կրկին պահպանել",
  "Сохраняем изменения…": "Պահպանում ենք փոփոխությունները…",
  "Управление голосами временно недоступно": "Ձայների կառավարումը ժամանակավորապես հասանելի չէ",
  "клон: Мой голос": "Իմ ձայնը",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Սեփական ձայները ժամանակավորապես հասանելի չեն։ Փորձեք թարմացնել ցանկը ավելի ուշ։",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Ձայների ծառայությունը ժամանակավորապես հասանելի չէ։ Փորձեք ավելի ուշ։",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Չհաջողվեց հաստատել ձայների սահմանաչափը։ Թարմացրեք ցանկը ավելի ուշ։",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Չհաջողվեց հաստատել հաշիվը։ Փորձեք ավելի ուշ։",
  "Имя голоса должно содержать от 2 до 32 символов.": "Ձայնի անունը պետք է լինի 2-ից 32 նիշ։",
  "Описание должно содержать не больше 120 символов.": "Նկարագրությունը պետք է լինի ոչ ավելի, քան 120 նիշ։",
  "Добавьте от 1 до 10 подходящих образцов.": "Ավելացրեք 1-ից 10 համապատասխան նմուշ։",
  "Превью этого голоса пока недоступно.": "Այս ձայնի նախադիտումը դեռ հասանելի չէ։",
  "Не удалось загрузить превью. Попробуйте позже.": "Չհաջողվեց բեռնել նախադիտումը։ Փորձեք ավելի ուշ։",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "Ձայնագրությունը շատ աղմկոտ է։ Փորձեք ձայնագրել հանգիստ տեղում։",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Ձայնագրության մեջ մի քանի ձայն է լսվում։ Ավելացրեք մեկ մարդու խոսք։",
  "Голос не прошёл правила площадки.": "Ձայնը չի համապատասխանում հարթակի կանոններին։",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Ծառայությունը չկարողացավ մշակել ձայնը։ Ստուգեք կարգավիճակը կրկնելուց առաջ։",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Համաձայնությունը փոխվել է կամ հասանելի չէ։ Թարմացրեք ցանկը և հաստատեք ընթացիկ տարբերակը կրկնելուց առաջ։",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Վերբեռնումը մերժվել է։ Սեղմեք կոճակը կրկին՝ նմուշը նորից վերբեռնելու համար։",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Վերբեռնումը դեռ հաստատված չէ։ Սեղմեք կոճակը կրկին․ նախ կստուգենք նախորդ վերբեռնումը։",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "Ընտրեք MP3, WAV, M4A, OGG կամ WebM աուդիոֆայլ։",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Չհաջողվեց կարդալ աուդիոն։ Փորձեք կրկին կամ վերբեռնեք ֆայլ։",
  "Пример звучания": "Հնչման օրինակ",
  "Пример звучания пока недоступен": "Հնչման օրինակը դեռ հասանելի չէ",
  "Превью голоса": "Ձայնի նախադիտում",
  "Прослушать пример": "Լսել օրինակը",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "{0}% զեղչ Circle-ի առաջին փաթեթի համար, գործում է բաժանորդագրվելուց հետո {1} {2}",
  "Вы уже пришли по ссылке партнёра": "Դուք արդեն եկել եք գործընկերոջ հղումով",
  "Промокод партнёра уже применён": "Գործընկերոջ պրոմոկոդն արդեն կիրառված է",
  "Тут откроется тема чата, куда бот прислал {0}": "Այստեղ կբացվի զրույցի թեման, որտեղ բոտն ուղարկել է արդյունքը՝ {0}",
  "можно вывести": "կարելի է դուրս բերել",
  "только в STEOS": "միայն STEOS-ում",
  "Не короче {0} знаков": "Առնվազն {0} նիշ",
  "Введите почту и пароль": "Մուտքագրեք էլփոստը և գաղտնաբառը",
  "от {0} знаков": "{0} նիշից",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Մուտք գործելուց հետո Circle-ները ընդհանուր կլինեն բոտի և STEOS հաշվի համար։ Մնացորդն ու դուրսբերումը կան նաև {0}-ում։",
  "Вход или новый аккаунт": "Մուտք կամ նոր հաշիվ",
  "Придумайте пароль": "Ստեղծեք գաղտնաբառ",
  "Ваш пароль": "Ձեր գաղտնաբառը",
  "Принимаю {0} и {1} STEOS": "Ընդունում եմ STEOS-ի {0} և {1}",
  "согласие: условия": "պայմանները",
  "согласие: политику конфиденциальности": "գաղտնիության քաղաքականությունը",
  "Пришлём ссылку на почту": "Հղումը կուղարկենք էլփոստին",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Բացեք նամակի հղումը և {0}-ում սահմանեք նոր գաղտնաբառ։ Հետո մուտք գործեք այստեղ նոր գաղտնաբառով։",
  "Ссылка для нового пароля ушла на {0}": "Նոր գաղտնաբառի հղումն ուղարկվել է {0} հասցեին",
  "Письма нет? Проверьте папку «Спам».": "Նամակ չկա՞։ Ստուգեք «Սպամ» թղթապանակը։",
  "Аккаунт создан и подключён": "Հաշիվը ստեղծվեց և միացվեց",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Բոտի մնացորդն այժմ ընդհանուր է STEOS հաշվի հետ։",
  "Подтвердите почту по ссылке из письма.": "Հաստատեք էլփոստը նամակի հղումով։",
  "Вывод работает здесь и на {0}.": "Դուրսբերումն աշխատում է այստեղ և {0}-ում։",
  "Открыть {0}": "Բացել {0}",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Հղումն ուղարկվել է {0} հասցեին։ Բացեք այն, ապա ստուգեք միացումն այստեղ։",
  "Проверить подключение": "Ստուգել միացումը",
  "Почти готово": "Գրեթե պատրաստ է",
  "Почта ещё не подтверждена": "Էլփոստը դեռ հաստատված չէ",
  "Не удалось проверить. Попробуйте позже": "Չհաջողվեց ստուգել։ Փորձեք ավելի ուշ",
  "Озвучиваю тексты голосом героя": "Տեքստեր հերոսի ձայնով",
  "Любой голос из библиотеки или свой": "Ցանկացած ձայն գրադարանից կամ ձերը",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "STEOS-ում տեքստերը հնչեցնում եմ հերոսների ձայներով։ Փորձեք իմ հղումով, պրոմոկոդ {0}",
  "Пишу текст, персонаж говорит": "Ես գրում եմ, կերպարը խոսում է",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "STEOS-ում կերպարներով շրջանաձև տեսանյութեր եմ անում․ գրում եմ տեքստը, կերպարն ասում է։ Պրոմոկոդ {0}",
  "Свои фото в любом образе": "Ձեր լուսանկարները ցանկացած կերպարով",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Ֆոտոսեսիա ցանկացած կերպարով իմ մի քանի լուսանկարից, առանց ստուդիայի։ STEOS, պրոմոկոդ {0}",
  "Вы в кадре, монтаж и музыка сами": "Դուք կադրում եք, մոնտաժն ու երաժշտությունը՝ ինքնաշխատ",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "STEOS-ում մեկ կոճակով նկարվում եմ ռիլսերում․ սյուժեն, մոնտաժն ու երաժշտությունն արդեն ձևանմուշում են։ Պրոմոկոդ {0}",
  "Персонаж оживает": "Կերպարը կենդանանում է",
  "Говорит вашим текстом": "Խոսում է ձեր տեքստով",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Կերպարը խոսում է իմ տեքստով և իր ձայնով։ Փորձեք STEOS-ը, պրոմոկոդ {0}",
  "Клон голоса за минуту": "Ձայնի կլոն մեկ րոպեում",
  "Запишите от 2 секунд, дальше говорит клон": "Ձայնագրեք 2 վայրկյան, հետո խոսում է կլոնը",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "Իմ ձայնի կլոնը մեկ րոպեում STEOS-ում․ հիմա ամեն ինչ ինքն է հնչեցնում։ Պրոմոկոդ {0}",
  "Старому фото цвет и резкость": "Գույն և հստակություն հին լուսանկարին",
  "Восстановление за минуту": "Վերականգնում մեկ րոպեում",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "STEOS-ում հին լուսանկարներին վերադարձնում եմ գույնն ու հստակությունը։ Պրոմոկոդ {0}",
  "По ссылке или промокоду": "Հղումով կամ պրոմոկոդով",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Նվիրում եմ +{0} C և {1}% զեղչ STEOS-ի առաջին փաթեթի համար իմ {2} պրոմոկոդով",
  "Кавер на любую песню": "Քավեր ցանկացած երգի",
  "Рок, джаз, lo-fi любым голосом": "Ռոք, ջազ, lo-fi ցանկացած ձայնով",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "Քավեր ցանկացած երգի ցանկացած ձայնով STEOS-ում։ Պրոմոկոդ {0}",
  "Мой аватар в любом образе": "Իմ ավատարը ցանկացած կերպարով",
  "Свой аватар из 10 фото": "Ձեր ավատարը 10 լուսանկարից",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Իմ ավատարը ցանկացած կերպարով․ ստեղծված 10 լուսանկարից STEOS-ում։ Պրոմոկոդ {0}",
  "Это я, только говорю вашим текстом": "Սա ես եմ, պարզապես խոսում եմ ձեր տեքստով",
  "сторис: Мой голос": "Իմ ձայնը",
  "на баланс сразу": "անմիջապես մնացորդին",
  "на первый пакет Circle": "Circle-ի առաջին փաթեթի համար",
  "Сторис открыта в Telegram": "Սթորին բացվեց Telegram-ում",
  "Сторис готова": "Սթորին պատրաստ է",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Մնում է սեղմել «Հրապարակել» Telegram-ի խմբագրիչում",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Այստեղ կբացվի Telegram-ի սթորիների խմբագրիչը այս նկարով և ստորագրությամբ",
  "Подпись к сторис": "Սթորիի ստորագրություն",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Telegram-ի սթորիներում հղման կոճակը կա միայն Premium-ով։ Նկարի պրոմոկոդը տեսնում են բոլորը։",
  "Опубликовать в сторис": "Հրապարակել սթորիում",
  "Попробовать STEOS": "Փորձել STEOS-ը",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Չհաջողվեց պատրաստել սթորին։ Փորձեք կրկին",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Սթորին ուղարկում է Telegram-ը․ բացեք Mini App-ը Telegram-ում",
  "Ссылка и промокод уже на картинке": "Հղումն ու պրոմոկոդն արդեն նկարում են",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "Փորձեք STEOS-ը իմ հղումով։ Պրոմոկոդ {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "Փորձեք STEOS-ը իմ հղումով․ +{0} C և {1}% զեղչ առաջին փաթեթի համար։ Պրոմոկոդ {2}",
  "Ссылка": "Հղում",
  "Скопировать ссылку": "Պատճենել հղումը",
  "Друзьям {0} и {1} на первый пакет": "Ընկերներին՝ {0} և {1} առաջին փաթեթի համար",
  "Промокод выделен: скопируйте вручную": "Պրոմոկոդը նշված է․ պատճենեք ձեռքով",
  "Ссылка выделена: скопируйте вручную": "Հղումը նշված է․ պատճենեք ձեռքով",
  "Ссылка скопирована": "Հղումը պատճենվեց",
  "Ссылка выделена: скопируйте её вручную": "Հղումը նշված է․ պատճենեք ձեռքով",
  "Ссылка выделена": "Հղումը նշված է",
  "Вы пришли по приглашению": "Դուք եկել եք հրավերով",
  "{0} C на баланс": "{0} C մնացորդին",
  "Сгорят через {0} {1}": "Կայրվեն {0} {1} հետո",
  "{0} на первый пакет Circle": "{0} Circle-ի առաջին փաթեթի համար",
  "{0} {1} после оформления подписки": "Բաժանորդագրվելուց հետո {0} {1}",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Circle-ի փաթեթները կարելի է գնել ցանկացած բաժանորդագրությամբ։ Զեղչը կսկսի գործել, հենց որ այն ձևակերպեք։",
  "Выбрать тариф": "Ընտրել սակագին",
  "QR-код ссылки приглашения, промокод {0}": "Հրավերի հղման QR կոդ, պրոմոկոդ {0}",
  "Друг наведёт камеру и откроет бота": "Ընկերը կուղղի տեսախցիկը և կբացի բոտը",
  "Цвет карточки": "Քարտի գույնը",
  "Скачать картинку": "Ներբեռնել նկարը",
  "Аврора": "Ավրորա",
  "Закат": "Մայրամուտ",
  "Океан": "Օվկիանոս",
  "Графит": "Գրաֆիտ",
  "Партнёры": "Գործընկերներ",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Գտա բոտ, որտեղ ցանկացած կերպար քո տեքստը կասի տեսահաղորդագրությամբ։ Այնտեղ նաև լուսանկարներ, տեսանյութեր և ցանկացած ձայնով հնչյունավորում կա, ամբողջը հենց Telegram-ում։",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Կիսվում եմ գտածոյով․ STEOS-ը Telegram-ի բոտ է, որտեղ ես պատրաստում եմ տեսահաղորդագրություններ կերպարներով, հնչյունավորում և լուսանկարներ։ Գրում եք տեքստը, ընտրում ձայնը, և մեկ րոպեում պատրաստ է։",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "STEOS-ում վերականգնում եմ մեր հին ընտանեկան լուսանկարները․ մեկ րոպեում վերադարձնում է գույնն ու հստակությունը։ Ուղարկեք ինձ այն նկարները, որոնք ուզում եք թարմացնել, կամ փորձեք ինքներդ։",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Ո՞վ էր ուզում տեսահաղորդագրություն իր սիրելի հերոսի ձայնով։ STEOS-ում գրում ես տեքստը, և խաղի կամ սերիալի կերպարը այն արտասանում է։ Սա Telegram-ի բոտ է։",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Ապրանքի լուսանկարներ, առավելություններով քարտեր և նկարագրություններ մարքեթփլեյսների համար պատրաստում եմ STEOS-ում մի քանի րոպեում՝ առանց ստուդիայի և դիզայների։ Գուցե ձեզ էլ պետք գա։",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Իմ տեսանյութերը հնչյունավորում եմ իմ ձայնի կլոնով, նկարահանվում եմ ռիլսերում պատրաստի ձևանմուշներով և ձայնագրում քավերներ։ Ամբողջը Telegram-ի մեկ STEOS բոտում։",
  "По моей ссылке +{0} C на старт.": "Իմ հղումով՝ +{0} C սկզբի համար։",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Իմ հղումով՝ +{0} C և −{1}% առաջին փաթեթի վրա։",
  "Попробуй сам.": "Փորձիր ինքդ։",
  "Попробуйте сами.": "Փորձեք ինքներդ։",
  "Актёры": "Դերասաններ",
  "Персонажи и актёры": "Կերպարներ և դերասաններ",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "«{q}» հարցմամբ ձայներ չկան։ Փորձեք այլ բառ կամ նայեք հավաքածուները",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Այստեղ դեռ ձայներ չկան։ Նայեք մյուս ներդիրները կամ հավաքածուները",
  "Голос вернётся на экран создания": "Ձայնը կվերադառնա ստեղծման էկրան",
  "После выбора пишите текст для озвучки в чат бота": "Հետո հնչյունավորման տեքստը գրեք բոտի չատում",
  "От Я до А": "Ֆ-ից Ա",
  "Сортировка и фильтры": "Դասավորում և զտիչներ",
  "Сбросить": "Զրոյացնել",
  "Чаще всего выбирают": "Ամենաշատ ընտրվածները",
  "Сначала свежие": "Նախ՝ նորերը",
  "Сначала давние": "Նախ՝ հները",
  "Сначала недорогие": "Նախ՝ էժանները",
  "Сначала короткие ролики": "Նախ՝ կարճ տեսանյութերը",
  "По названию": "Ըստ անվան",
  "По названию, с конца алфавита": "Ըստ անվան՝ այբուբենի վերջից",
  "Вертикальные ролики": "Ուղղահայաց տեսանյութեր",
  "Картинки и посты": "Նկարներ և գրառումներ",
  "Горизонтальные ролики": "Հորիզոնական տեսանյութեր",
  "Видеосообщения Telegram": "Telegram տեսահաղորդագրություններ",
  "Один человек в кадре": "Կադրում մեկ մարդ",
  "Трое и больше": "Երեք և ավելի",
  "С ребёнком": "Երեխայի հետ",
  "С питомцем": "Ընտանի կենդանու հետ",
  "Двое человек в кадре": "Կադրում երկու մարդ",
  "О разделе": "Բաժնի մասին",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Տեքստը վերածում է խոսքի՝ կատալոգի ձայն կամ ձեր կլոնը, ինտոնացիայի և արագության կարգավորումներով։",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Ձեր ձայնի պատճենը՝ ձայնագրությունից․ դրանով կարող եք հնչյունավորել ցանկացած տեքստ։",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "AI-ստուդիա՝ տեսահոլովակներ, լուսանկարներ, շրջանակներ և այլ ձևանմուշներ ձեզ, ձեր հարազատների և կերպարների հետ։",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Հաշվի կրեդիտները (C) և համալրում։ Կրեդիտները ծախսվում են հնչյունավորման և ստուդիայի պատվերների վրա։",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Առաջադրանքներ և պարգևներ՝ կատարեք առաջադրանքներ և ստացեք կրեդիտներ։",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Ձեր բոլոր հնչյունավորումները և ստուդիայի պատվերները՝ լսել, ներբեռնել կամ կրկնել։",
  "Ваш профиль и данные аккаунта.": "Ձեր պրոֆիլը և հաշվի տվյալները։",
  "Настройки приложения: язык, валюта и уведомления.": "Հավելվածի կարգավորումներ՝ լեզու, արժույթ և ծանուցումներ։",
  "Ответы на частые вопросы и связь с поддержкой.": "Պատասխաններ հաճախ տրվող հարցերին և կապ աջակցության հետ։",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Գործընկերային ծրագիր՝ հրավիրեք ընկերներին և ստացեք տոկոս նրանց համալրումներից։",
  "Озвучка больших текстов и сценариев по ролям.": "Երկար տեքստերի և սցենարների հնչյունավորում ըստ դերերի։",
  "Вы или один близкий": "Դուք կամ մեկ հարազատ",
  "Вы и близкий": "Դուք և հարազատը",
  "Товары и места": "Ապրանքներ և վայրեր",
  "Фото товара, блюда или места": "Ապրանքի, ուտեստի կամ վայրի լուսանկար",
  "В избранном": "Ընտրյալներում",
  "Голоса и персонажи, которые вы отметили сердцем": "Ձայներ և կերպարներ, որոնք նշել եք սրտիկով",
  "Нажмите — выбрать голос": "Հպեք՝ ձայն ընտրելու համար",
  "Удерживайте — карточка голоса": "Պահեք՝ ձայնի քարտի համար",
  "Карточка голоса или персонажа": "Ձայնի կամ կերպարի քարտ",
  "Нажмите на голос, чтобы выбрать его": "Հպեք ձայնին՝ այն ընտրելու համար",
  "Удерживайте, чтобы открыть карточку голоса": "Պահեք՝ ձայնի քարտը բացելու համար",
  "Удаление голоса": "Ձայնի ջնջում",
  "Подсказка": "Հուշում",
  "Пример звучания пока недоступен. Попробуйте позже.": "Նմուշը դեռ հասանելի չէ։ Փորձեք ավելի ուշ։",
  "Языков: {0}": "Լեզուներ՝ {0}",
  "Ещё языков: {0}": "Այլ լեզուներ՝ {0}",
  "Ход примера": "Նմուշի ընթացքը",
  "Голос говорит на {0} языках": "Ձայնը խոսում է {0} լեզվով",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Բոլոր ձայները բազմալեզու են և կհնչեցնեն տեքստը համակարգի ցանկացած լեզվով։",
  "Голоса подборки": "Հավաքածուի ձայները",
  "Удерживайте голос, чтобы открыть его": "Պահեք ձայնը՝ այն բացելու համար",
  "Назад к голосу": "Վերադառնալ ձայնին",
  "Оригинал голоса говорил на {0} языке": "Ձայնի բնօրինակը խոսում էր {0}",
  "Происхождение: {0}. Подробнее": "Ծագում՝ {0}։ Մանրամասն",
  "Новый": "Նոր",
  "Официальный": "Պաշտոնական",
  "Актёр": "Դերասան",
  "Удерживайте, чтобы послушать": "Պահեք՝ լսելու համար",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Պահեք ձայնի տողը կամ սեղմեք մկնիկի աջ կոճակով՝ ձայնի քարտը բացելու համար։ Կերպարը բացվում է սովորական հպումով։",
  "Подборка · Голосов: {0}": "Հավաքածու · Ձայներ՝ {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Հասանելի ձայները կհայտնվեն կատալոգում։ Այստեղ կարող եք լսել նմուշը և ընտրել ձայն բոտի համար։",
  "Зажмите голос": "Սեղմած պահեք ձայնը",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Պահեք ձայնի տողը՝ դրա քարտը բացելու համար՝ լսել և դիտել հավաքածուները։ Կարճ հպումն ընտրում է ձայնը։",
  "Нажмите на аватарку": "Հպեք ավատարին",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "Տողի կլոր ավատարը նվագարկում է ձայնի նմուշը։ Կրկին հպեք՝ դադարեցնելու համար։ Տողին հպելն ընտրում է ձայնը։",
  "Сохраняйте в избранное": "Պահեք ընտրյալներում",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Հպեք սրտին ձայնի կամ կերպարի քարտում․ դրանք կհավաքվեն «Ընտրյալներ» հավաքածուում՝ առաջինը «Հավաքածուներում» և «Առաջարկվողում»։ Կրկին հպեք՝ հեռացնելու համար։",
  "Запишите свой голос": "Ձայնագրեք ձեր ձայնը",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 վայրկյան խոսք կամ մի քանի ֆայլ, և երկու րոպեից ձեր ձայնը կհայտնվի բարձրաձայնման բոլոր գործիքներում։ Հպեք «Ձայնագրել» և կարդացեք էկրանի տեքստը։",
  "Читать полностью": "Կարդալ ամբողջությամբ",
  "Голос STEOS": "STEOS ձայն",
  "Назад к персонажу": "Վերադառնալ կերպարին",
  "Назад к списку": "Վերադառնալ ցանկին",
  "Актёр STEOS": "STEOS դերասան",
  "Персонаж STEOS": "STEOS կերպար",
  "Об актёре": "Դերասանի մասին",
  "О персонаже": "Կերպարի մասին",
  "Голоса актёра": "Դերասանի ձայները",
  "Голоса персонажа": "Կերպարի ձայները",
  "шапка: Мой голос": "Իմ ձայնը",
  "Пример голоса «{0}»": "«{0}» ձայնի նմուշ",
  "Ещё языки": "Այլ լեզուներ",
  "Юзеры": "Օգտատերեր",
  "Лайки": "Հավանումներ",
  "Пол": "Սեռ",
  "В каталоге с": "Կատալոգում է",
  "Автор": "Հեղինակ",
  "Откуда": "Որտեղից",
  "Характер": "Բնավորություն",
  "Голосов": "Ձայներ",
  "Мужской": "Արական",
  "Женский": "Իգական",
  "Детский": "Մանկական",
  "Не указан": "Նշված չէ",
  "Голос персонажа": "Կերպարի ձայնը",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "Ընտրեք աջակցվող աուդիոֆայլ՝ մինչև {0} ՄԲ։",
  "пол: Детский": "Մանկական",
  "Состав подборки": "Հավաքածուի կազմը",
  "Закрыть выбор голоса": "Փակել ձայնի ընտրությունը",
  "Не удалось открыть запись для прослушивания.": "Չհաջողվեց բացել ձայնագրությունը լսելու համար։",
  "Использовать готовую запись": "Օգտագործել պատրաստի ձայնագրություն",
  "Подтвердите права на материалы, чтобы взять запись.": "Հաստատեք նյութերի նկատմամբ ձեր իրավունքները՝ ձայնագրությունն օգտագործելու համար։",
  "Работа из доната": "Աշխատանք դոնատից",
  "Модель синтеза": "Սինթեզի մոդել",
  "Новая модель": "Նոր մոդել",
  "Прежняя модель": "Նախկին մոդել",
  "Удерживайте — карточка голоса и модель синтеза": "Սեղմած պահեք՝ ձայնի քարտը և սինթեզի մոդելը",
  "Модель для озвучки в чате": "Չատում հնչյունավորման մոդել",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Նոր մոդել՝ զգացմունքներ և կենդանի ինտոնացիա, հարցեր, շատ լեզուներ, ձայնի կլոններ",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Նախկին մոդել՝ միայն հինգ լեզու, առանց զգացմունքների և հարցական ինտոնացիայի, առանց կլոնների",
  "Активная модель: STEOS Voice": "Ակտիվ մոդել՝ STEOS Voice",
  "Активная модель:": "Ակտիվ մոդել՝",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Նոր մոդել՝ 19 լեզու, բնական հնչողություն՝ կենդանի ինտոնացիաներով, առանց մետաղական ու ռոբոտային երանգի, ձայնի որակյալ կլոնավորում",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Նախկին մոդել՝ միայն 5 լեզու, առանց զգացմունքների և հարցական ինտոնացիայի, առանց ձայնի կլոնների",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "STEOS Voice {0} մոդելում բոլոր ձայները բազմալեզու են և կհնչյունավորեն տեքստը այս լեզուներից ցանկացածով։",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "STEOS Voice {0} մոդելում բոլոր ձայները բազմալեզու են և կհնչյունավորեն տեքստը {1} ցանկացածով։",
  "этих языков": "այս լեզուներից",
  "Языки озвучки": "Հնչյունավորման լեզուներ",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "STEOS Voice {0} մոդելի ցանկացած ձայն կհնչյունավորի տեքստը այս լեզուներից յուրաքանչյուրով",
  "Все голоса": "Բոլոր ձայները",
  "Озвучка текста и переозвучка": "Տեքստի հնչյունավորում և ձայնի փոխարինում",
  "Переозвучка записи": "Ձայնագրության ձայնի փոխարինում",
  "Меняют голос в вашей записи": "Փոխում են ձայնը ձեր ձայնագրությունում",
  "Выберите голос для переозвучки записи": "Ընտրեք ձայն ձայնագրության ձայնը փոխարինելու համար",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Ձայնն ընտրված է — վերադարձեք զրույց և սեղմեք «Շարունակել ձայնի փոխարինումը»"
}
